import { ClosePopup as e, Dialog as t, Loading as n, Notify as r, QBar as i, QBtn as a, QBtnToggle as o, QCard as s, QCardActions as c, QCardSection as l, QCheckbox as u, QChip as d, QDate as f, QDialog as p, QField as m, QIcon as h, QImg as g, QInput as ee, QItem as _, QItemLabel as v, QItemSection as y, QList as b, QMenu as te, QPagination as ne, QPopupProxy as x, QSelect as re, QSeparator as ie, QSpinner as ae, QSpinnerDots as oe, QTab as se, QTabPanel as ce, QTabPanels as le, QTable as S, QTabs as ue, QTd as de, QTh as fe, QTime as pe, QToggle as me, QToolbarTitle as he, QTooltip as ge, Quasar as _e, copyToClipboard as ve, debounce as ye, format as be, useDialogPluginComponent as xe, useQuasar as Se } from "quasar";
import { Fragment as Ce, computed as C, createBlock as w, createCommentVNode as T, createElementBlock as E, createElementVNode as D, createSlots as we, createTextVNode as O, createVNode as k, defineAsyncComponent as Te, defineComponent as A, guardReactiveProps as Ee, h as De, inject as Oe, markRaw as ke, mergeModels as Ae, mergeProps as je, nextTick as Me, normalizeClass as Ne, normalizeProps as Pe, onBeforeMount as Fe, onBeforeUnmount as Ie, onMounted as Le, onUnmounted as Re, openBlock as j, provide as ze, reactive as Be, ref as M, renderList as Ve, renderSlot as He, resolveDynamicComponent as Ue, toDisplayString as N, unref as P, useAttrs as We, useModel as Ge, vShow as Ke, watch as qe, withCtx as F, withDirectives as Je, withKeys as Ye, withModifiers as Xe } from "vue";
import { defaultLocale as Ze, languages as Qe } from "@editor/lib-i18n";
import $e from "quasar/lang/de";
import et from "quasar/lang/en-GB";
import tt from "quasar/lang/it";
import { createI18n as nt, useI18n as rt } from "vue-i18n";
import { containsTransformableQuote as it, transformToGermanQuotes as at } from "@utils/string-utils";
import { NavigationFailureType as ot, isNavigationFailure as st, onBeforeRouteLeave as ct, useRouter as lt } from "vue-router";
import { useMutation as ut, useQuery as dt, useQueryClient as ft } from "@tanstack/vue-query";
//#region \0rolldown/runtime.js
var pt = Object.create, mt = Object.defineProperty, ht = Object.getOwnPropertyDescriptor, gt = Object.getOwnPropertyNames, _t = Object.getPrototypeOf, vt = Object.prototype.hasOwnProperty, yt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), bt = (e, t) => {
	let n = {};
	for (var r in e) mt(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || mt(n, Symbol.toStringTag, { value: "Module" }), n;
}, xt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = gt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !vt.call(e, s) && s !== n && mt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ht(t, s)) || r.enumerable
	});
	return e;
}, St = (e, t, n) => (n = e == null ? {} : pt(_t(e)), xt(t || !e || !e.__esModule ? mt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/bind.js
function Ct(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/utils.js
var { toString: wt } = Object.prototype, { getPrototypeOf: Tt } = Object, { iterator: Et, toStringTag: Dt } = Symbol, Ot = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), kt = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), At = (e, t, n) => e === Object.prototype || !n && t === null, jt = (e) => {
	if (!Object.isExtensible(e)) return !1;
	let t = Object.getOwnPropertyNames(e);
	return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((t) => {
		if (kt(t)) return !1;
		let n = Object.getOwnPropertyDescriptor(e, t);
		return !!n && n.configurable && n.writable === !0;
	});
}, Mt = (e, t) => {
	let n = e, r = [];
	for (; n != null;) {
		if (r.indexOf(n) !== -1) return !1;
		r.push(n);
		let i = Tt(n);
		if (At(n, i, n === e)) return !1;
		if (Ot(n, t)) return !0;
		n = i;
	}
	return !1;
}, Nt = (e, t) => e != null && Mt(e, t) ? e[t] : void 0, Pt = (e) => {
	if (e == null || typeof e != "object" && typeof e != "function") return e;
	let t = Tt(e);
	if (t === null && jt(e)) return e;
	let n = Object.create(null), r = Object.create(null), i = [], a = e;
	for (; a != null && i.indexOf(a) === -1;) {
		i.push(a);
		let o = a === e ? t : Tt(a);
		if (At(a, o, a === e)) break;
		let s = Object.getOwnPropertyNames(a);
		Object.getOwnPropertySymbols && s.push(...Object.getOwnPropertySymbols(a));
		for (let t of s) kt(t) || Ot(r, t) || (n[t] = e[t], r[t] = !0);
		a = o;
	}
	return n;
}, Ft = ((e) => (t) => {
	let n = wt.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), It = (e) => (e = e.toLowerCase(), (t) => Ft(t) === e), Lt = (e) => (t) => typeof t === e, { isArray: Rt } = Array, zt = Lt("undefined");
function Bt(e) {
	return e !== null && !zt(e) && e.constructor !== null && !zt(e.constructor) && Wt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Vt = It("ArrayBuffer");
function Ht(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Vt(e.buffer), t;
}
var Ut = Lt("string"), Wt = Lt("function"), Gt = Lt("number"), Kt = (e) => typeof e == "object" && !!e, qt = (e) => e === !0 || e === !1, Jt = (e) => {
	if (!Kt(e)) return !1;
	let t = Tt(e);
	return (t === null || t === Object.prototype || Tt(t) === null) && !Mt(e, Dt) && !Mt(e, Et);
}, Yt = (e) => {
	if (!Kt(e) || Bt(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, Xt = It("Date"), Zt = It("File"), Qt = (e) => !!(e && e.uri !== void 0), $t = (e) => e && e.getParts !== void 0, en = It("Blob"), tn = It("FileList"), nn = It("Set"), rn = (e) => Kt(e) && Wt(e.pipe);
function an() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var on = an(), sn = on.FormData === void 0 ? void 0 : on.FormData, cn = (e) => {
	if (!e) return !1;
	if (sn && e instanceof sn) return !0;
	let t = Tt(e);
	if (!t || t === Object.prototype || !Wt(e.append)) return !1;
	let n = Ft(e);
	return n === "formdata" || n === "object" && Wt(e.toString) && e.toString() === "[object FormData]";
}, ln = It("URLSearchParams"), [un, dn, fn, pn] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(It), mn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function hn(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), Rt(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (Bt(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function gn(e, t) {
	if (Bt(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var _n = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, vn = (e) => !zt(e) && e !== _n;
function yn(...e) {
	let { caseless: t, skipUndefined: n } = vn(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && gn(r, i) || i, o = Ot(r, a) ? r[a] : void 0;
		Jt(o) && Jt(e) ? r[a] = yn(o, e) : Jt(e) ? r[a] = yn({}, e) : Rt(e) ? r[a] = e.slice() : (!n || !zt(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || Bt(n) || (hn(n, i), typeof n != "object" || Rt(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			jn.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var bn = (e, t, n, { allOwnKeys: r } = {}) => (hn(t, (t, r) => {
	n && Wt(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: Ct(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), xn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Sn = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, Cn = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && Tt(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, wn = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, Tn = (e) => {
	if (!e) return null;
	if (Rt(e)) return e;
	let t = e.length;
	if (!Gt(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, En = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Tt(Uint8Array)), Dn = (e, t) => {
	let n = (e && e[Et]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, On = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, kn = It("HTMLFormElement"), An = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: jn } = Object.prototype, Mn = It("RegExp"), Nn = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	hn(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, Pn = (e) => {
	Nn(e, (t, n) => {
		if (Wt(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (Wt(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, Fn = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return Rt(e) ? r(e) : r(String(e).split(t)), n;
}, In = () => {}, Ln = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Rn(e) {
	return !!(e && Wt(e.append) && e[Dt] === "FormData" && e[Et]);
}
var zn = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (Kt(e)) {
			if (t.has(e)) return;
			if (Bt(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r;
				if (nn(e)) {
					r = [];
					for (let t of e) {
						let e = n(t);
						!zt(e) && r.push(e);
					}
				} else r = Rt(e) ? [] : {}, hn(e, (e, t) => {
					let i = n(e);
					!zt(i) && (r[t] = i);
				});
				return t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, Bn = It("AsyncFunction"), Vn = (e) => e && (Kt(e) || Wt(e)) && Wt(e.then) && Wt(e.catch), Hn = ((e, t) => e ? setImmediate : t ? ((e, t) => (_n.addEventListener("message", ({ source: n, data: r }) => {
	n === _n && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), _n.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Wt(_n.postMessage)), Un = typeof queueMicrotask < "u" ? queueMicrotask.bind(_n) : typeof process < "u" && process.nextTick || Hn, Wn = (e) => e != null && Wt(e[Et]), I = {
	isArray: Rt,
	isArrayBuffer: Vt,
	isBuffer: Bt,
	isFormData: cn,
	isArrayBufferView: Ht,
	isString: Ut,
	isNumber: Gt,
	isBoolean: qt,
	isObject: Kt,
	isPlainObject: Jt,
	isEmptyObject: Yt,
	isReadableStream: un,
	isRequest: dn,
	isResponse: fn,
	isHeaders: pn,
	isUndefined: zt,
	isDate: Xt,
	isFile: Zt,
	isReactNativeBlob: Qt,
	isReactNative: $t,
	isBlob: en,
	isRegExp: Mn,
	isFunction: Wt,
	isStream: rn,
	isURLSearchParams: ln,
	isTypedArray: En,
	isFileList: tn,
	forEach: hn,
	merge: yn,
	extend: bn,
	trim: mn,
	stripBOM: xn,
	inherits: Sn,
	toFlatObject: Cn,
	kindOf: Ft,
	kindOfTest: It,
	endsWith: wn,
	toArray: Tn,
	forEachEntry: Dn,
	matchAll: On,
	isHTMLForm: kn,
	hasOwnProperty: Ot,
	hasOwnProp: Ot,
	hasOwnInPrototypeChain: Mt,
	getSafeProp: Nt,
	toSafeFlatObject: Pt,
	reduceDescriptors: Nn,
	freezeMethods: Pn,
	toObjectSet: Fn,
	toCamelCase: An,
	noop: In,
	toFiniteNumber: Ln,
	findKey: gn,
	global: _n,
	isContextDefined: vn,
	isSpecCompliantForm: Rn,
	toJSONObject: zn,
	isAsyncFn: Bn,
	isThenable: Vn,
	setImmediate: Hn,
	asap: Un,
	isIterable: Wn,
	isSafeIterable: (e) => e != null && Mt(e, Et) && Wn(e)
}, Gn = I.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), Kn = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim();
		let a = I.hasOwnProp(t, n);
		!n || a && I.hasOwnProp(Gn, n) || (n === "set-cookie" ? a ? t[n].push(r) : t[n] = [r] : t[n] = a ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function qn(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Jn = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Yn = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Xn(e, t) {
	return I.isArray(e) ? e.map((e) => Xn(e, t)) : qn(String(e).replace(t, ""));
}
var Zn = (e) => Xn(e, Jn), Qn = (e) => Xn(e, Yn);
function $n(e) {
	let t = Object.create(null);
	return I.forEach(e.toJSON(), (e, n) => {
		t[n] = Qn(e);
	}), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/AxiosHeaders.js
var er = Symbol("internals");
function tr(e) {
	return e && String(e).trim().toLowerCase();
}
function nr(e) {
	return e === !1 || e == null ? e : I.isArray(e) ? e.map(nr) : Zn(String(e));
}
function rr(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var ir = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function ar(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
function or(e) {
	let t = e.length - 1;
	if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34) return e;
	let n = "";
	for (let r = 1; r < t; r++) {
		let i = e.charCodeAt(r);
		if (i === 34 || i === 92 && (r += 1, r >= t)) return e;
		n += e[r];
	}
	return n;
}
function sr(e) {
	let t = Object.create(null), n = String(e), r = 0, i = !1, a = !1;
	function o(e) {
		let i = ar(n.slice(r, e)), a = i.indexOf("=");
		if (a < 1) return;
		let o = ar(i.slice(0, a));
		if (!ir.test(o)) return;
		let s = o.toLowerCase();
		s === "__proto__" || s === "constructor" || s === "prototype" || (t[s] = or(ar(i.slice(a + 1))));
	}
	for (let e = 0; e < n.length; e++) {
		let t = n.charCodeAt(e);
		i ? a ? a = !1 : t === 92 ? a = !0 : t === 34 && (i = !1) : t === 34 ? i = !0 : (t === 44 || t === 59) && (o(e), r = e + 1);
	}
	return o(n.length), t;
}
var cr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function lr(e, t, n, r, i) {
	if (I.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), I.isString(t)) {
		if (I.isString(r)) return t.indexOf(r) !== -1;
		if (I.isRegExp(r)) return r.test(t);
	}
}
function ur(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function dr(e, t) {
	let n = I.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var fr = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = tr(t);
			if (!i) return;
			let a = I.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = nr(e));
		}
		let a = (e, t) => I.forEach(e, (e, n) => i(e, n, t));
		if (I.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (I.isString(e) && (e = e.trim()) && !cr(e)) a(Kn(e), t);
		else if (I.isObject(e) && I.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!I.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], I.hasOwnProp(n, i) ? (r = n[i], n[i] = I.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = tr(e), e) {
			let n = I.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return rr(e);
				if (I.isFunction(t)) return t.call(this, e, n);
				if (I.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = tr(e), e) {
			let n = I.findKey(this, e);
			return !!(n && this[n] !== void 0 && (!t || lr(this, this[n], n, t)));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = tr(e), e) {
				let i = I.findKey(n, e);
				i && (!t || lr(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return I.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || lr(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return I.forEach(this, (r, i) => {
			let a = I.findKey(n, i);
			if (a) {
				t[a] = nr(r), delete t[i];
				return;
			}
			let o = e ? ur(i) : String(i).trim();
			o !== i && delete t[i], t[o] = nr(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return I.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && I.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		let e = this.get("set-cookie");
		return I.isArray(e) ? e : e == null || e === !1 ? [] : [e];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static parseParameters(e) {
		return sr(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[er] = this[er] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = tr(e);
			t[r] || (dr(n, e), t[r] = !0);
		}
		return I.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
fr.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), I.reduceDescriptors(fr.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), I.freezeMethods(fr);
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/AxiosError.js
var pr = "[REDACTED ****]";
function mr(e) {
	if (I.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (I.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function hr(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || I.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof fr && (e = e.toJSON()), r.push(e);
		let t;
		if (I.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			I.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!I.isPlainObject(e) && mr(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? pr : i(a);
				I.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
function gr(e) {
	try {
		return String(e);
	} catch {
		return "";
	}
}
function _r(e) {
	return e.errors.map((e) => {
		try {
			return e && e.message ? gr(e.message) : gr(e);
		} catch {
			return "";
		}
	}).filter(Boolean).join("; ") || e.name || "AggregateError";
}
var L = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = t.message;
		!s && I.isArray(t.errors) && t.errors.length && (s = _r(t));
		let c = new e(s, n || t.code, r, i, a);
		return Object.defineProperty(c, "cause", {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), c.name = t.name, t.status != null && c.status == null && (c.status = t.status), o && Object.assign(c, o), c;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && I.hasOwnProp(e, "redact") ? e.redact : void 0, n = I.isArray(t) && t.length > 0 ? hr(e, t) : I.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
L.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", L.ERR_BAD_OPTION = "ERR_BAD_OPTION", L.ECONNABORTED = "ECONNABORTED", L.ETIMEDOUT = "ETIMEDOUT", L.ECONNREFUSED = "ECONNREFUSED", L.ERR_NETWORK = "ERR_NETWORK", L.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", L.ERR_DEPRECATED = "ERR_DEPRECATED", L.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", L.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", L.ERR_CANCELED = "ERR_CANCELED", L.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", L.ERR_INVALID_URL = "ERR_INVALID_URL", L.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function vr(e) {
	return I.isPlainObject(e) || I.isArray(e);
}
function yr(e) {
	return I.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function br(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = yr(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function xr(e) {
	return I.isArray(e) && !e.some(vr);
}
var Sr = I.toFlatObject(I, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function Cr(e, t, n) {
	if (!I.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData();
	let r = (e, t) => {
		let r = I.getSafeProp(n, e);
		return I.isUndefined(r) ? t : r;
	}, i = r("metaTokens", !0), a = r("visitor") || h, o = r("dots", !1), s = r("indexes", !1), c = r("Blob") || typeof Blob < "u" && Blob, l = r("maxDepth", 100), u = c && I.isSpecCompliantForm(t), d = [];
	if (!I.isFunction(a)) throw TypeError("visitor must be a function");
	function f(e) {
		if (e === null) return "";
		if (I.isDate(e)) return e.toISOString();
		if (I.isBoolean(e)) return e.toString();
		if (!u && I.isBlob(e)) throw new L("Blob is not supported. Use a Buffer instead.");
		if (I.isArrayBuffer(e) || I.isTypedArray(e)) {
			if (u && typeof c == "function") return new c([e]);
			throw new L("Blob is not supported. Use a Buffer instead.", L.ERR_NOT_SUPPORT);
		}
		return e;
	}
	function p(e) {
		if (e > l) throw new L("Object is too deeply nested (" + e + " levels). Max depth: " + l, L.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function m(e, t) {
		if (l === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!I.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), p(t + n.length - 1), r;
		});
	}
	function h(e, n, r) {
		let a = e;
		if (I.isReactNative(t) && I.isReactNativeBlob(e)) return t.append(br(r, n, o), f(e)), !1;
		if (e && !r && typeof e == "object") {
			if (I.endsWith(n, "{}")) n = i ? n : n.slice(0, -2), e = m(e, 1);
			else if (I.isArray(e) && xr(e) || (I.isFileList(e) || I.endsWith(n, "[]")) && (a = I.toArray(e))) return n = yr(n), a.forEach(function(e, r) {
				!(I.isUndefined(e) || e === null) && t.append(s === !0 ? br([n], r, o) : s === null ? n : n + "[]", f(e));
			}), !1;
		}
		return vr(e) ? !0 : (t.append(br(r, n, o), f(e)), !1);
	}
	let g = Object.assign(Sr, {
		defaultVisitor: h,
		convertValue: f,
		isVisitable: vr
	});
	function ee(e, n, r = 0) {
		if (!I.isUndefined(e)) {
			if (p(r), d.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			d.push(e), I.forEach(e, function(e, i) {
				(!(I.isUndefined(e) || e === null) && a.call(t, e, I.isString(i) ? i.trim() : i, n, g)) === !0 && ee(e, n ? n.concat(i) : [i], r + 1);
			}), d.pop();
		}
	}
	if (!I.isObject(e)) throw TypeError("data must be an object");
	return ee(e), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function wr(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function Tr(e, t) {
	this._pairs = [], e && Cr(e, this, t);
}
var Er = Tr.prototype;
Er.append = function(e, t) {
	this._pairs.push([e, t]);
}, Er.toString = function(e) {
	let t = e ? (t) => e.call(this, t, wr) : wr;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/buildURL.js
function Dr(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Or(e, t, n) {
	if (!t) return e;
	e ||= "";
	let r = I.isFunction(n) ? { serialize: n } : n, i = I.getSafeProp(r, "encode") || Dr, a = I.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : I.isURLSearchParams(t) ? t.toString() : new Tr(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/InterceptorManager.js
var kr = Symbol("internals");
function Ar(e) {
	return e ? e.length : 0;
}
function jr(e) {
	if (e) for (; e.length && e[e.length - 1] === null;) e.pop();
}
function Mr(e, t) {
	let n = e.handlers, r = Ar(n);
	n === t.handlersRef ? r !== t.handlersLength && (r ? t.handlerEntries.forEach(function(e, r) {
		n[e.index] !== e.handler && t.handlerEntries.delete(r);
	}) : t.handlerEntries.clear()) : (t.handlersRef = n, t.handlerEntries.clear()), t.handlersLength = r;
}
var Nr = class {
	constructor() {
		this.handlers = [], this[kr] = {
			handlersRef: this.handlers,
			handlersLength: this.handlers.length,
			handlerEntries: /* @__PURE__ */ new Map(),
			iterationDepth: 0,
			nextId: 0
		};
	}
	use(e, t, n) {
		let r = {
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}, i = this[kr];
		this.handlers ??= [], Mr(this, i);
		let a = i.nextId++;
		return this.handlers.push(r), i.handlerEntries.set(a, {
			handler: r,
			index: this.handlers.length - 1
		}), i.handlersLength = this.handlers.length, a;
	}
	eject(e) {
		let t = this[kr];
		Mr(this, t);
		let n = t.handlerEntries.get(e);
		if (n) {
			if (t.handlerEntries.delete(e), this.handlers[n.index] !== n.handler) return;
			this.handlers[n.index] = null, t.iterationDepth || (jr(this.handlers), t.handlersLength = this.handlers.length);
		}
	}
	clear() {
		this.handlers && (this.handlers = [], Mr(this, this[kr]));
	}
	forEach(e) {
		let t = this[kr];
		Mr(this, t), t.iterationDepth++;
		try {
			I.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		} finally {
			--t.iterationDepth || (Mr(this, t), jr(this.handlers), t.handlersLength = Ar(this.handlers));
		}
	}
}, Pr = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, Fr = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Tr,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, Ir = /* @__PURE__ */ bt({
	hasBrowserEnv: () => Lr,
	hasStandardBrowserEnv: () => zr,
	hasStandardBrowserWebWorkerEnv: () => Br,
	navigator: () => Rr,
	origin: () => Vr
}), Lr = typeof window < "u" && typeof document < "u", Rr = typeof navigator == "object" && navigator || void 0, zr = Lr && (!Rr || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(Rr.product) < 0), Br = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Vr = Lr && window.location.href || "http://localhost", Hr = {
	...Ir,
	...Fr
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/toURLEncodedForm.js
function Ur(e, t) {
	return Cr(e, new Hr.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Hr.isNode && I.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/formDataToJSON.js
var Wr = 100;
function Gr(e) {
	if (e > Wr) throw new L("FormData field is too deeply nested (" + e + " levels). Max depth: " + Wr, L.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function Kr(e) {
	let t = [], n = /[^.[\]]+|\[([^.[\]]*)]/g, r;
	for (; (r = n.exec(e)) !== null;) Gr(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function qr(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function Jr(e) {
	function t(e, n, r, i) {
		Gr(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && I.isArray(r) ? r.length : a, s ? (I.hasOwnProp(r, a) ? r[a] = I.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!I.hasOwnProp(r, a) || !I.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && I.isArray(r[a]) && (r[a] = qr(r[a])), !o);
	}
	if (I.isFormData(e) && I.isFunction(e.entries)) {
		let n = {};
		return I.forEachEntry(e, (e, r) => {
			t(Kr(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/methodList.js
var Yr = Object.freeze([
	"get",
	"delete",
	"head",
	"options",
	"post",
	"put",
	"patch",
	"purge",
	"link",
	"unlink",
	"query"
]), Xr = (e, t) => e != null && I.hasOwnProp(e, t) ? e[t] : void 0;
function Zr(e, t, n) {
	if (I.isString(e)) try {
		return (t || JSON.parse)(e), I.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var Qr = {
	transitional: Pr,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = I.isObject(e);
		if (i && I.isHTMLForm(e) && (e = new FormData(e)), I.isFormData(e)) return r ? JSON.stringify(Jr(e)) : e;
		if (I.isArrayBuffer(e) || I.isBuffer(e) || I.isStream(e) || I.isFile(e) || I.isBlob(e) || I.isReadableStream(e)) return e;
		if (I.isArrayBufferView(e)) return e.buffer;
		if (I.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = Xr(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Ur(e, t).toString();
			if ((a = I.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = Xr(this, "env"), r = n && n.FormData;
				return Cr(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), Zr(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = Xr(this, "transitional") || Qr.transitional, n = t && t.forcedJSONParsing, r = Xr(this, "responseType"), i = r === "json";
		if (I.isResponse(e) || I.isReadableStream(e)) return e;
		if (e && I.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, Xr(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? L.from(e, L.ERR_BAD_RESPONSE, this, null, Xr(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Hr.classes.FormData,
		Blob: Hr.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
I.forEach(Yr, (e) => {
	Qr.headers[e] = {};
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/transformData.js
function $r(e, t) {
	let n = this || Qr, r = t || n, i = fr.from(r.headers), a = r.data;
	return I.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/isCancel.js
function ei(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/CanceledError.js
var ti = class extends L {
	constructor(e, t, n) {
		super(e ?? "canceled", L.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/settle.js
function ni(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new L("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? L.ERR_BAD_REQUEST : L.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/normalizeURLForProtocolCheck.js
var ri = /[\t\n\r]/g;
function ii(e) {
	if (typeof e != "string") return e;
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t).replace(ri, "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/parseProtocol.js
function ai(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/speedometer.js
function oi(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/throttle.js
function si(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [
		(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		},
		() => i && o(i),
		(...e) => o(e)
	];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/progressEventReducer.js
var ci = (e, t, n = 3) => {
	let r = 0, i = oi(50, 250);
	return si((n) => {
		if (!n || !I.isNumber(n.loaded)) return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = Math.max(0, o == null ? a : Math.min(a, o)), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, li = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, ui = (e, t = I.asap) => (...n) => t(() => e(...n)), di = Hr.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Hr.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Hr.origin), Hr.navigator && /(msie|trident)/i.test(Hr.navigator.userAgent)) : () => !0, fi = Hr.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		I.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), I.isString(r) && s.push(`path=${r}`), I.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), I.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) try {
				return decodeURIComponent(r.slice(i + 1));
			} catch {
				return r.slice(i + 1);
			}
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/isAbsoluteURL.js
function pi(e) {
	return typeof e == "string" ? /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) : !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/combineURLs.js
function mi(e, t) {
	if (!t) return e;
	let n = e.length;
	for (; n > 0 && e.charCodeAt(n - 1) === 47;) n--;
	return e.slice(0, n) + "/" + t.replace(/^\/+/, "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/buildFullPath.js
var hi = /^https?:(?!\/\/)/i;
function gi(e) {
	return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (e, t, n = "") => `${t}${n}${pr}`);
}
function _i(e) {
	let t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${pr}@`), n = t.indexOf("#"), r = (n === -1 ? t : t.slice(0, n)).replace(/([?&][^=&#]*=)[^&#]*/g, `$1${pr}`);
	return n === -1 ? r : `${r}#${gi(t.slice(n + 1))}`;
}
function vi(e, t) {
	if (typeof e == "string") {
		let n = ii(e);
		if (hi.test(n)) throw new L(`Invalid URL ${JSON.stringify(_i(n))}: missing "//" after protocol`, L.ERR_INVALID_URL, t);
	}
}
function yi(e, t, n, r) {
	vi(t, r);
	let i = !pi(t);
	return e && (i || n === !1) ? (vi(e, r), mi(e, t)) : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/mergeConfig.js
var bi = (e) => e instanceof fr ? { ...e } : e, xi = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(Object.getOwnPropertySymbols(e).filter((t) => Object.getOwnPropertyDescriptor(e, t).enumerable)) : Object.keys(e);
function Si(e, t) {
	e ||= {}, t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return I.isPlainObject(e) && I.isPlainObject(t) ? I.merge.call({ caseless: r }, e, t) : I.isPlainObject(t) ? I.merge({}, t) : I.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!I.isUndefined(t)) return r(e, t, n, i);
		if (!I.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!I.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!I.isUndefined(t)) return r(void 0, t);
		if (!I.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = I.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!I.isUndefined(r)) if (I.isPlainObject(r)) {
			if (I.hasOwnProp(r, n)) return r[n];
		} else return;
		let i = I.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (I.isPlainObject(i) && I.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (I.hasOwnProp(t, a)) return r(n, i);
		if (I.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutErrorMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(bi(e), bi(t), n, !0)
	};
	return I.forEach(xi({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = I.hasOwnProp(l, r) ? l[r] : i, o = a(I.hasOwnProp(e, r) ? e[r] : void 0, I.hasOwnProp(t, r) ? t[r] : void 0, r);
		I.isUndefined(o) && a !== c || (n[r] = o);
	}), I.hasOwnProp(t, "validateStatus") && I.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (I.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/setFormDataHeaders.js
var Ci = ["content-type", "content-length"];
function wi(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t || {}).forEach(([t, n]) => {
		Ci.includes(t.toLowerCase()) && e.set(t, n);
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/resolveConfig.js
var Ti = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function Ei(e) {
	let t = Si({}, e), n = (e) => I.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = fr.from(s), t.url = Or(yi(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let t = I.getSafeProp(c, "username") || "", n = I.getSafeProp(c, "password") || "";
		try {
			s.set("Authorization", "Basic " + btoa(t + ":" + (n ? Ti(n) : "")));
		} catch (t) {
			throw L.from(t, L.ERR_BAD_OPTION_VALUE, e);
		}
	}
	if (I.isFormData(r)) {
		let e = I.getSafeProp(r, "getHeaders");
		Hr.hasStandardBrowserEnv || Hr.hasStandardBrowserWebWorkerEnv || I.isReactNative(r) ? s.setContentType(void 0) : I.isFunction(e) && wi(s, e.call(r), n("formDataHeaderPolicy"));
	}
	if (Hr.hasStandardBrowserEnv && (I.isFunction(i) && (i = i(t)), i === !0 || i == null && di(t.url))) {
		let e = a && o && fi.read(o);
		e && s.set(a, e);
	}
	return t;
}
var Di = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = Ei(e), i = r.data, a = fr.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p, m;
		function h() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let g = new XMLHttpRequest();
		g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
		function ee(i) {
			if (!g) return;
			if (g.status === 0 && (ai(ii(r.url)) || ai(Hr.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
				n(new L("Request aborted", L.ECONNABORTED, e, g)), h(), g = null;
				return;
			}
			try {
				i ? m && m(i) : p && p();
			} catch (e) {
				setTimeout(() => {
					throw e;
				});
			}
			if (!g) return;
			let a = fr.from("getAllResponseHeaders" in g && g.getAllResponseHeaders());
			ni(function(e) {
				t(e), h();
			}, function(e) {
				n(e), h();
			}, {
				data: !o || o === "text" || o === "json" ? g.responseText : g.response,
				status: g.status,
				statusText: g.statusText,
				headers: a,
				config: e,
				request: g
			}), g = null;
		}
		"onloadend" in g ? g.onloadend = ee : g.onreadystatechange = function() {
			!g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.startsWith("file:")) || setTimeout(ee);
		}, g.onabort = function() {
			g &&= (n(new L("Request aborted", L.ECONNABORTED, e, g)), h(), null);
		}, g.onerror = function(t) {
			let r = new L(t && t.message ? t.message : "Network Error", L.ERR_NETWORK, e, g);
			r.event = t || null, n(r), h(), g = null;
		}, g.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || Pr;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new L(t, i.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED, e, g)), h(), g = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in g && I.forEach($n(a), function(e, t) {
			g.setRequestHeader(t, e);
		}), I.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), o && o !== "json" && (g.responseType = r.responseType), c && ([d, p, m] = ci(c, !0), g.addEventListener("progress", d)), s && g.upload && ([u, f] = ci(s), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			g &&= (n(!t || t.type ? new ti(null, e, g) : t), g.abort(), h(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let _ = ai(r.url);
		if (_ && !Hr.protocols.includes(_)) {
			n(new L("Unsupported protocol " + _ + ":", L.ERR_BAD_REQUEST, e)), h();
			return;
		}
		g.send(i || null);
	});
}, Oi = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof L ? t : new ti(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new L(`timeout of ${t}ms exceeded`, L.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => {
		if (!r) {
			if (e.aborted) {
				i.call(e);
				return;
			}
			e.addEventListener("abort", i, { once: !0 });
		}
	});
	let { signal: s } = n;
	return s.unsubscribe = () => I.asap(o), s;
}, ki = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, Ai = async function* (e, t) {
	for await (let n of ji(e)) yield* ki(n, t);
}, ji = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, Mi = (e, t, n, r) => {
	let i = Ai(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, Ni = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Pi = (e, t, n) => t + 2 < n && Ni(e.charCodeAt(t + 1)) && Ni(e.charCodeAt(t + 2)), Fi = (e) => e <= 57 ? e - 48 : (e & 223) - 55, Ii = (e) => e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || e === 43 || e === 47 || e === 45 || e === 95, Li = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, Ri = (e) => {
	let t = Math.floor(e / 4), n = e % 4;
	return t * 3 + (n === 2 ? 1 : n === 3 ? 2 : 0);
}, zi = (e) => {
	let t = e.length, n = 0;
	return t > 0 && e.charCodeAt(t - 1) === 61 && (n++, t > 1 && e.charCodeAt(t - 2) === 61 && n++), Math.floor((t - n) * 3 / 4);
}, Bi = (e) => {
	let t = e.length, n = 0, r = 0, i = !1;
	for (let a = 0; a < t; a++) {
		let o = e.charCodeAt(a);
		if (o === 37 && Pi(e, a, t) && (o = Fi(e.charCodeAt(a + 1)) * 16 + Fi(e.charCodeAt(a + 2)), a += 2), !Li(o)) {
			if (o === 61) {
				r++;
				continue;
			}
			if (!Ii(o) || r > 0) {
				i = !0;
				continue;
			}
			n++;
		}
	}
	return i || r > 2 || r > 0 && (n + r) % 4 != 0 || n % 4 == 1 ? zi(e) : Ri(n);
}, Vi = (e, t) => {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let n = e.indexOf(",");
	if (n < 0) return 0;
	let r = e.slice(5, n), i = e.slice(n + 1);
	if (/;base64/i.test(r)) return t(i);
	let a = 0;
	for (let e = 0, t = i.length; e < t; e++) {
		let n = i.charCodeAt(e);
		if (n === 37 && Pi(i, e, t)) a += 1, e += 2;
		else if (n < 128) a += 1;
		else if (n < 2048) a += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = i.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (a += 4, e++) : a += 3;
		} else a += 3;
	}
	return a;
};
function Hi(e) {
	let t = typeof e == "string" ? e.indexOf("#") : -1;
	return Vi(t === -1 ? e : e.slice(0, t), Bi);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/env/data.js
var Ui = "1.20.0", Wi = 64 * 1024, Gi = {
	cache: "default",
	redirect: "follow",
	referrer: "about:client",
	referrerPolicy: "",
	mode: "cors",
	integrity: "",
	keepalive: !1,
	priority: "auto",
	window: null
}, { isFunction: Ki } = I, qi = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Ji = (e) => {
	if (!I.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, Yi = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, Xi = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, Zi = (e) => {
	let t = I.global !== void 0 && I.global !== null ? I.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = I.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? Ki(i) : typeof fetch == "function", c = Ki(a), l = Ki(o);
	if (!s) return !1;
	let u = s && Ki(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && Yi(() => {
		let e = !1, t = new a(Hr.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && Yi(() => I.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new L(`Response type '${e}' is not supported`, L.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (I.isBlob(e)) return e.size;
		if (I.isSpecCompliantForm(e)) return (await new a(Hr.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (I.isArrayBufferView(e) || I.isArrayBuffer(e)) return e.byteLength;
		if (I.isURLSearchParams(e) && (e += ""), I.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => I.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: ee, onDownloadProgress: _, onUploadProgress: v, responseType: y, headers: b, withCredentials: te = "same-origin", fetchOptions: ne, maxContentLength: x, maxBodyLength: re, maxRedirects: ie } = Ei(e), ae = I.isNumber(x) && x > -1, oe = I.isNumber(re) && re > -1, se = (t) => I.hasOwnProp(e, t) ? e[t] : void 0, ce = i || fetch;
		y = y ? (y + "").toLowerCase() : "text";
		let le = Oi([l, d && d.toAbortSignal()], ee), S = null, ue = le && le.unsubscribe && (() => {
			le.unsubscribe();
		}), de, fe = null, pe = () => new L("Request body larger than maxBodyLength limit", L.ERR_BAD_REQUEST, e, S);
		try {
			let i, l = se("auth");
			if (l && (i = {
				username: I.getSafeProp(l, "username") || "",
				password: I.getSafeProp(l, "password") || ""
			}), Xi(t)) {
				let e = new URL(t, Hr.origin);
				!i && (e.username || e.password) && (i = {
					username: Ji(e.username),
					password: Ji(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (b.delete("authorization"), b.set("Authorization", "Basic " + btoa(qi((i.username || "") + ":" + (i.password || ""))))), ae && typeof t == "string" && t.startsWith("data:") && Hi(t) > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			if (oe && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (de = e, e > re)) throw pe();
			}
			let d = oe && (I.isReadableStream(s) || I.isStream(s)), ee = (e, t, n) => Mi(e, Wi, (e) => {
				if (oe && e > re) throw fe = pe();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (v || d)) {
				if (de ??= await g(b, s), de !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (I.isFormData(s) && (n = e.headers.get("content-type")) && b.setContentType(n), e.body) {
						let [t, n] = v && li(de, ci(ui(v))) || [];
						s = ee(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = ee(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new L("Stream request bodies are not supported by the current fetch implementation", L.ERR_NOT_SUPPORT, e, S);
			I.isString(te) || (te = te ? "include" : "omit");
			let me = c && "credentials" in a.prototype;
			if (I.isFormData(s)) {
				let e = b.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && b.delete("content-type");
			}
			b.set("User-Agent", "axios/" + Ui, !1);
			let he = ne == null ? ne : Object.assign(Object.create(null), ne);
			he && (delete he.body, delete he.headers, delete he.method, delete he.signal, delete he.duplex, delete he.credentials);
			let ge = Object.assign(Object.create(null), he, {
				signal: le,
				method: n.toUpperCase(),
				headers: $n(b.normalize()),
				body: s,
				duplex: "half",
				credentials: me ? te : void 0
			});
			c && (I.forEach(Gi, (e, t) => {
				ge[t] === void 0 && (ge[t] = e);
			}), ge.signal === void 0 && (ge.signal = null), ge.body === void 0 && (ge.body = null)), ie === 0 && (ge.redirect = "manual", he && (he.redirect = "manual")), S = c && new a(t, ge);
			let _e = await (c ? ce(S, he) : ce(t, ge)), ve = fr.from(_e.headers);
			if (ae) {
				let t = I.toFiniteNumber(ve.getContentLength());
				if (t != null && t > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			}
			let ye = p && (y === "stream" || y === "response");
			if (p && _e.body && (_ || ae || ye && ue)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = _e[e];
				});
				let n = I.toFiniteNumber(ve.getContentLength()), [r, i] = _ && li(n, ci(ui(_), !0)) || [], a = 0;
				_e = new o(Mi(_e.body, Wi, (t) => {
					if (ae && (a = t, a > x)) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
					r && r(t);
				}, () => {
					i && i(), ue && ue();
				}), t);
			}
			y ||= "text";
			let be = await m[I.findKey(m, y) || "text"](_e, e);
			if (ae && !p && !ye) {
				let t;
				if (be != null && (typeof be.byteLength == "number" ? t = be.byteLength : typeof be.size == "number" ? t = be.size : typeof be == "string" && (t = typeof r == "function" ? new r().encode(be).byteLength : be.length)), typeof t == "number" && t > x) throw new L("maxContentLength size of " + x + " exceeded", L.ERR_BAD_RESPONSE, e, S);
			}
			return !ye && ue && ue(), await new Promise((t, n) => {
				ni(t, n, {
					data: be,
					headers: fr.from(_e.headers),
					status: _e.status,
					statusText: _e.statusText,
					config: e,
					request: S
				});
			});
		} catch (t) {
			if (ue && ue(), le && le.aborted && le.reason instanceof L) {
				let n = le.reason;
				throw n.config = e, S && (n.request = S), t !== n && Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			if (fe) throw S && !fe.request && (fe.request = S), fe;
			if (t instanceof L) throw S && !t.request && (t.request = S), t;
			if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
				let n = new L("Network Error", L.ERR_NETWORK, e, S, t && t.response);
				throw Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t.cause || t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			throw L.from(t, t && t.code, e, S, t && t.response);
		}
	};
}, Qi = /* @__PURE__ */ new Map(), $i = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = Qi;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : Zi(t)), l = c;
	return c;
};
$i();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/adapters/adapters.js
var ea = {
	http: null,
	xhr: Di,
	fetch: { get: $i }
};
I.forEach(ea, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var ta = (e) => `- ${e}`, na = (e) => I.isFunction(e) || e === null || e === !1;
function ra(e, t) {
	e = I.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !na(r) && (i = ea[(n = String(r)).toLowerCase()], i === void 0)) throw new L(`Unknown adapter '${n}'`);
		if (i && (I.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new L("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(ta).join("\n") : " " + ta(e[0]) : "as no adapter specified"), L.ERR_NOT_SUPPORT);
	}
	return i;
}
var ia = {
	getAdapter: ra,
	adapters: ea
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/core/dispatchRequest.js
function aa(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ti(null, e);
}
function oa(e) {
	let t = I.toSafeFlatObject(e);
	return aa(t), t.headers = fr.from(I.getSafeProp(t, "headers")), t.data = $r.call(t, t.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), ia.getAdapter(t.adapter || Qr.adapter, t)(t).then(function(e) {
		aa(t), t.response = e;
		try {
			e.data = $r.call(t, t.transformResponse, e);
		} finally {
			delete t.response;
		}
		return e.headers = fr.from(e.headers), e;
	}, function(e) {
		if (!ei(e) && (aa(t), e && e.response)) {
			t.response = e.response;
			try {
				e.response.data = $r.call(t, t.transformResponse, e.response);
			} finally {
				delete t.response;
			}
			e.response.headers = fr.from(e.response.headers);
		}
		return Promise.reject(e);
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/validator.js
var sa = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	sa[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var ca = {};
sa.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + Ui + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new L(r(i, " has been removed" + (t ? " in " + t : "")), L.ERR_DEPRECATED);
		return t && !ca[i] && (ca[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(n, i, a) : !0;
	};
}, sa.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function la(e, t, n) {
	if (typeof e != "object" || !e) throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new L("option " + a + " must be " + n, L.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new L("Unknown option " + a, L.ERR_BAD_OPTION);
	}
}
var ua = {
	assertOptions: la,
	validators: sa
}, da = ua.validators, fa = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new Nr(),
			response: new Nr()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) try {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = t.stack, r = "";
				if (typeof n == "string") {
					let e = n.indexOf("\n");
					r = e === -1 ? "" : n.slice(e + 1);
				}
				if (!e.stack) e.stack = r;
				else if (r) {
					let t = r.indexOf("\n"), n = t === -1 ? -1 : r.indexOf("\n", t + 1), i = n === -1 ? "" : r.slice(n + 1);
					String(e.stack).endsWith(i) || (e.stack += "\n" + r);
				}
			} catch {}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = Si(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && ua.assertOptions(n, {
			silentJSONParsing: da.transitional(da.boolean),
			forcedJSONParsing: da.transitional(da.boolean),
			clarifyTimeoutError: da.transitional(da.boolean),
			legacyInterceptorReqResOrdering: da.transitional(da.boolean),
			advertiseZstdAcceptEncoding: da.transitional(da.boolean),
			validateStatusUndefinedResolves: da.transitional(da.boolean)
		}, !1), r != null && (I.isFunction(r) ? t.paramsSerializer = { serialize: r } : ua.assertOptions(r, {
			encode: da.function,
			serialize: da.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), ua.assertOptions(t, {
			baseUrl: da.spelling("baseURL"),
			withXsrfToken: da.spelling("withXSRFToken")
		}, !0), t.method = (I.getSafeProp(t, "method") || I.getSafeProp(this.defaults, "method") || "get").toLowerCase();
		let a = i && I.merge(i.common, i[t.method]);
		i && I.forEach(Yr.concat("common"), (e) => {
			delete i[e];
		}), t.headers = fr.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || Pr;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [oa.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e ? e(f) : f;
			} catch (e) {
				if (!t) {
					l = Promise.reject(e);
					break;
				}
				try {
					let n = t.call(this, e);
					I.isThenable(n) && (l = Promise.resolve(n).then(() => oa.call(this, f)));
				} catch (e) {
					l = Promise.reject(e);
				}
				break;
			}
		}
		if (!l) try {
			l = oa.call(this, f);
		} catch (e) {
			l = Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = Si(this.defaults, e), Or(yi(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
I.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	fa.prototype[e] = function(t, n) {
		return this.request(Si(n || {}, {
			method: e,
			url: t,
			data: n && I.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), I.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(Si(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	fa.prototype[e] = t(), e !== "query" && (fa.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/cancel/CancelToken.js
var pa = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new ti(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/spread.js
function ma(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/isAxiosError.js
function ha(e) {
	return I.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/helpers/HttpStatusCode.js
var ga = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	ContentTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	UnprocessableContent: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerReturnsAnUnknownError: 520,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(ga).forEach(([e, t]) => {
	ga[t] === void 0 && (ga[t] = e);
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/lib/axios.js
function _a(e) {
	let t = new fa(e), n = Ct(fa.prototype.request, t);
	return I.extend(n, fa.prototype, t, { allOwnKeys: !0 }), I.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return _a(Si(e, t));
	}, n;
}
var R = _a(Qr);
R.Axios = fa, R.CanceledError = ti, R.CancelToken = pa, R.isCancel = ei, R.VERSION = Ui, R.toFormData = Cr, R.AxiosError = L, R.Cancel = R.CanceledError, R.all = function(e) {
	return Promise.all(e);
}, R.spread = ma, R.isAxiosError = ha, R.mergeConfig = Si, R.AxiosHeaders = fr, R.formToJSON = (e) => Jr(I.isHTMLForm(e) ? new FormData(e) : e), R.getAdapter = ia.getAdapter, R.HttpStatusCode = ga, R.default = R;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/axios@1.20.0_debug@4.4.3_supports-color@8.1.1__supports-color@8.1.1/node_modules/axios/index.js
var { Axios: va, AxiosError: ya, CanceledError: ba, isCancel: xa, CancelToken: Sa, VERSION: Ca, all: wa, Cancel: Ta, isAxiosError: Ea, spread: Da, toFormData: Oa, AxiosHeaders: ka, HttpStatusCode: Aa, formToJSON: ja, getAdapter: Ma, mergeConfig: Na, create: Pa } = R, z = {
	articles: {
		path: "articles",
		hasTitlePropagation: !0
	},
	images: {
		path: "images",
		hasTitlePropagation: !0
	},
	videos: {
		path: "videos",
		hasTitlePropagation: !0
	},
	galleries: {
		path: "galleries",
		hasTitlePropagation: !0
	},
	staticPages: {
		path: "static-page",
		hasTitlePropagation: !0
	},
	articleList: {
		path: "article-list",
		hasTitlePropagation: !0
	},
	channels: {
		path: "channels",
		hasTitlePropagation: !0
	},
	assembler: {
		path: "assembler",
		hasTitlePropagation: !1
	},
	catTool: {
		path: "cat-tool",
		hasTitlePropagation: !1
	},
	pushes: {
		path: "article-push",
		hasTitlePropagation: !1
	},
	kim: {
		path: "kim",
		hasTitlePropagation: !1
	},
	videoPages: {
		path: "video-page",
		hasTitlePropagation: !0
	},
	abHeadlineTest: {
		path: "ab-headline-test",
		hasTitlePropagation: !0
	}
}, Fa = /* @__PURE__ */ St((/* @__PURE__ */ yt(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return e.propertyIsEnumerable(t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (p(e, i) && n.isMergeableObject(t[i]) ? r[i] = u(i, n)(e[i], t[i], n) : r[i] = c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
})))(), 1), Ia = () => {
	let e = navigator.language;
	return /^en\b/.test(e) ? "en" : "de";
}, La = window.innerWidth > 960, Ra = "cms_language", za = "cms_color_scheme", Ba = () => {
	let e = localStorage.getItem(za);
	return e === "light" || e === "dark" || e === "system" ? e : "light";
}, Va = 257, Ha = 56, Ua = Be({
	sidebarNavigationWidth: 257,
	sidebarNavigationOpen: JSON.parse(localStorage.getItem("sidebarNavigationOpen") || JSON.stringify(La)),
	language: localStorage.getItem(Ra) || Ia(),
	colorScheme: Ba(),
	internalLinks: [],
	toggleSidebarNavigation() {
		this.sidebarNavigationOpen = !this.sidebarNavigationOpen;
	},
	setLanguage(e) {
		this.language = e, localStorage.setItem(Ra, e);
	},
	setColorScheme(e) {
		this.colorScheme = e, localStorage.setItem(za, e);
	}
});
qe(() => Ua.sidebarNavigationOpen, (e) => {
	localStorage.setItem("sidebarNavigationOpen", JSON.stringify(e)), Ua.sidebarNavigationWidth = Ua.sidebarNavigationOpen ? 257 : 56;
}, { immediate: !0 });
var Wa = () => Ua, Ga = {
	messages: {
		copyErrorToClipboard: "Details in die Zwischenablage kopieren",
		copiedToClipboard: "In die Zwischenablage kopiert"
	},
	changesWatch: { dialog: {
		title: "Es gibt ungespeicherte Änderungen.",
		text: "Willst du wirklich alle Änderungen verwerfen und die Seite verlassen?",
		inspect: "Untersuchen",
		downloadInitial: "Anfangswert herunterladen",
		downloadCurrent: "Aktuellen Wert herunterladen",
		stay: "Nein, bleiben",
		leave: "Ja, verwerfen"
	} },
	common: {
		error: "Unbekannter Fehler",
		close: "Schließen",
		scheduleBannerText: "Geplante Änderungen dieses Artikels sind vorgesehen für",
		doneBy: "Durchgeführt von",
		removeChange: "Änderung entfernen",
		editChange: "Änderung bearbeiten",
		yes: "Ja",
		no: "Nein",
		all: "Alle"
	},
	scheduledChanges: {
		remove: {
			changesTitle: "Geplante Änderung entfernen",
			changesText: "Willst du die geplanten Änderungen wirklich entfernen?"
		},
		edit: {
			changesTitle: "Geplante Änderung",
			changesText: {
				articleScheduledOn: "Dieser Artikel enthält geplante Änderungen, geplant für",
				warningScheduledChangesPresent: "Alle Änderungen, die jetzt vorgenommen werden, überschreiben die geplanten Änderungen.",
				questionScheduledChangesWillBeOverwritten: "Willst du die geplanten Änderungen wirklich bearbeiten?",
				editingBannerInfo: "Du bearbeitest eine Änderung, die geplant ist für"
			}
		}
	},
	entityState: {
		status: "Status",
		dpAll: "Alle",
		dpDraft: "Entwurf",
		dpSchedule: "Geplant",
		dpPublished: "Veröffentlicht",
		dpExpired: "Depubliziert",
		dpRescheduled: "Änderungen geplant"
	},
	login: { newUserNotification: "Willkommen im Vibe-Editor. Du hast derzeit nur das Recht zur Ansicht, nicht zum Schreiben. Schau dich um, du kannst nichts kaputt machen." },
	pathSelector: {
		pathAutogenerate: "Pfad automatisch generieren",
		pathAutoselect: "Wird automatisch ausgefüllt",
		pathCopiedToClipboard: "Pfad in die Zwischenablage kopiert",
		pathInvalid: "Ungültiger Pfad",
		pathInputLabel: "Pfad"
	},
	cmsSelector: {
		label: "Ursprungs-CMS",
		hint: "CMS, in dem der Artikel erstellt wurde",
		dpAll: "Alle"
	},
	legacySelector: {
		hint: "CMS, in dem der Inhalt ursprünglich erstellt wurde",
		dpAll: "Alle",
		yes: "Ja",
		no: "Nein"
	},
	noEditTooltip: { label: "Dieser {{record}} stammt ursprünglich aus dem {{source}}-Editor" },
	dateTimeSelector: { nowLabel: "Auf jetzt einstellen" },
	aiFieldAssist: {
		fieldFallback: "Text",
		buttonTooltip: "Mit KI verbessern",
		original: "Original",
		result: "Ergebnis",
		resultPlaceholder: "Das generierte Ergebnis erscheint hier.",
		loading: "Wird generiert…",
		promptLabel: "Prompt",
		generate: "Generieren",
		regenerate: "Neu generieren",
		accept: "Übernehmen",
		cancel: "Abbrechen",
		error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
		showChanges: "Änderungen anzeigen",
		useContext: "Artikelinhalt zusätzlich als Kontext verwenden",
		useContextHint: "Der Artikelinhalt dient nur als zusätzlicher Kontext für ein besseres Ergebnis – er wird nicht verändert.",
		actions: {
			basic: "Verbessern",
			correct: "Rechtschreibung",
			seo: "SEO"
		},
		actionHints: {
			basic: "Verbessert Wortwahl und Lesbarkeit, ohne die Bedeutung zu verändern.",
			correct: "Korrigiert nur Rechtschreibung, Grammatik und Zeichensetzung – Bedeutung und Stil bleiben gleich.",
			seo: "Optimiert den Text für Suchmaschinen und hält ihn dabei natürlich und lesbar."
		},
		formatChanged: "Formatierung geändert: {marks}",
		diffTooLarge: "Text zu lang, um Änderungen anzuzeigen",
		marks: {
			bold: "Fett",
			italic: "Kursiv",
			link: "Link",
			heading: "Überschrift"
		}
	},
	[z.articles.path]: {
		routeTitle: "Artikel",
		routeTitleDetail: "A: "
	},
	[z.images.path]: {
		routeTitle: "Bilder",
		routeTitleDetail: "B: "
	},
	[z.videos.path]: {
		routeTitle: "Videos",
		routeTitleDetail: "V: "
	},
	[z.galleries.path]: {
		routeTitle: "Galerien",
		routeTitleDetail: "G: "
	},
	[z.channels.path]: {
		routeTitle: "Channels",
		routeTitleDetail: "C: "
	},
	[z.staticPages.path]: {
		routeTitle: "Statische Seiten",
		routeTitleDetail: "S: "
	},
	[z.articleList.path]: {
		routeTitle: "Listen",
		routeTitleDetail: "L: "
	},
	[z.assembler.path]: {
		routeTitle: "Partner-Content",
		routeTitleDetail: "P: "
	},
	[z.catTool.path]: {
		routeTitle: "Cat-Tool",
		routeTitleDetail: "C: "
	},
	[z.abHeadlineTest.path]: {
		routeTitle: "A/B-Headline-Test",
		routeTitleDetail: "AB: "
	},
	[z.pushes.path]: {
		routeTitle: "Pushes",
		routeTitleDetail: "P: "
	},
	[z.kim.path]: {
		routeTitle: "Kim",
		routeTitleDetail: "K: "
	}
}, Ka = {
	messages: {
		copyErrorToClipboard: "Copy details to clipboard",
		copiedToClipboard: "Copied to clipboard"
	},
	changesWatch: { dialog: {
		title: "There are unsaved changes.",
		text: "Are you sure you want to discard all changes and leave the page?",
		inspect: "Inspect",
		downloadInitial: "Download initial value",
		downloadCurrent: "Download current value",
		stay: "No, stay",
		leave: "Yes, discard"
	} },
	common: {
		error: "Unknown error",
		close: "Close",
		scheduleBannerText: "Scheduled updates to this article are set for",
		doneBy: "Done by",
		removeChange: "Remove change",
		editChange: "Edit change",
		yes: "Yes",
		no: "No",
		all: "All"
	},
	scheduledChanges: {
		remove: {
			changesTitle: "Remove scheduled change",
			changesText: "Are you sure you want to discard the scheduled changes?"
		},
		edit: {
			changesTitle: "Scheduled change",
			changesText: {
				articleScheduledOn: "This article has changes scheduled for",
				warningScheduledChangesPresent: "Any changes you make now will overwrite the changes scheduled for that time.",
				questionScheduledChangesWillBeOverwritten: "Are you sure you want to edit the scheduled changes?",
				editingBannerInfo: "You are editing the change that was scheduled for"
			}
		}
	},
	entityState: {
		status: "Status",
		dpAll: "All",
		dpDraft: "Draft",
		dpSchedule: "Scheduled",
		dpPublished: "Published",
		dpExpired: "Unpublished",
		dpRescheduled: "Rescheduled"
	},
	login: { newUserNotification: "Welcome to the Vibe editor. You have view-only access. Feel free to look around without worrying about breaking anything." },
	pathSelector: {
		pathAutogenerate: "Automatically generate path",
		pathAutoselect: "Will be filled automatically",
		pathCopiedToClipboard: "Path copied to clipboard",
		pathInvalid: "Invalid path",
		pathInputLabel: "Path"
	},
	cmsSelector: {
		label: "CMS of origin",
		hint: "CMS in which article was created",
		dpAll: "All"
	},
	legacySelector: {
		hint: "Original CMS the content was created in",
		dpAll: "All",
		yes: "Yes",
		no: "No"
	},
	noEditTooltip: { label: "This {{record}} is originally from the {{source}} editor" },
	dateTimeSelector: { nowLabel: "Set to now" },
	aiFieldAssist: {
		fieldFallback: "Text",
		buttonTooltip: "Improve with AI",
		original: "Original",
		result: "Result",
		resultPlaceholder: "The generated result will appear here.",
		loading: "Generating…",
		promptLabel: "Prompt",
		generate: "Generate",
		regenerate: "Regenerate",
		accept: "Accept",
		cancel: "Cancel",
		error: "Something went wrong. Please try again.",
		showChanges: "Show changes",
		useContext: "Use article content as background",
		useContextHint: "The article text is used only as background information to inform the result — it is not returned.",
		actions: {
			basic: "Improve",
			correct: "Spell check",
			seo: "SEO"
		},
		actionHints: {
			basic: "Improves wording and readability while keeping the original meaning.",
			correct: "Fixes spelling, grammar and punctuation only — meaning and style stay the same.",
			seo: "Optimizes the text for search engines while keeping it natural and readable."
		},
		formatChanged: "Formatting changed: {marks}",
		diffTooLarge: "Text too long to show changes",
		marks: {
			bold: "bold",
			italic: "italic",
			link: "link",
			heading: "heading"
		}
	},
	[z.articles.path]: {
		routeTitle: "Articles",
		routeTitleDetail: "A: "
	},
	[z.images.path]: {
		routeTitle: "Images",
		routeTitleDetail: "I: "
	},
	[z.videos.path]: {
		routeTitle: "Videos",
		routeTitleDetail: "V: "
	},
	[z.galleries.path]: {
		routeTitle: "Galleries",
		routeTitleDetail: "G: "
	},
	[z.channels.path]: {
		routeTitle: "Channels",
		routeTitleDetail: "C: "
	},
	[z.staticPages.path]: {
		routeTitle: "Static Pages",
		routeTitleDetail: "S: "
	},
	[z.articleList.path]: {
		routeTitle: "Lists",
		routeTitleDetail: "L: "
	},
	[z.assembler.path]: {
		routeTitle: "Partner content",
		routeTitleDetail: "P: "
	},
	[z.catTool.path]: {
		routeTitle: "CAT tool",
		routeTitleDetail: "C: "
	},
	[z.abHeadlineTest.path]: {
		routeTitle: "A/B headline test",
		routeTitleDetail: "AB: "
	},
	[z.pushes.path]: {
		routeTitle: "Pushes",
		routeTitleDetail: "P: "
	},
	[z.kim.path]: {
		routeTitle: "Kim",
		routeTitleDetail: "K: "
	},
	[z.videoPages.path]: {
		routeTitle: "Video pages",
		routeTitleDetail: "VP: "
	}
}, qa, Ja = {
	en: et,
	de: $e,
	it: tt
}, Ya = Wa(), Xa = () => Ja[Ya.language], Za = (e) => {
	let t = Ya.language;
	return qa = nt({
		locale: t,
		legacy: !1,
		fallbackLocale: Ze,
		messages: (0, Fa.default)({
			de: Ga,
			en: Ka
		}, (0, Fa.default)(Qe, e))
	}), qa;
}, B = () => {
	if (!qa) throw Error("I18n is not initialized yet!");
	return qa.global;
};
qe(Ya, (e) => {
	qa.mode === "legacy" ? qa.global.locale = e.language : qa.global.locale.value = e.language;
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/rng.js
var Qa, $a = new Uint8Array(16);
function eo() {
	if (!Qa && (Qa = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Qa)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return Qa($a);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/stringify.js
var to = [];
for (let e = 0; e < 256; ++e) to.push((e + 256).toString(16).slice(1));
function no(e, t = 0) {
	return to[e[t + 0]] + to[e[t + 1]] + to[e[t + 2]] + to[e[t + 3]] + "-" + to[e[t + 4]] + to[e[t + 5]] + "-" + to[e[t + 6]] + to[e[t + 7]] + "-" + to[e[t + 8]] + to[e[t + 9]] + "-" + to[e[t + 10]] + to[e[t + 11]] + to[e[t + 12]] + to[e[t + 13]] + to[e[t + 14]] + to[e[t + 15]];
}
var ro = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js
function io(e, t, n) {
	if (ro.randomUUID && !t && !e) return ro.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || eo)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return no(r);
}
//#endregion
//#region src/stores/notification.store.ts
var ao = class e {
	static DEFAULT_TIMEOUT = 1e4;
	static NO_TIMEOUT = 0;
	message;
	timestamp;
	severity;
	dismissible;
	callbackFunc;
	callbackLabel;
	callbackDataQa;
	callbackNoDismiss;
	callbackHref;
	callbackTarget;
	multiLine;
	timeout;
	progress;
	position;
	html;
	color;
	badgeStyle;
	onDismiss;
	id;
	constructor(t = B().t("common.error"), n = "negative", r) {
		let i = {
			dismissible: !0,
			callbackFunc: void 0,
			callbackLabel: "Action",
			callbackNoDismiss: !1,
			timeout: e.DEFAULT_TIMEOUT,
			progress: !0,
			position: "top",
			multiLine: !1,
			html: !1,
			badgeStyle: void 0,
			color: n,
			id: io(),
			...r
		};
		this.message = t, this.timestamp = Date.now(), this.severity = n, this.dismissible = i.dismissible, this.callbackFunc = i.callbackFunc, this.callbackLabel = i.callbackLabel, this.callbackDataQa = i.callbackDataQa, this.callbackNoDismiss = i.callbackNoDismiss, this.callbackHref = i.callbackHref, this.callbackTarget = i.callbackTarget, this.timeout = e._resolveTimeoutSettings(i.timeout), this.progress = i.progress, this.position = i.position, this.multiLine = i.multiLine, this.html = i.html, this.color = i.color, this.badgeStyle = i.badgeStyle, this.onDismiss = i.onDismiss, this.id = i.id || io();
	}
	static _resolveTimeoutSettings(t) {
		return t === null ? e.NO_TIMEOUT : t === void 0 ? e.DEFAULT_TIMEOUT : t;
	}
}, oo = Be({
	notifications: /* @__PURE__ */ new Map(),
	latestNotification: null,
	notify: void 0,
	clearAndShowNotification(e) {
		this.clearNotification(), this.showNotification(e);
	},
	showNotification(e) {
		let t = {
			label: e.callbackLabel,
			handler: e.callbackFunc,
			noDismiss: e.callbackNoDismiss,
			"data-qa-notification-action": e.callbackDataQa || "",
			...e.callbackHref ? {
				href: e.callbackHref,
				target: e.callbackTarget,
				rel: "noopener"
			} : {}
		}, n = [];
		if ((e.callbackFunc || e.callbackHref) && n.push(t), e.dismissible) {
			let e = {
				label: B().t("common.close"),
				"data-qa-notification-close": ""
			};
			n.push(e);
		}
		let i = {
			message: e.message,
			timeout: e?.timeout ?? ao.DEFAULT_TIMEOUT,
			type: e?.severity,
			classes: e?.severity,
			closeBtn: !1,
			progress: e?.progress,
			position: e?.position,
			multiLine: e.multiLine,
			html: e.html,
			badgeStyle: e.badgeStyle,
			color: e?.color,
			onDismiss: e.onDismiss,
			actions: n
		}, a = r.create(i);
		return this.notifications.has(e.id) || this.notifications.set(e.id, []), this.notifications.get(e.id)?.push(a), this.latestNotification = e, a;
	},
	clearNotification() {
		for (let [e, t] of this.notifications) t.forEach((e) => e());
		this.notifications.clear(), this.latestNotification = null;
	},
	isNotificationVisible(e) {
		return this.notifications.has(e);
	},
	hideNotification(e) {
		let t = this.notifications.get(e);
		if (!t) {
			console.error(`Attempted to hide notification with id ${e} that does not exist in notification store`);
			return;
		}
		t.forEach((e) => e()), this.notifications.delete(e);
	}
});
oo.clearNotification = oo.clearNotification.bind(oo), oo.showNotification = oo.showNotification.bind(oo), oo.clearAndShowNotification = oo.clearAndShowNotification.bind(oo), oo.hideNotification = oo.hideNotification.bind(oo), oo.isNotificationVisible = oo.isNotificationVisible.bind(oo);
var so = () => oo;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/toInteger/index.js
function V(e) {
	if (e === null || e === !0 || e === !1) return NaN;
	var t = Number(e);
	return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function H(e, t) {
	if (t.length < e) throw TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/toDate/index.js
function co(e) {
	H(1, arguments);
	var t = Object.prototype.toString.call(e);
	return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn((/* @__PURE__ */ Error()).stack)), /* @__PURE__ */ new Date(NaN));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/addMilliseconds/index.js
function lo(e, t) {
	H(2, arguments);
	var n = co(e).getTime(), r = V(t);
	return new Date(n + r);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function uo(e) {
	var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
	return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/startOfDay/index.js
function fo(e) {
	H(1, arguments);
	var t = co(e);
	return t.setHours(0, 0, 0, 0), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/isDate/index.js
function po(e) {
	return H(1, arguments), e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/isValid/index.js
function mo(e) {
	if (H(1, arguments), !po(e) && typeof e != "number") return !1;
	var t = co(e);
	return !isNaN(Number(t));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/endOfDay/index.js
function ho(e) {
	H(1, arguments);
	var t = co(e);
	return t.setHours(23, 59, 59, 999), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var go = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, _o = function(e, t, n) {
	var r, i = go[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function vo(e) {
	return function() {
		var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var yo = {
	date: vo({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: vo({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: vo({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, bo = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, xo = function(e, t, n, r) {
	return bo[e];
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function So(e) {
	return function(t, n) {
		var r = n || {}, i = r.context ? String(r.context) : "standalone", a;
		if (i === "formatting" && e.formattingValues) {
			var o = e.defaultFormattingWidth || e.defaultWidth, s = r.width ? String(r.width) : o;
			a = e.formattingValues[s] || e.formattingValues[o];
		} else {
			var c = e.defaultWidth, l = r.width ? String(r.width) : e.defaultWidth;
			a = e.values[l] || e.values[c];
		}
		var u = e.argumentCallback ? e.argumentCallback(t) : t;
		return a[u];
	};
}
var Co = {
	ordinalNumber: function(e, t) {
		var n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: So({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: So({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: function(e) {
			return e - 1;
		}
	}),
	month: So({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: So({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: So({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function wo(e) {
	return function(t) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		var o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Eo(s, function(e) {
			return e.test(o);
		}) : To(s, function(e) {
			return e.test(o);
		}), l = e.valueCallback ? e.valueCallback(c) : c;
		l = n.valueCallback ? n.valueCallback(l) : l;
		var u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function To(e, t) {
	for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function Eo(e, t) {
	for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function Do(e) {
	return function(t) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
		if (!r) return null;
		var i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		var s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/locale/en-US/index.js
var Oo = {
	code: "en-US",
	formatDistance: _o,
	formatLong: yo,
	formatRelative: xo,
	localize: Co,
	match: {
		ordinalNumber: Do({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: function(e) {
				return parseInt(e, 10);
			}
		}),
		era: wo({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: wo({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: function(e) {
				return e + 1;
			}
		}),
		month: wo({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: wo({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: wo({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/subMilliseconds/index.js
function ko(e, t) {
	return H(2, arguments), lo(e, -V(t));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function U(e, t) {
	for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
	return n + r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var Ao = {
	y: function(e, t) {
		var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
		return U(t === "yy" ? r % 100 : r, t.length);
	},
	M: function(e, t) {
		var n = e.getUTCMonth();
		return t === "M" ? String(n + 1) : U(n + 1, 2);
	},
	d: function(e, t) {
		return U(e.getUTCDate(), t.length);
	},
	a: function(e, t) {
		var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h: function(e, t) {
		return U(e.getUTCHours() % 12 || 12, t.length);
	},
	H: function(e, t) {
		return U(e.getUTCHours(), t.length);
	},
	m: function(e, t) {
		return U(e.getUTCMinutes(), t.length);
	},
	s: function(e, t) {
		return U(e.getUTCSeconds(), t.length);
	},
	S: function(e, t) {
		var n = t.length, r = e.getUTCMilliseconds();
		return U(Math.floor(r * 10 ** (n - 3)), t.length);
	}
}, jo = 864e5;
function Mo(e) {
	H(1, arguments);
	var t = co(e), n = t.getTime();
	t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
	var r = n - t.getTime();
	return Math.floor(r / jo) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function No(e) {
	H(1, arguments);
	var t = 1, n = co(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
	return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function Po(e) {
	H(1, arguments);
	var t = co(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
	var i = No(r), a = /* @__PURE__ */ new Date(0);
	a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
	var o = No(a);
	return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function Fo(e) {
	H(1, arguments);
	var t = Po(e), n = /* @__PURE__ */ new Date(0);
	return n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0), No(n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
var Io = 6048e5;
function Lo(e) {
	H(1, arguments);
	var t = co(e), n = No(t).getTime() - Fo(t).getTime();
	return Math.round(n / Io) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function Ro(e, t) {
	H(1, arguments);
	var n = t || {}, r = n.locale, i = r && r.options && r.options.weekStartsOn, a = i == null ? 0 : V(i), o = n.weekStartsOn == null ? a : V(n.weekStartsOn);
	if (!(o >= 0 && o <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var s = co(e), c = s.getUTCDay(), l = (c < o ? 7 : 0) + c - o;
	return s.setUTCDate(s.getUTCDate() - l), s.setUTCHours(0, 0, 0, 0), s;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function zo(e, t) {
	H(1, arguments);
	var n = co(e, t), r = n.getUTCFullYear(), i = t || {}, a = i.locale, o = a && a.options && a.options.firstWeekContainsDate, s = o == null ? 1 : V(o), c = i.firstWeekContainsDate == null ? s : V(i.firstWeekContainsDate);
	if (!(c >= 1 && c <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var l = /* @__PURE__ */ new Date(0);
	l.setUTCFullYear(r + 1, 0, c), l.setUTCHours(0, 0, 0, 0);
	var u = Ro(l, t), d = /* @__PURE__ */ new Date(0);
	d.setUTCFullYear(r, 0, c), d.setUTCHours(0, 0, 0, 0);
	var f = Ro(d, t);
	return n.getTime() >= u.getTime() ? r + 1 : n.getTime() >= f.getTime() ? r : r - 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function Bo(e, t) {
	H(1, arguments);
	var n = t || {}, r = n.locale, i = r && r.options && r.options.firstWeekContainsDate, a = i == null ? 1 : V(i), o = n.firstWeekContainsDate == null ? a : V(n.firstWeekContainsDate), s = zo(e, t), c = /* @__PURE__ */ new Date(0);
	return c.setUTCFullYear(s, 0, o), c.setUTCHours(0, 0, 0, 0), Ro(c, t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/getUTCWeek/index.js
var Vo = 6048e5;
function Ho(e, t) {
	H(1, arguments);
	var n = co(e), r = Ro(n, t).getTime() - Bo(n, t).getTime();
	return Math.round(r / Vo) + 1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/formatters/index.js
var Uo = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Wo = {
	G: function(e, t, n) {
		var r = +(e.getUTCFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
			return n.ordinalNumber(i, { unit: "year" });
		}
		return Ao.y(e, t);
	},
	Y: function(e, t, n, r) {
		var i = zo(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? U(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : U(a, t.length);
	},
	R: function(e, t) {
		return U(Po(e), t.length);
	},
	u: function(e, t) {
		return U(e.getUTCFullYear(), t.length);
	},
	Q: function(e, t, n) {
		var r = Math.ceil((e.getUTCMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return U(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		var r = Math.ceil((e.getUTCMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return U(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		var r = e.getUTCMonth();
		switch (t) {
			case "M":
			case "MM": return Ao.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		var r = e.getUTCMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return U(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		var i = Ho(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : U(i, t.length);
	},
	I: function(e, t, n) {
		var r = Lo(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : U(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getUTCDate(), { unit: "date" }) : Ao.d(e, t);
	},
	D: function(e, t, n) {
		var r = Mo(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : U(r, t.length);
	},
	E: function(e, t, n) {
		var r = e.getUTCDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		var i = e.getUTCDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return U(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		var i = e.getUTCDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return U(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		var r = e.getUTCDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return U(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		var r = e.getUTCHours(), i = r === 12 ? Uo.noon : r === 0 ? Uo.midnight : r / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		var r = e.getUTCHours(), i = r >= 17 ? Uo.evening : r >= 12 ? Uo.afternoon : r >= 4 ? Uo.morning : Uo.night;
		switch (t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			var r = e.getUTCHours() % 12;
			return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
		}
		return Ao.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), { unit: "hour" }) : Ao.H(e, t);
	},
	K: function(e, t, n) {
		var r = e.getUTCHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : U(r, t.length);
	},
	k: function(e, t, n) {
		var r = e.getUTCHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : U(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), { unit: "minute" }) : Ao.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), { unit: "second" }) : Ao.s(e, t);
	},
	S: function(e, t) {
		return Ao.S(e, t);
	},
	X: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		if (i === 0) return "Z";
		switch (t) {
			case "X": return Ko(i);
			case "XXXX":
			case "XX": return qo(i);
			default: return qo(i, ":");
		}
	},
	x: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "x": return Ko(i);
			case "xxxx":
			case "xx": return qo(i);
			default: return qo(i, ":");
		}
	},
	O: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Go(i, ":");
			default: return "GMT" + qo(i, ":");
		}
	},
	z: function(e, t, n, r) {
		var i = (r._originalDate || e).getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Go(i, ":");
			default: return "GMT" + qo(i, ":");
		}
	},
	t: function(e, t, n, r) {
		var i = r._originalDate || e;
		return U(Math.floor(i.getTime() / 1e3), t.length);
	},
	T: function(e, t, n, r) {
		return U((r._originalDate || e).getTime(), t.length);
	}
};
function Go(e, t) {
	var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
	if (a === 0) return n + String(i);
	var o = t || "";
	return n + String(i) + o + U(a, 2);
}
function Ko(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + U(Math.abs(e) / 60, 2) : qo(e, t);
}
function qo(e, t) {
	var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), a = U(Math.floor(i / 60), 2), o = U(i % 60, 2);
	return r + a + n + o;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
function Jo(e, t) {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}
function Yo(e, t) {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}
function Xo(e, t) {
	var n = e.match(/(P+)(p+)?/), r = n[1], i = n[2];
	if (!i) return Jo(e, t);
	var a;
	switch (r) {
		case "P":
			a = t.dateTime({ width: "short" });
			break;
		case "PP":
			a = t.dateTime({ width: "medium" });
			break;
		case "PPP":
			a = t.dateTime({ width: "long" });
			break;
		default:
			a = t.dateTime({ width: "full" });
			break;
	}
	return a.replace("{{date}}", Jo(r, t)).replace("{{time}}", Yo(i, t));
}
var Zo = {
	p: Yo,
	P: Xo
}, Qo = ["D", "DD"], $o = ["YY", "YYYY"];
function es(e) {
	return Qo.indexOf(e) !== -1;
}
function ts(e) {
	return $o.indexOf(e) !== -1;
}
function ns(e, t, n) {
	if (e === "YYYY") throw RangeError(`Use \`yyyy\` instead of \`YYYY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "YY") throw RangeError(`Use \`yy\` instead of \`YY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "D") throw RangeError(`Use \`d\` instead of \`D\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://git.io/fxCyr`);
	if (e === "DD") throw RangeError(`Use \`dd\` instead of \`DD\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://git.io/fxCyr`);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/format/index.js
var rs = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, is = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, as = /^'([^]*?)'?$/, os = /''/g, ss = /[a-zA-Z]/;
function cs(e, t, n) {
	H(2, arguments);
	var r = String(t), i = n || {}, a = i.locale || Oo, o = a.options && a.options.firstWeekContainsDate, s = o == null ? 1 : V(o), c = i.firstWeekContainsDate == null ? s : V(i.firstWeekContainsDate);
	if (!(c >= 1 && c <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var l = a.options && a.options.weekStartsOn, u = l == null ? 0 : V(l), d = i.weekStartsOn == null ? u : V(i.weekStartsOn);
	if (!(d >= 0 && d <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (!a.localize) throw RangeError("locale must contain localize property");
	if (!a.formatLong) throw RangeError("locale must contain formatLong property");
	var f = co(e);
	if (!mo(f)) throw RangeError("Invalid time value");
	var p = ko(f, uo(f)), m = {
		firstWeekContainsDate: c,
		weekStartsOn: d,
		locale: a,
		_originalDate: f
	};
	return r.match(is).map(function(e) {
		var t = e[0];
		if (t === "p" || t === "P") {
			var n = Zo[t];
			return n(e, a.formatLong, m);
		}
		return e;
	}).join("").match(rs).map(function(n) {
		if (n === "''") return "'";
		var r = n[0];
		if (r === "'") return ls(n);
		var o = Wo[r];
		if (o) return !i.useAdditionalWeekYearTokens && ts(n) && ns(n, t, e), !i.useAdditionalDayOfYearTokens && es(n) && ns(n, t, e), o(p, n, a.localize, m);
		if (r.match(ss)) throw RangeError("Format string contains an unescaped latin alphabet character `" + r + "`");
		return n;
	}).join("");
}
function ls(e) {
	return e.match(as)[1].replace(os, "'");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/assign/index.js
function us(e, t) {
	if (e == null) throw TypeError("assign requires that input parameter not be null or undefined");
	for (var n in t ||= {}, t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCDay/index.js
function ds(e, t, n) {
	H(2, arguments);
	var r = n || {}, i = r.locale, a = i && i.options && i.options.weekStartsOn, o = a == null ? 0 : V(a), s = r.weekStartsOn == null ? o : V(r.weekStartsOn);
	if (!(s >= 0 && s <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var c = co(e), l = V(t), u = c.getUTCDay(), d = ((l % 7 + 7) % 7 < s ? 7 : 0) + l - u;
	return c.setUTCDate(c.getUTCDate() + d), c;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCISODay/index.js
function fs(e, t) {
	H(2, arguments);
	var n = V(t);
	n % 7 == 0 && (n -= 7);
	var r = 1, i = co(e), a = i.getUTCDay(), o = ((n % 7 + 7) % 7 < r ? 7 : 0) + n - a;
	return i.setUTCDate(i.getUTCDate() + o), i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js
function ps(e, t) {
	H(2, arguments);
	var n = co(e), r = V(t), i = Lo(n) - r;
	return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/_lib/setUTCWeek/index.js
function ms(e, t, n) {
	H(2, arguments);
	var r = co(e), i = V(t), a = Ho(r, n) - i;
	return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/date-fns@2.26.0/node_modules/date-fns/esm/parse/_lib/parsers/index.js
var hs = 36e5, gs = 6e4, _s = 1e3, W = {
	month: /^(1[0-2]|0?\d)/,
	date: /^(3[0-1]|[0-2]?\d)/,
	dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	week: /^(5[0-3]|[0-4]?\d)/,
	hour23h: /^(2[0-3]|[0-1]?\d)/,
	hour24h: /^(2[0-4]|[0-1]?\d)/,
	hour11h: /^(1[0-1]|0?\d)/,
	hour12h: /^(1[0-2]|0?\d)/,
	minute: /^[0-5]?\d/,
	second: /^[0-5]?\d/,
	singleDigit: /^\d/,
	twoDigits: /^\d{1,2}/,
	threeDigits: /^\d{1,3}/,
	fourDigits: /^\d{1,4}/,
	anyDigitsSigned: /^-?\d+/,
	singleDigitSigned: /^-?\d/,
	twoDigitsSigned: /^-?\d{1,2}/,
	threeDigitsSigned: /^-?\d{1,3}/,
	fourDigitsSigned: /^-?\d{1,4}/
}, vs = {
	basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	basic: /^([+-])(\d{2})(\d{2})|Z/,
	basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	extended: /^([+-])(\d{2}):(\d{2})|Z/,
	extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function G(e, t, n) {
	var r = t.match(e);
	if (!r) return null;
	var i = parseInt(r[0], 10);
	return {
		value: n ? n(i) : i,
		rest: t.slice(r[0].length)
	};
}
function ys(e, t) {
	var n = t.match(e);
	if (!n) return null;
	if (n[0] === "Z") return {
		value: 0,
		rest: t.slice(1)
	};
	var r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
	return {
		value: r * (i * hs + a * gs + o * _s),
		rest: t.slice(n[0].length)
	};
}
function bs(e, t) {
	return G(W.anyDigitsSigned, e, t);
}
function K(e, t, n) {
	switch (e) {
		case 1: return G(W.singleDigit, t, n);
		case 2: return G(W.twoDigits, t, n);
		case 3: return G(W.threeDigits, t, n);
		case 4: return G(W.fourDigits, t, n);
		default: return G(RegExp("^\\d{1," + e + "}"), t, n);
	}
}
function xs(e, t, n) {
	switch (e) {
		case 1: return G(W.singleDigitSigned, t, n);
		case 2: return G(W.twoDigitsSigned, t, n);
		case 3: return G(W.threeDigitsSigned, t, n);
		case 4: return G(W.fourDigitsSigned, t, n);
		default: return G(RegExp("^-?\\d{1," + e + "}"), t, n);
	}
}
function Ss(e) {
	switch (e) {
		case "morning": return 4;
		case "evening": return 17;
		case "pm":
		case "noon":
		case "afternoon": return 12;
		default: return 0;
	}
}
function Cs(e, t) {
	var n = t > 0, r = n ? t : 1 - t, i;
	if (r <= 50) i = e || 100;
	else {
		var a = r + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
		i = e + o - (s ? 100 : 0);
	}
	return n ? i : 1 - i;
}
var ws = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], Ts = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function Es(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
var Ds = {
	G: {
		priority: 140,
		parse: function(e, t, n, r) {
			switch (t) {
				case "G":
				case "GG":
				case "GGG": return n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
				case "GGGGG": return n.era(e, { width: "narrow" });
				default: return n.era(e, { width: "wide" }) || n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
			}
		},
		set: function(e, t, n, r) {
			return t.era = n, e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"R",
			"u",
			"t",
			"T"
		]
	},
	y: {
		priority: 130,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return {
					year: e,
					isTwoDigitYear: t === "yy"
				};
			};
			switch (t) {
				case "y": return K(4, e, i);
				case "yo": return n.ordinalNumber(e, {
					unit: "year",
					valueCallback: i
				});
				default: return K(t.length, e, i);
			}
		},
		validate: function(e, t, n) {
			return t.isTwoDigitYear || t.year > 0;
		},
		set: function(e, t, n, r) {
			var i = e.getUTCFullYear();
			if (n.isTwoDigitYear) {
				var a = Cs(n.year, i);
				return e.setUTCFullYear(a, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
			}
			var o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
			return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"u",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	Y: {
		priority: 130,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return {
					year: e,
					isTwoDigitYear: t === "YY"
				};
			};
			switch (t) {
				case "Y": return K(4, e, i);
				case "Yo": return n.ordinalNumber(e, {
					unit: "year",
					valueCallback: i
				});
				default: return K(t.length, e, i);
			}
		},
		validate: function(e, t, n) {
			return t.isTwoDigitYear || t.year > 0;
		},
		set: function(e, t, n, r) {
			var i = zo(e, r);
			if (n.isTwoDigitYear) {
				var a = Cs(n.year, i);
				return e.setUTCFullYear(a, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ro(e, r);
			}
			var o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
			return e.setUTCFullYear(o, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ro(e, r);
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]
	},
	R: {
		priority: 130,
		parse: function(e, t, n, r) {
			return xs(t === "R" ? 4 : t.length, e);
		},
		set: function(e, t, n, r) {
			var i = /* @__PURE__ */ new Date(0);
			return i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0), No(i);
		},
		incompatibleTokens: [
			"G",
			"y",
			"Y",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]
	},
	u: {
		priority: 130,
		parse: function(e, t, n, r) {
			return xs(t === "u" ? 4 : t.length, e);
		},
		set: function(e, t, n, r) {
			return e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"G",
			"y",
			"Y",
			"R",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	Q: {
		priority: 120,
		parse: function(e, t, n, r) {
			switch (t) {
				case "Q":
				case "QQ": return K(t.length, e);
				case "Qo": return n.ordinalNumber(e, { unit: "quarter" });
				case "QQQ": return n.quarter(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
				case "QQQQQ": return n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.quarter(e, {
					width: "wide",
					context: "formatting"
				}) || n.quarter(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.quarter(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 4;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth((n - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	q: {
		priority: 120,
		parse: function(e, t, n, r) {
			switch (t) {
				case "q":
				case "qq": return K(t.length, e);
				case "qo": return n.ordinalNumber(e, { unit: "quarter" });
				case "qqq": return n.quarter(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
				case "qqqqq": return n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.quarter(e, {
					width: "wide",
					context: "standalone"
				}) || n.quarter(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.quarter(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 4;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth((n - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	M: {
		priority: 110,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e - 1;
			};
			switch (t) {
				case "M": return G(W.month, e, i);
				case "MM": return K(2, e, i);
				case "Mo": return n.ordinalNumber(e, {
					unit: "month",
					valueCallback: i
				});
				case "MMM": return n.month(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.month(e, {
					width: "narrow",
					context: "formatting"
				});
				case "MMMMM": return n.month(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.month(e, {
					width: "wide",
					context: "formatting"
				}) || n.month(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.month(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"L",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	L: {
		priority: 110,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e - 1;
			};
			switch (t) {
				case "L": return G(W.month, e, i);
				case "LL": return K(2, e, i);
				case "Lo": return n.ordinalNumber(e, {
					unit: "month",
					valueCallback: i
				});
				case "LLL": return n.month(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.month(e, {
					width: "narrow",
					context: "standalone"
				});
				case "LLLLL": return n.month(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.month(e, {
					width: "wide",
					context: "standalone"
				}) || n.month(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.month(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	w: {
		priority: 100,
		parse: function(e, t, n, r) {
			switch (t) {
				case "w": return G(W.week, e);
				case "wo": return n.ordinalNumber(e, { unit: "week" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 53;
		},
		set: function(e, t, n, r) {
			return Ro(ms(e, n, r), r);
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]
	},
	I: {
		priority: 100,
		parse: function(e, t, n, r) {
			switch (t) {
				case "I": return G(W.week, e);
				case "Io": return n.ordinalNumber(e, { unit: "week" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 53;
		},
		set: function(e, t, n, r) {
			return No(ps(e, n, r), r);
		},
		incompatibleTokens: [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]
	},
	d: {
		priority: 90,
		subPriority: 1,
		parse: function(e, t, n, r) {
			switch (t) {
				case "d": return G(W.date, e);
				case "do": return n.ordinalNumber(e, { unit: "date" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			var r = Es(e.getUTCFullYear()), i = e.getUTCMonth();
			return r ? t >= 1 && t <= Ts[i] : t >= 1 && t <= ws[i];
		},
		set: function(e, t, n, r) {
			return e.setUTCDate(n), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	D: {
		priority: 90,
		subPriority: 1,
		parse: function(e, t, n, r) {
			switch (t) {
				case "D":
				case "DD": return G(W.dayOfYear, e);
				case "Do": return n.ordinalNumber(e, { unit: "date" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return Es(e.getUTCFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
		},
		set: function(e, t, n, r) {
			return e.setUTCMonth(0, n), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"E",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	E: {
		priority: 90,
		parse: function(e, t, n, r) {
			switch (t) {
				case "E":
				case "EE":
				case "EEE": return n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "EEEEE": return n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "EEEEEE": return n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting"
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = ds(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]
	},
	e: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				var t = Math.floor((e - 1) / 7) * 7;
				return (e + r.weekStartsOn + 6) % 7 + t;
			};
			switch (t) {
				case "e":
				case "ee": return K(t.length, e, i);
				case "eo": return n.ordinalNumber(e, {
					unit: "day",
					valueCallback: i
				});
				case "eee": return n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "eeeee": return n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				case "eeeeee": return n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting"
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.day(e, {
					width: "short",
					context: "formatting"
				}) || n.day(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = ds(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"c",
			"t",
			"T"
		]
	},
	c: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				var t = Math.floor((e - 1) / 7) * 7;
				return (e + r.weekStartsOn + 6) % 7 + t;
			};
			switch (t) {
				case "c":
				case "cc": return K(t.length, e, i);
				case "co": return n.ordinalNumber(e, {
					unit: "day",
					valueCallback: i
				});
				case "ccc": return n.day(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				case "ccccc": return n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				case "cccccc": return n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
				default: return n.day(e, {
					width: "wide",
					context: "standalone"
				}) || n.day(e, {
					width: "abbreviated",
					context: "standalone"
				}) || n.day(e, {
					width: "short",
					context: "standalone"
				}) || n.day(e, {
					width: "narrow",
					context: "standalone"
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 6;
		},
		set: function(e, t, n, r) {
			return e = ds(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"e",
			"t",
			"T"
		]
	},
	i: {
		priority: 90,
		parse: function(e, t, n, r) {
			var i = function(e) {
				return e === 0 ? 7 : e;
			};
			switch (t) {
				case "i":
				case "ii": return K(t.length, e);
				case "io": return n.ordinalNumber(e, { unit: "day" });
				case "iii": return n.day(e, {
					width: "abbreviated",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				case "iiiii": return n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				case "iiiiii": return n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
				default: return n.day(e, {
					width: "wide",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "abbreviated",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "short",
					context: "formatting",
					valueCallback: i
				}) || n.day(e, {
					width: "narrow",
					context: "formatting",
					valueCallback: i
				});
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 7;
		},
		set: function(e, t, n, r) {
			return e = fs(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"E",
			"e",
			"c",
			"t",
			"T"
		]
	},
	a: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "a":
				case "aa":
				case "aaa": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "aaaaa": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Ss(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"b",
			"B",
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	b: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "b":
				case "bb":
				case "bbb": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "bbbbb": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Ss(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"B",
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	B: {
		priority: 80,
		parse: function(e, t, n, r) {
			switch (t) {
				case "B":
				case "BB":
				case "BBB": return n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				case "BBBBB": return n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
				default: return n.dayPeriod(e, {
					width: "wide",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "abbreviated",
					context: "formatting"
				}) || n.dayPeriod(e, {
					width: "narrow",
					context: "formatting"
				});
			}
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(Ss(n), 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"t",
			"T"
		]
	},
	h: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "h": return G(W.hour12h, e);
				case "ho": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 12;
		},
		set: function(e, t, n, r) {
			var i = e.getUTCHours() >= 12;
			return i && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : !i && n === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"H",
			"K",
			"k",
			"t",
			"T"
		]
	},
	H: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "H": return G(W.hour23h, e);
				case "Ho": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 23;
		},
		set: function(e, t, n, r) {
			return e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"K",
			"k",
			"t",
			"T"
		]
	},
	K: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "K": return G(W.hour11h, e);
				case "Ko": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 11;
		},
		set: function(e, t, n, r) {
			return e.getUTCHours() >= 12 && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : e.setUTCHours(n, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"H",
			"k",
			"t",
			"T"
		]
	},
	k: {
		priority: 70,
		parse: function(e, t, n, r) {
			switch (t) {
				case "k": return G(W.hour24h, e);
				case "ko": return n.ordinalNumber(e, { unit: "hour" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 1 && t <= 24;
		},
		set: function(e, t, n, r) {
			var i = n <= 24 ? n % 24 : n;
			return e.setUTCHours(i, 0, 0, 0), e;
		},
		incompatibleTokens: [
			"a",
			"b",
			"h",
			"H",
			"K",
			"t",
			"T"
		]
	},
	m: {
		priority: 60,
		parse: function(e, t, n, r) {
			switch (t) {
				case "m": return G(W.minute, e);
				case "mo": return n.ordinalNumber(e, { unit: "minute" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 59;
		},
		set: function(e, t, n, r) {
			return e.setUTCMinutes(n, 0, 0), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	s: {
		priority: 50,
		parse: function(e, t, n, r) {
			switch (t) {
				case "s": return G(W.second, e);
				case "so": return n.ordinalNumber(e, { unit: "second" });
				default: return K(t.length, e);
			}
		},
		validate: function(e, t, n) {
			return t >= 0 && t <= 59;
		},
		set: function(e, t, n, r) {
			return e.setUTCSeconds(n, 0), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	S: {
		priority: 30,
		parse: function(e, t, n, r) {
			return K(t.length, e, function(e) {
				return Math.floor(e * 10 ** (-t.length + 3));
			});
		},
		set: function(e, t, n, r) {
			return e.setUTCMilliseconds(n), e;
		},
		incompatibleTokens: ["t", "T"]
	},
	X: {
		priority: 10,
		parse: function(e, t, n, r) {
			switch (t) {
				case "X": return ys(vs.basicOptionalMinutes, e);
				case "XX": return ys(vs.basic, e);
				case "XXXX": return ys(vs.basicOptionalSeconds, e);
				case "XXXXX": return ys(vs.extendedOptionalSeconds, e);
				default: return ys(vs.extended, e);
			}
		},
		set: function(e, t, n, r) {
			return t.timestampIsSet ? e : new Date(e.getTime() - n);
		},
		incompatibleTokens: [
			"t",
			"T",
			"x"
		]
	},
	x: {
		priority: 10,
		parse: function(e, t, n, r) {
			switch (t) {
				case "x": return ys(vs.basicOptionalMinutes, e);
				case "xx": return ys(vs.basic, e);
				case "xxxx": return ys(vs.basicOptionalSeconds, e);
				case "xxxxx": return ys(vs.extendedOptionalSeconds, e);
				default: return ys(vs.extended, e);
			}
		},
		set: function(e, t, n, r) {
			return t.timestampIsSet ? e : new Date(e.getTime() - n);
		},
		incompatibleTokens: [
			"t",
			"T",
			"X"
		]
	},
	t: {
		priority: 40,
		parse: function(e, t, n, r) {
			return bs(e);
		},
		set: function(e, t, n, r) {
			return [/* @__PURE__ */ new Date(n * 1e3), { timestampIsSet: !0 }];
		},
		incompatibleTokens: "*"
	},
	T: {
		priority: 20,
		parse: function(e, t, n, r) {
			return bs(e);
		},
		set: function(e, t, n, r) {
			return [new Date(n), { timestampIsSet: !0 }];
		},
		incompatibleTokens: "*"
	}
}, Os = 10, ks = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, As = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, js = /^'([^]*?)'?$/, Ms = /''/g, Ns = /\S/, Ps = /[a-zA-Z]/;
function Fs(e, t, n, r) {
	H(3, arguments);
	var i = String(e), a = String(t), o = r || {}, s = o.locale || Oo;
	if (!s.match) throw RangeError("locale must contain match property");
	var c = s.options && s.options.firstWeekContainsDate, l = c == null ? 1 : V(c), u = o.firstWeekContainsDate == null ? l : V(o.firstWeekContainsDate);
	if (!(u >= 1 && u <= 7)) throw RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var d = s.options && s.options.weekStartsOn, f = d == null ? 0 : V(d), p = o.weekStartsOn == null ? f : V(o.weekStartsOn);
	if (!(p >= 0 && p <= 6)) throw RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (a === "") return i === "" ? co(n) : /* @__PURE__ */ new Date(NaN);
	var m = {
		firstWeekContainsDate: u,
		weekStartsOn: p,
		locale: s
	}, h = [{
		priority: Os,
		subPriority: -1,
		set: Is,
		index: 0
	}], g, ee = a.match(As).map(function(e) {
		var t = e[0];
		if (t === "p" || t === "P") {
			var n = Zo[t];
			return n(e, s.formatLong, m);
		}
		return e;
	}).join("").match(ks), _ = [];
	for (g = 0; g < ee.length; g++) {
		var v = ee[g];
		!o.useAdditionalWeekYearTokens && ts(v) && ns(v, a, e), !o.useAdditionalDayOfYearTokens && es(v) && ns(v, a, e);
		var y = v[0], b = Ds[y];
		if (b) {
			var te = b.incompatibleTokens;
			if (Array.isArray(te)) {
				for (var ne = void 0, x = 0; x < _.length; x++) {
					var re = _[x].token;
					if (te.indexOf(re) !== -1 || re === y) {
						ne = _[x];
						break;
					}
				}
				if (ne) throw RangeError(`The format string mustn't contain \`${ne.fullToken}\` and \`${v}\` at the same time`);
			} else if (b.incompatibleTokens === "*" && _.length) throw RangeError(`The format string mustn't contain \`${v}\` and any other token at the same time`);
			_.push({
				token: y,
				fullToken: v
			});
			var ie = b.parse(i, v, s.match, m);
			if (!ie) return /* @__PURE__ */ new Date(NaN);
			h.push({
				priority: b.priority,
				subPriority: b.subPriority || 0,
				set: b.set,
				validate: b.validate,
				value: ie.value,
				index: h.length
			}), i = ie.rest;
		} else {
			if (y.match(Ps)) throw RangeError("Format string contains an unescaped latin alphabet character `" + y + "`");
			if (v === "''" ? v = "'" : y === "'" && (v = Ls(v)), i.indexOf(v) === 0) i = i.slice(v.length);
			else return /* @__PURE__ */ new Date(NaN);
		}
	}
	if (i.length > 0 && Ns.test(i)) return /* @__PURE__ */ new Date(NaN);
	var ae = h.map(function(e) {
		return e.priority;
	}).sort(function(e, t) {
		return t - e;
	}).filter(function(e, t, n) {
		return n.indexOf(e) === t;
	}).map(function(e) {
		return h.filter(function(t) {
			return t.priority === e;
		}).sort(function(e, t) {
			return t.subPriority - e.subPriority;
		});
	}).map(function(e) {
		return e[0];
	}), oe = co(n);
	if (isNaN(oe)) return /* @__PURE__ */ new Date(NaN);
	var se = ko(oe, uo(oe)), ce = {};
	for (g = 0; g < ae.length; g++) {
		var le = ae[g];
		if (le.validate && !le.validate(se, le.value, m)) return /* @__PURE__ */ new Date(NaN);
		var S = le.set(se, ce, le.value, m);
		S[0] ? (se = S[0], us(ce, S[1])) : se = S;
	}
	return se;
}
function Is(e, t) {
	if (t.timestampIsSet) return e;
	var n = /* @__PURE__ */ new Date(0);
	return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
}
function Ls(e) {
	return e.match(js)[1].replace(Ms, "'");
}
//#endregion
//#region src/utils/date.util.ts
var Rs = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+-])(\d{2}):(\d{2}))$/, zs = (e) => e ? cs(new Date(e), "dd-MM-yy HH:mm") : "-", Bs = (e) => e ? cs(new Date(e), "dd.MM.yy HH:mm") : "-", Vs = (e) => e ? cs(new Date(e), "dd.MM.yy") : "-", Hs = (e) => e ? cs(new Date(e), "dd.MM.yyyy") : "-", Us = (e) => e ? cs(new Date(e), "HH:mm") : "-", Ws = (e) => e ? cs(new Date(e), "dd.MM.yy HH:mm:ss") : "-", Gs = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : e, Ks = (e, t = ["second", "millisecond"]) => (t.includes("hour") && e.setHours(0), t.includes("minute") && e.setMinutes(0), t.includes("second") && e.setSeconds(0), t.includes("millisecond") && e.setMilliseconds(0), e), qs = (e) => Ks(e, ["second", "millisecond"]), Js = (e) => {
	function t(e) {
		let n = {};
		for (let r of Object.keys(e)) {
			let i = e[r];
			typeof i == "string" && Rs.test(i) ? n[r] = new Date(i) : typeof i == "object" && i ? n[r] = t(i) : n[r] = i;
		}
		return Object.assign(e, n), e;
	}
	return t(e);
}, Ys = (e) => `${Math.floor(e / 60).toString().padStart(2, "0")}:${(e % 60).toString().padStart(2, "0")}`, Xs = Wa(), Zs = {}, Qs = {}, $s = (e = GLOBAL_CONFIG.API_BASE_URL) => ({
	withCredentials: !0,
	baseURL: e,
	withXSRFToken: !0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "x-xsrf-token",
	headers: {
		"Content-Type": "application/json",
		"Accept-Language": Xs.language ?? navigator.language
	},
	paramsSerializer: { serialize: (e) => Object.entries(e).map(([e, t]) => {
		if (!(t === void 0 || t === "")) return Array.isArray(t) ? t.map((t) => `${encodeURIComponent(e)}[]=${encodeURIComponent(`${Gs(t)}`)}`).join("&") : `${encodeURIComponent(e)}=${encodeURIComponent(`${Gs(t)}`)}`;
	}).filter(Boolean).join("&") }
}), ec = (e) => {
	if (R.isCancel(e) || e.config?.handleError === !1) return Promise.reject(e);
	let t = so();
	if (((t) => e.isAxiosError)(e)) {
		if (e.response?.status === 401 && e.response.data?.type === "UnauthenticatedInCMSError") return Promise.reject(e);
		let { t: n } = B(), r = e.response?.status === 404 ? "warning" : "negative";
		t.showNotification(new ao(e.message + (e.response?.data.message ? `: ${e.response?.data.message}` : ""), r, {
			multiLine: !0,
			timeout: null,
			dismissible: !0,
			callbackLabel: n("messages.copyErrorToClipboard"),
			async callbackFunc() {
				await ve(e.response ? JSON.stringify(e.response, void 0, 2) : JSON.stringify(e, void 0, 2)), t.showNotification(new ao(n("messages.copiedToClipboard"), "info"));
			}
		}));
	}
	return Promise.reject(e);
}, tc = (e) => {
	let t = e.data;
	return typeof t != "object" || !t || (e.data = Js(t)), e;
}, nc = (e) => {
	let t = Object.keys(z).filter((e) => z[e].hasTitlePropagation).map((e) => z[e].path), n = location.pathname.split("/").filter((e) => e.length > 0), r = n[0], { _id: i, title: a, image: o } = e.data, s = i || o?._id, c = a || o?.title, l = r ? t.includes(r) : !1, u = B().te(`${r}.routeTitleDetail`);
	if (l && c && u && s === n.pop()) {
		let e = B().t(`${r}.routeTitleDetail`);
		document.title = `${e} ${c}`;
	}
	return e;
}, rc = [ec], ic = (e) => {
	let t = R.create(e);
	for (let e of rc) t.interceptors.response.use(void 0, e);
	return t.interceptors.response.use(tc), t.interceptors.response.use(nc), t;
}, ac = (e) => {
	rc.push(e);
}, oc, sc = (e) => {
	let t = Zs[e];
	if (!t) throw Error(`Entity "${e}" has no registered endpoint!`);
	let n = Qs[e];
	return n ||= Qs[e] = t(), n;
}, cc = () => (oc ||= ic($s()), oc), lc = async (e, t, n) => {
	if (!Zs[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await sc(e).get(`/${t}`, n)).data;
}, uc = async (e, t, n) => {
	if (!Zs[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await sc(e).post("", t, n)).data;
}, dc = async (e, t, n, r) => {
	if (!Zs[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await sc(e).put(`/${t}`, n, r)).data;
}, fc = async (e, t, n) => {
	if (!Zs[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await sc(e).delete(`/${t}`, n)).data;
}, pc = async (e, t) => {
	if (!Zs[e]) throw Error(`Entity "${e}" has no registered endpoint!`);
	return (await sc(e).get("", t)).data;
}, mc = (e, t = `/cms/${e.toLowerCase()}`) => (Zs[e] = () => ic($s(`${GLOBAL_CONFIG.API_BASE_URL}${t}`)), {
	getEntity: lc.bind(void 0, e),
	listEntities: pc.bind(void 0, e),
	postEntity: uc.bind(void 0, e),
	putEntity: dc.bind(void 0, e),
	deleteEntity: fc.bind(void 0, e),
	getEntityAPIClient: sc.bind(void 0, e)
}), hc = /* @__PURE__ */ A({
	__name: "bf-checkbox",
	props: { modelValue: {
		type: [Boolean, null],
		default: void 0
	} },
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = C({
			get() {
				return !!n.modelValue;
			},
			set(e) {
				r("update:modelValue", e);
			}
		});
		return (e, t) => (j(), w(P(u), je({
			modelValue: i.value,
			"onUpdate:modelValue": t[0] ||= (e) => i.value = e
		}, e.$attrs), {
			default: F(() => [He(e.$slots, "default")]),
			_: 3
		}, 16, ["modelValue"]));
	}
}), gc = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%3e%3csymbol%20id='javascript'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M14%201a1.01%201.01%200%200%201%20.25.031l.03.009c.03.009.061.02.091.031l.027.012a.914.914%200%200%201%20.195.112c.04.03.078.062.114.098l-.093-.082.011.009.082.073%206%206a1.006%201.006%200%200%201%20.21.309l.012.027c.012.03.022.06.031.091l.008.03A.921.921%200%200%201%2021%208l-.008-.126.001.01L21%208v12a3%203%200%200%201-3%203H6a3%203%200%200%201-3-3V4a3%203%200%200%201%203-3h8zm-1%202H6a1%201%200%200%200-1%201v16a1%201%200%200%200%201%201h12a1%201%200%200%200%201-1V9h-5a1%201%200%200%201-.993-.883L13%208V3zm-2.155%207.2v6.744c0%201.504-.675%202.256-2.026%202.256-.299%200-.525-.009-.679-.026v-1.282c.103.009.265.013.487.013.257%200%20.455-.062.596-.186.141-.124.212-.348.212-.673V10.2h1.41zm3.135-.112c.67%200%201.177.19%201.521.572.344.381.515.928.515%201.64v.277H14.71v-.365c0-.301-.059-.521-.176-.66-.117-.138-.289-.207-.515-.207-.227%200-.398.07-.516.207-.117.139-.176.359-.176.66%200%20.369.099.692.296.968.197.277.492.591.886.943.327.302.59.568.792.798.201.23.373.51.515.836.143.327.214.7.214%201.119%200%20.712-.176%201.259-.528%201.64-.352.381-.863.572-1.534.572-.67%200-1.181-.19-1.533-.572-.352-.381-.528-.928-.528-1.64v-.54h1.307v.628c0%20.57.24.854.717.854s.716-.284.716-.854c0-.369-.098-.692-.295-.968-.197-.277-.492-.591-.886-.943-.327-.302-.591-.568-.792-.798a3.212%203.212%200%200%201-.516-.836%202.775%202.775%200%200%201-.213-1.119c0-.712.171-1.259.515-1.64s.85-.572%201.521-.572zM15%204.415V7h2.585L15%204.415z'/%3e%3c/symbol%3e%3csymbol%20id='gallery'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M2%207a1%201%200%200%201%20.993.883L3%208v12a1%201%200%200%200%20.883.993L4%2021h12a1%201%200%200%201%20.117%201.993L16%2023H4a3%203%200%200%201-2.995-2.824L1%2020V8a1%201%200%200%201%201-1zm18-6a3%203%200%200%201%203%203v12a3%203%200%200%201-3%203H8a3.05%203.05%200%200%201-.14-.003%201.005%201.005%200%200%201-.375-.04A3.002%203.002%200%200%201%205%2016V4a3%203%200%200%201%203-3zm-2.445%208.636L10.191%2017H20a1%201%200%200%200%20.993-.883L21%2016v-2.919l-3.445-3.445zM20%203H8a1%201%200%200%200-1%201v12a1%201%200%200%200%20.498.865l9.35-9.35a1%201%200%200%201%201.32-.083l.095.083L21%2010.252V4a1%201%200%200%200-.883-.993L20%203zm-9.111%201.556a2.333%202.333%200%201%201%200%204.666%202.333%202.333%200%200%201%200-4.666zm0%202a.333.333%200%201%200%200%20.666.333.333%200%200%200%200-.666z'%20/%3e%3c/symbol%3e%3csymbol%20id='video-performance'%20viewBox='0%200%2024%2024'%20stroke='currentColor'%20fill='none'%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M1%204v6h6M23%2020v-6h-6'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M23%2014l-4.64%204.36c-1.075%201.075-2.405%201.86-3.865%202.283-1.46.423-3.004.468-4.487.133-1.483-.336-2.856-1.041-3.993-2.051C4.88%2017.715%204.017%2016.433%203.51%2015M2%208.998l4.64-4.36c1.075-1.076%202.405-1.861%203.865-2.284%201.46-.422%203.004-.468%204.487-.132%201.483.335%202.856%201.041%203.993%202.051%201.136%201.01%201.998%202.291%202.505%203.725'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M11%209l4.5%203-4.5%203V9z'/%3e%3c/symbol%3e%3csymbol%20id='flag-de'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H24V24H0V0Z'%20fill='black'/%3e%3cpath%20d='M0%208H24V24H0V8Z'%20fill='%23DD0000'/%3e%3cpath%20d='M0%2016H24V24H0V16Z'%20fill='%23FFCE00'/%3e%3c/symbol%3e%3csymbol%20id='flag-en'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23clip_a)'%3e%3cg%20clip-path='url(%23clip_b)'%3e%3cpath%20d='M-12%200V24H36V0H-12Z'%20fill='%23012169'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='white'%20stroke-width='6'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='%23C8102E'%20stroke-width='4'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='white'%20stroke-width='10'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='%23C8102E'%20stroke-width='6'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip_a'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip_b'%3e%3crect%20width='48'%20height='24'%20fill='white'%20transform='translate(-12)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/symbol%3e%3csymbol%20id='flag-it'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H8V24H0V0Z'%20fill='%23008C45'/%3e%3cpath%20d='M8%200H16V24H8V0Z'%20fill='white'/%3e%3cpath%20d='M16%200H24V24H16V0Z'%20fill='%23CD212A'/%3e%3c/symbol%3e%3c/svg%3e", _c = { key: 0 }, vc = /* @__PURE__ */ A({
	__name: "language-selector",
	props: {
		showLabel: {
			type: Boolean,
			default: !0
		},
		menuPosition: { default: "top" },
		shrinked: {
			type: Boolean,
			default: !1
		},
		flat: {
			type: Boolean,
			default: !1
		}
	},
	setup(t) {
		let n = Wa(), { t: r } = rt(), i = t, o = {
			en: ["English", "flag-en"],
			de: ["Deutsch", "flag-de"]
		}, s = Se(), c = (e) => {
			switch (e) {
				case "de":
				case "en":
					n.setLanguage(e), s.lang.set(Ja[e]);
					break;
				default: break;
			}
		}, l = C(() => `dropdown-menu dropdown-menu-${i.menuPosition}`);
		return (n, i) => (j(), w(P(a), je({
			class: t.shrinked && "shrinked",
			depressed: "",
			text: "",
			flat: t.flat
		}, n.$attrs), {
			default: F(() => [
				k(P(h), { name: "globe" }),
				t.showLabel ? (j(), E("span", _c, N(P(r)("common.language")), 1)) : T("", !0),
				k(P(te), {
					bottom: t.menuPosition === "bottom",
					"content-class": l.value,
					top: t.menuPosition === "top",
					left: "",
					"offset-y": ""
				}, {
					default: F(() => [k(P(b), { class: "text-body1" }, {
						default: F(() => [(j(), E(Ce, null, Ve(o, (t, n) => Je(k(P(_), {
							key: n,
							clickable: "",
							ripple: "",
							onClick: (e) => c(n)
						}, {
							default: F(() => [k(P(y), { avatar: "" }, {
								default: F(() => [k(P(h), {
									"custom-icon": !0,
									name: t[1],
									src: P(gc),
									class: "icon"
								}, null, 8, ["name", "src"])]),
								_: 2
							}, 1024), k(P(y), null, {
								default: F(() => [O(N(t[0]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1032, ["onClick"]), [[P(e)]])), 64))]),
						_: 1
					})]),
					_: 1
				}, 8, [
					"bottom",
					"content-class",
					"top"
				])
			]),
			_: 1
		}, 16, ["class", "flat"]));
	}
}), yc = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, bc = /* @__PURE__ */ yc(vc, [["__scopeId", "data-v-d6dcb9e8"]]), xc = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20800%20118.2'%20style='enable-background:new%200%200%20800%20118.2;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%2395C11F;}%20.st1{fill:%23F39200;}%20.st2{fill:%231D1D1B;}%20%3c/style%3e%3cpath%20class='st0'%20d='M0,0h344.1v118.2H0V0z'/%3e%3cpath%20class='st1'%20d='M344.1,0H800v118.2H344.1V0z'/%3e%3cpath%20class='st2'%20d='M41.7,20.2h39.2c7.5,0,12.9,1.9,17,4.8c4.7,3.6,7.3,9,7.2,14.9c0,7.2-3.1,11.8-9.5,14.5v0.3%20c7.9,2.5,13.4,10,13.1,18.2c0,8.1-3.3,14.3-8.7,18.2c-4.5,3.1-10.6,4.8-18.4,4.8h-40C41.7,96.1,41.7,20.2,41.7,20.2L41.7,20.2z%20M77.3,49.8c4.2,0,7.2-2,7.2-6.1s-3-6.2-7.2-6.2H63.6v12.3L77.3,49.8L77.3,49.8z%20M79.3,78.9c4.8,0,8.1-2.8,8.1-7.5%20c0-4.8-3.6-7.3-8.1-7.3H63.6v14.8C63.6,78.9,79.3,78.9,79.3,78.9z%20M149.5,96.1v-7h-0.3c-3.7,5.6-10.1,8.9-16.8,8.6%20c-12.9,0-19.3-8.6-19.3-20.8V42h20.1v30.2c0,5.6,2.5,8.6,7.2,8.6c5.1,0,8.2-3.7,8.2-9.5V42.1h20.1v54L149.5,96.1L149.5,96.1z%20M194.8,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6V96h-20.1V42h19.1%20L194.8,50.2L194.8,50.2z%20M217,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2%20c-3.1,5.8-9.3,9.3-15.9,9.3C227.5,97.8,217,87.7,217,69.1z%20M257.2,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8%20c0,8.2,3.7,14.2,9.8,14.2S257.2,76.5,257.2,68.7z%20M316.9,89.9h-0.2c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2%20c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4%20c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3v11.4c-2.8,1.1-5.8,1.6-8.9,1.6%20C322.4,97.1,318.2,94.9,316.9,89.9L316.9,89.9z%20M316.1,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5c-5.9,1.2-7.6,3-7.6,6.2%20c0,3.6,3,5.1,6.2,5.1C311.6,85.5,316.1,83.1,316.1,76.5L316.1,76.5z%20M344.1,20.2h58.5v18.7h-36.3v12.4h30v17.1h-30v27.5h-22.1%20C344.1,96.1,344.1,20.2,344.1,20.2z%20M401.4,69.2c0-16.5,11.7-28.8,29.7-28.8s29.6,12.3,29.6,28.8s-11.5,28.6-29.6,28.6%20S401.4,85.5,401.4,69.2z%20M440.3,69.2c0-9.2-3.1-15.2-9.3-15.2c-6.2,0-9.2,6.2-9.2,15.2s3,15.2,9.2,15.2%20C437.2,84.5,440.3,78.4,440.3,69.2z%20M484.6,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.3%20c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L484.6,50.2L484.6,50.2z%20M507.2,42h20.7l5.3,19.6c1.2,4.2,2.5,10.9,2.5,10.9h0.2%20c0,0,1.4-6.7,2.5-11.2l4.6-19.2h17l4.7,19.1c1.2,4.7,2.5,11.5,2.5,11.5h0.2c0,0,1.6-6.8,2.6-11l5-19.6h20.2l-17.1,54.1h-19.3%20l-5.4-22.6c-1.1-4.2-2.2-10.1-2.2-10.1H551c0,0-1.2,5.9-2.2,10.1L543.4,96h-19L507.2,42L507.2,42z%20M629.5,89.9h-0.2%20c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1%20s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3%20v11.4c-2.8,1.1-5.8,1.6-8.9,1.6C635.1,97.1,630.9,94.9,629.5,89.9L629.5,89.9z%20M628.7,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5%20c-5.9,1.2-7.6,3-7.6,6.2c0,3.6,3,5.1,6.2,5.1C624.2,85.5,628.7,83.1,628.7,76.5L628.7,76.5z%20M674.8,50.2h0.3%20c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L674.8,50.2L674.8,50.2z%20M697,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2c-3.1,5.8-9.3,9.3-15.9,9.3%20C707.4,97.8,697,87.7,697,69.1L697,69.1z%20M737.1,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8s3.7,14.2,9.8,14.2%20S737.1,76.5,737.1,68.7z'/%3e%3c/svg%3e", Sc = { class: "d-flex flex-column justify-center align-center" }, Cc = ["src"], wc = { class: "text-center mb-4" }, Tc = /* @__PURE__ */ A({
	__name: "modal-reload",
	props: {
		reloadMsg: { default: "" },
		offline: {
			type: Boolean,
			default: !1
		},
		forceUpdate: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["close"],
	setup(e, { emit: t }) {
		let n = t, { t: r } = rt(), o = () => window.location.reload(), u = () => n("close");
		return (t, n) => (j(), E("div", Sc, [k(P(s), {
			class: "pa-8",
			style: { width: "435px" }
		}, {
			default: F(() => [
				k(P(i), { class: "text-center bg-white" }, {
					default: F(() => [e.offline ? T("", !0) : (j(), w(P(he), { key: 0 }, {
						default: F(() => [D("img", {
							src: P(xc),
							style: { height: "40px" },
							class: "align-self-center"
						}, null, 8, Cc)]),
						_: 1
					})), !e.offline && !e.forceUpdate ? (j(), w(P(a), {
						key: 1,
						class: "float-right",
						flat: "",
						round: "",
						dense: "",
						icon: "close",
						onClick: u
					})) : T("", !0)]),
					_: 1
				}),
				k(P(l), { class: "pt-4 text-center" }, {
					default: F(() => [D("h2", wc, N(e.reloadMsg), 1)]),
					_: 1
				}),
				k(P(c), { align: "center" }, {
					default: F(() => [e.offline ? T("", !0) : (j(), w(P(a), {
						key: 0,
						color: "primary",
						block: "",
						onClick: o
					}, {
						default: F(() => [O(N(P(r)("pingApi.reload")), 1)]),
						_: 1
					}))]),
					_: 1
				})
			]),
			_: 1
		})]));
	}
}), Ec = (e, t) => e === t ? !0 : t.startsWith(`${e}:`), Dc = (e, t) => {
	for (let n of e) if (Ec(n, t)) return !0;
	return !1;
}, Oc, kc = (e) => Oc = e, Ac = () => {
	if (!Oc) throw Error("Router not yet initialized!");
	return Oc;
}, jc = mc("CmsUserModelName ", "/cms/users"), { getEntity: Mc, listEntities: Nc, putEntity: Pc } = jc, Fc = async (e) => Mc(e), Ic = async (e) => Nc({ params: {
	search: e,
	page: 1
} }), Lc = async (e = !0) => (await cc().get("/cms/session/currentUser", { handleError: e })).data, Rc = async (e) => {
	let { _id: t, ...n } = e;
	return Pc(t, n);
}, zc = async (e, t) => (await cc().put(`/cms/users/${e}/additional-rights`, { additionalRights: t })).data, Bc = async () => (await cc().get("/cms/session/rights-meta")).data, Vc = "authentik:", Hc = "vibe_sso_provider", Uc = "vibe_sso_redirect_uri", Wc = "vibe_sso_oauth_state", Gc = "vibe_sso_code_in_flight", Kc = "vibe_sso_code_in_flight_at", qc = () => `${Vc}${crypto.randomUUID()}`, Jc = (e) => !!e?.startsWith(Vc), Yc = (e) => {
	if (!Jc(e)) return !1;
	let t = sessionStorage.getItem(Wc);
	return !!(t && e === t);
}, Xc = async (e, t = "cognito", n, r) => (await cc().post("/cms/session/authenticate", {
	code: e,
	provider: t,
	...n ? { redirectUri: n } : {},
	...r ? { oauthClientId: r } : {}
}, { handleError: !1 })).data, Zc = async () => (await cc().delete("/cms/session/logout")).data, { getEntity: Qc } = mc("authors"), $c = so(), el = {
	loaded: !1,
	loggedIn: !1,
	name: "",
	userId: "",
	group: "External",
	isEnabled: !1,
	avatarUuid: "",
	authorUuid: "",
	email: "",
	rights: [],
	wasLoggedIn: !1,
	expiredToken: !1,
	seenUpdateModal: !1,
	get fullName() {
		return this.name;
	},
	hasRight(e) {
		return (Array.isArray(e) ? e : [e]).every((e) => Dc(this.rights, e));
	},
	resetCurrentUser(e = !1) {
		Object.assign(tl, el), e && (this.expiredToken = !0), this.wasLoggedIn = !0;
	},
	async loadAvatarUuid(e) {
		let t = await Qc(e);
		this.avatarUuid = t.imageUuid || "";
	},
	async loadCurrentUser() {
		try {
			this.loaded = !1;
			let e = await Lc(!1);
			this.loaded = !0, this.wasLoggedIn = !0, this.loggedIn = !0, this.expiredToken = !1, this.applyUser(e), this.group === "NewUser" && $c.showNotification(new ao(B().t("login.newUserNotification"), "info", { multiLine: !0 })), e.authorUuid && (this.authorUuid = e.authorUuid, await this.loadAvatarUuid(e.authorUuid));
		} catch (e) {
			console.error(e), this.loaded = !0;
		}
		return this;
	},
	async logoutCurrentUser() {
		await Zc(), this.userId = "", this.loggedIn = !1, this.wasLoggedIn = !1, this.name = "", this.group = "External", window.localStorage.clear(), await Ac().replace("/login");
	},
	async authenticate(e, t = "cognito", n, r) {
		let i = await Xc(e, t, n, r);
		this.applyUser(i), this.loggedIn = !0;
	},
	applyUser(e) {
		this.isEnabled = e.isEnabled, this.name = e.name, this.group = e.group, this.userId = e._id, this.rights = e.rights;
	}
}, tl = Be({ ...el }), nl = () => tl, rl = (e) => {
	if (e.config?.handleError === !1) return Promise.reject(e);
	if (e instanceof ya) {
		let t = so();
		((t) => e.response?.status === 401 && e.response?.data.type === "UnauthenticatedInCMSError")(e) && !tl.expiredToken && tl.loggedIn && (t.showNotification(new ao(B().t("login.sessionExpired"), "negative", { timeout: ao.NO_TIMEOUT })), tl.resetCurrentUser(!0), tl.loaded = !0), e.response?.status === 403 && t.showNotification(new ao(e.response?.data.message));
	}
	return Promise.reject(e);
}, il = "/brands", al = "/logos", q = (e) => `${il}/${e}`, ol = (e) => `${al}/${e}`, sl = (e) => e.replace(/\s/g, "-").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ä/g, "ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/Ä/g, "Ae").replace(/ß/g, "ss").replace(/[^\w\d\s-]/g, "").replace(/-+/g, "-").replace(/-+$/g, "");
//#endregion
//#region src/utils/validation.ts
function cl(e) {
	return /^(?:(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@(?:(?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(e).toLowerCase());
}
function ll(e) {
	return /\d/.test(e);
}
function ul(e) {
	return /[A-Z]/.test(e);
}
function dl(e) {
	return /[a-z]/.test(e);
}
function fl(e) {
	return /^[\w\d/-]+$/g.test(e);
}
function pl(e) {
	return /^\d+$/.test(e);
}
function ml(e) {
	return /^\/.*$/.test(e);
}
function hl(e) {
	return /^\d+$/.test(e) && parseInt(e) < 11;
}
function gl(e) {
	return /^\d+$/.test(e) && parseInt(e) > -1;
}
function _l(e) {
	return e ? /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(e) : !0;
}
function vl(e) {
	return mo(Fs(e, "dd.MM.yyyy", 0));
}
function yl(e) {
	let t = Fs(e, "dd.MM.yyyy", 0), n = /* @__PURE__ */ new Date();
	return mo(t) && t <= n;
}
function bl(e) {
	return mo(Fs(e, "dd.MM.yyyy HH:mm", 0));
}
function xl(e) {
	return e[0] !== " ";
}
function Sl(e) {
	return Array.isArray(e) ? !!e?.length : typeof e == "object" ? !!e?.uuid || !!e?._id : !!e?.length;
}
var Cl = (e, t) => !e || !t || t.includes(e);
function wl(e, t) {
	return !t || t.trim().length >= e;
}
function Tl(e) {
	return !e || e.trim().length >= 1;
}
function J(e, t) {
	return Object.assign(e, { aiHint: t });
}
var El = {
	required: J((e) => Sl(e) || B().t("validation.required"), "Must not be empty."),
	validateRequiredRichTextValue: J((e) => !!e && e.trim() !== "<p></p>", "Must contain non-empty content."),
	numberRequired: J((e) => !!e || B().t("validation.required"), "A number is required."),
	equalOrMoreThan: (e) => J((t) => t >= e || `${B().t("validation.moreThan")} ${e}`, `Must be greater than or equal to ${e}.`),
	equalOrLessThan: (e) => J((t) => t <= e || `${B().t("validation.lessThan")} ${e}`, `Must be less than or equal to ${e}.`),
	minLength: (e) => J((t) => t.length >= e || `${B().t("validation.minLength1")} ${e} ${B().t("validation.minLength2")}`, `Minimum ${e} characters.`),
	maxLength: (e) => J((t) => !t || t.length <= e || `${B().t("validation.maxLength1")} ${e} ${B().t("validation.maxLength2")}`, `Maximum ${e} characters.`),
	exactLengthNumbers: (e) => J((t) => t.length >= e || `${B().t("validation.exactLengthNumber1")} ${e} ${B().t("validation.exactLengthNumber2")}`, `Minimum ${e} characters.`),
	containNumber: J((e) => ll(e) || B().t("validation.containNumber"), "Must contain at least one number."),
	containLowercase: J((e) => dl(e) || B().t("validation.containLowercase"), "Must contain at least one lowercase letter."),
	containUppercase: J((e) => ul(e) || B().t("validation.containUppercase"), "Must contain at least one uppercase letter."),
	containSubstring: (e, t) => J((n) => Cl(e, n) || B().t(t || "validation.containSubstring"), `Must contain the substring "${e ?? ""}".`),
	validEmail: J((e) => cl(e) || B().t("validation.validEmail"), "Must be a valid email address."),
	validEmailOptional: J((e) => !e || cl(e) || B().t("validation.validEmail"), "Must be a valid email address if provided."),
	validPath: J((e) => fl(e) || B().t("validation.validPath"), "Must be a valid path."),
	validDate: J((e) => vl(e) || B().t("validation.validDate"), "Must be a valid date (dd.MM.yyyy)."),
	validateDateNotInFuture: J((e) => !e || yl(e) || B().t("validation.validDateNotInFuture"), "Must be a valid date not in the future."),
	validDateTime: J((e) => bl(e) || B().t("validation.validDateTime"), "Must be a valid date and time (dd.MM.yyyy HH:mm)."),
	validDateTimeOptional: J((e) => !e || bl(e) || B().t("validation.validDateTime"), "Must be a valid date and time if provided."),
	notContainHTML: J((e) => !e.includes(".html") || B().t("validation.notContainHTML"), "Must not contain \".html\"."),
	isNumeric: J((e) => pl(e) || B().t("validation.isNumeric"), "Must contain only digits."),
	isRelativePath: J((e) => ml(e) || B().t("validation.isRelativePath"), "Must be a relative path starting with \"/\"."),
	lessThan11: J((e) => hl(e) || B().t("validation.lessThan11"), "Must be a number less than 11."),
	validUrl: J((e) => _l(e) || B().t("validation.validURL"), "Must be a valid URL."),
	higherorEqualto0: J((e) => gl(e) || B().t("validation.higherEqual0"), "Must be a number greater than or equal to 0."),
	positiveNumberOrUndefined: J((e) => !e || gl(e) || B().t("validation.higherEqual0"), "Must be a number greater than or equal to 0 if provided."),
	noStartingWhiteSpace: J((e) => xl(e) || B().t("channels.checkWhiteSpace"), "Must not start with a whitespace character."),
	requiredCharsCount: (e) => J((t) => wl(e, t) || `${B().t("validation.required")}`, `Minimum ${e} non-whitespace characters.`),
	noBlankString: J((e) => Tl(e) || B().t("validation.required"), "Must not consist only of whitespace."),
	hasCorrectBrandLicense: J((e, t) => !t || !e?._id || e?.license?.includes(t) || e?.brand === t || B().t("articles.errorAssetLicense"), "Must have the correct brand license."),
	slugValidation: J((e, t) => t.isRootChannel ? !0 : !!e || B().t("validation.required"), "Must be a valid slug (required unless the channel is a root channel)."),
	validPublishState: J((e) => e?.state === "publish" || B().t("validation.validPublishState"), "Must be in the published state.")
}, Dl = new Set([
	"script",
	"style",
	"iframe",
	"object",
	"embed",
	"link",
	"meta",
	"base",
	"form",
	"input",
	"button",
	"textarea"
]), Ol = new Set([
	"href",
	"src",
	"xlink:href"
]);
function kl(e) {
	let t = e.replace(/[\u0000-\u0020]+/g, "").toLowerCase();
	return t.startsWith("javascript:") || t.startsWith("data:") || t.startsWith("vbscript:");
}
function Al(e) {
	let t = e.parentNode;
	if (t) {
		for (; e.firstChild;) t.insertBefore(e.firstChild, e);
		t.removeChild(e);
	}
}
function jl(e, t) {
	if (typeof document > "u" || typeof document.createElement != "function") return e.replace(/<[^>]*>/g, "");
	let n = t ? new Set(t.map((e) => e.toLowerCase())) : void 0, r = document.createElement("template");
	r.innerHTML = e;
	for (let e of Array.from(r.content.querySelectorAll("*"))) {
		let t = e.tagName.toLowerCase();
		if (Dl.has(t)) {
			e.remove();
			continue;
		}
		for (let t of Array.from(e.attributes)) {
			let n = t.name.toLowerCase();
			(n.startsWith("on") || Ol.has(n) && kl(t.value)) && e.removeAttribute(t.name);
		}
		n && !n.has(t) && Al(e);
	}
	return r.innerHTML;
}
//#endregion
//#region src/ai-assist/textDiff.ts
var Ml = 1e7;
function Nl(e) {
	return e.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"");
}
function Pl(e) {
	return Nl(e.replace(/<\s*br\s*\/?\s*>/gi, "\n").replace(/<\s*\/\s*(p|div|li|h[1-6]|blockquote)\s*>/gi, "\n").replace(/<[^>]*>/g, "")).replace(/[ \t]+/g, " ").replace(/ *\n */g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}
function Fl(e) {
	return e.split(/(\s+)/).filter((e) => e.length > 0);
}
function Il(e, t, n) {
	let r = e.length, i = t.length, a = e.map(n), o = t.map(n), s = Math.min(r, i), c = 0;
	for (; c < s && a[c] === o[c];) c++;
	let l = 0;
	for (; l < s - c && a[r - 1 - l] === o[i - 1 - l];) l++;
	let u = r - c - l, d = i - c - l;
	if (u * d > Ml) return null;
	let f = [];
	for (let n = 0; n < c; n++) f.push({
		type: "equal",
		a: e[n],
		b: t[n]
	});
	let p = d + 1, m = new Int32Array((u + 1) * p);
	for (let e = u - 1; e >= 0; e--) {
		let t = a[c + e];
		for (let n = d - 1; n >= 0; n--) m[e * p + n] = t === o[c + n] ? (m[(e + 1) * p + n + 1] ?? 0) + 1 : Math.max(m[(e + 1) * p + n] ?? 0, m[e * p + n + 1] ?? 0);
	}
	let h = 0, g = 0;
	for (; h < u && g < d;) a[c + h] === o[c + g] ? (f.push({
		type: "equal",
		a: e[c + h],
		b: t[c + g]
	}), h++, g++) : (m[(h + 1) * p + g] ?? 0) >= (m[h * p + g + 1] ?? 0) ? (f.push({
		type: "delete",
		a: e[c + h]
	}), h++) : (f.push({
		type: "insert",
		b: t[c + g]
	}), g++);
	for (; h < u;) f.push({
		type: "delete",
		a: e[c + h]
	}), h++;
	for (; g < d;) f.push({
		type: "insert",
		b: t[c + g]
	}), g++;
	for (let n = 0; n < l; n++) f.push({
		type: "equal",
		a: e[r - l + n],
		b: t[i - l + n]
	});
	return f;
}
function Ll(e, t, n) {
	let r = e[e.length - 1];
	r && r.type === t ? r.text += n : e.push({
		type: t,
		text: n
	});
}
function Rl(e, t) {
	let n = Fl(e), r = Fl(t);
	if (n.length === 0 && r.length === 0) return [];
	let i = Il(n, r, (e) => e);
	if (i === null) return t ? [{
		type: "insert",
		text: t
	}] : [];
	let a = [];
	for (let e of i) e.type === "delete" ? Ll(a, "delete", e.a ?? "") : e.type === "insert" ? Ll(a, "insert", e.b ?? "") : Ll(a, "equal", e.b ?? "");
	return a;
}
var zl = new Set(["strong", "b"]), Bl = new Set(["em", "i"]), Vl = new Set([
	"p",
	"div",
	"li",
	"blockquote",
	"ul",
	"ol",
	"tr",
	"section",
	"article"
]);
function Hl(e, t) {
	return e.bold === t.bold && e.italic === t.italic && e.link === t.link && e.heading === t.heading;
}
function Ul(e, t) {
	let n = [];
	return e.bold !== t.bold && n.push("bold"), e.italic !== t.italic && n.push("italic"), e.link !== t.link && n.push("link"), e.heading !== t.heading && n.push("heading"), n;
}
function Wl(e, t) {
	return !e && !t ? !0 : !e || !t || e.length !== t.length ? !1 : e.every((e, n) => e === t[n]);
}
function Gl(e) {
	let t = [], n = 0, r = 0, i = [], a = [], o = () => ({
		bold: n > 0,
		italic: r > 0,
		link: i.length ? i[i.length - 1] ?? null : null,
		heading: a.length ? a[a.length - 1] ?? 0 : 0
	}), s = () => {
		t.push({
			text: "\n",
			marks: o()
		});
	}, c = /<[^>]+>|[^<]+/g, l;
	for (; (l = c.exec(e)) !== null;) {
		let e = l[0];
		if (e.startsWith("<")) {
			let t = /^<\s*(\/)?\s*([a-zA-Z][a-zA-Z0-9]*)\b([^>]*?)\/?>$/.exec(e);
			if (!t) continue;
			let o = t[1] === "/", c = (t[2] ?? "").toLowerCase(), l = t[3] ?? "", u = /^h([1-6])$/.exec(c);
			if (c === "br") s();
			else if (zl.has(c)) n = Math.max(0, n + (o ? -1 : 1));
			else if (Bl.has(c)) r = Math.max(0, r + (o ? -1 : 1));
			else if (c === "a") if (o) i.pop();
			else {
				let e = /href\s*=\s*("([^"]*)"|'([^']*)')/i.exec(l);
				i.push(e ? e[2] ?? e[3] ?? "" : "");
			}
			else u ? o ? (a.pop(), s()) : a.push(Number(u[1])) : o && Vl.has(c) && s();
			continue;
		}
		for (let n of Nl(e).split(/(\s+)/)) n.length > 0 && t.push({
			text: n,
			marks: o()
		});
	}
	return t;
}
function Kl(e, t) {
	let n = e[e.length - 1];
	n && n.type === t.type && Hl(n.marks, t.marks) && Wl(n.changed, t.changed) ? n.text += t.text : e.push(t);
}
function ql(e) {
	let t = [], n = [];
	for (let r of e) n.push(r), r.text === "\n" && (t.push(n), n = []);
	return n.length && t.push(n), t;
}
function Jl(e, t, n) {
	let r = Il(e, t, (e) => e.text);
	if (r === null) return !1;
	for (let e of r) if (e.type === "insert" && e.b) Kl(n, {
		type: "insert",
		text: e.b.text,
		marks: e.b.marks
	});
	else if (e.type === "delete" && e.a) Kl(n, {
		type: "delete",
		text: e.a.text,
		marks: e.a.marks
	});
	else if (e.a && e.b) {
		let { text: t } = e.b;
		t.trim() && !Hl(e.a.marks, e.b.marks) ? Kl(n, {
			type: "format",
			text: t,
			marks: e.b.marks,
			changed: Ul(e.a.marks, e.b.marks)
		}) : Kl(n, {
			type: "equal",
			text: t,
			marks: e.b.marks
		});
	}
	return !0;
}
function Yl(e, t) {
	let n = Gl(e), r = Gl(t);
	if (n.length === 0 && r.length === 0) return {
		tooLarge: !1,
		segments: []
	};
	let i = Il(ql(n), ql(r), (e) => e.map((e) => e.text).join(""));
	if (i === null) return {
		tooLarge: !0,
		segments: []
	};
	let a = [], o = [], s = [], c = () => {
		if (o.length === 0 && s.length === 0) return !0;
		let e = !0;
		if (o.length === s.length) for (let t = 0; t < o.length && e; t++) e = Jl(o[t] ?? [], s[t] ?? [], a);
		else e = Jl(o.flat(), s.flat(), a);
		return o = [], s = [], e;
	};
	for (let e of i) if (e.type === "delete" && e.a) o.push(e.a);
	else if (e.type === "insert" && e.b) s.push(e.b);
	else if (e.a && e.b && (!c() || !Jl(e.a, e.b, a))) return {
		tooLarge: !0,
		segments: []
	};
	return c() ? {
		tooLarge: !1,
		segments: a
	} : {
		tooLarge: !0,
		segments: []
	};
}
//#endregion
//#region src/ai-assist/types.ts
var Xl = [
	"basic",
	"correct",
	"seo"
], Zl = {
	class: "vaibe-lockup",
	role: "img",
	"aria-label": "VAIBE"
}, Ql = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "vaibe-lockup",
	setup(e) {
		return (e, t) => (j(), E("span", Zl, [k(P(h), {
			name: "ai-generated-icon",
			size: "17px",
			class: "vaibe-lockup__icon"
		}), t[0] ||= D("svg", {
			class: "vaibe-lockup__wordmark",
			width: "52.05",
			height: "17.488",
			viewBox: "0 0 53 18",
			fill: "none",
			"aria-hidden": "true",
			focusable: "false"
		}, [
			D("path", {
				d: "M7.14844 14.4727L12.1758 0H14.625L8.30859 17.0625H6.5625L7.14844 14.4727ZM2.44922 0L7.42969 14.4727L8.05078 17.0625H6.30469L0 0H2.44922Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M17.5955 2.58984L12.7322 17.0625H9.32203L15.697 0H17.8767L17.5955 2.58984ZM21.6619 17.0625L16.7752 2.58984L16.4822 0H18.6736L25.0837 17.0625H21.6619ZM21.4392 10.7227V13.2656H12.2869V10.7227H21.4392Z",
				fill: "#00636C"
			}),
			D("path", {
				d: "M26.6452 0V17.0625H26.1602L24.6602 13.0625V0H26.6452Z",
				fill: "#00636C"
			}),
			D("path", {
				d: "M28.8642 0V17.0625H26.6452V0H28.8642Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M35.4595 9.08203H31.1353L31.1119 7.26563H35.0377C35.6861 7.26563 36.2525 7.15625 36.7369 6.9375C37.2213 6.71875 37.5963 6.40625 37.8619 6C38.1353 5.58594 38.272 5.09375 38.272 4.52344C38.272 3.89844 38.1509 3.39063 37.9088 3C37.6744 2.60156 37.3111 2.3125 36.8189 2.13281C36.3345 1.94531 35.7173 1.85156 34.9673 1.85156H31.6392V17.0625H29.3775V0H34.9673C35.8423 0 36.6236 0.0898438 37.3111 0.269531C37.9986 0.441406 38.5806 0.714844 39.0572 1.08984C39.5416 1.45703 39.9088 1.92578 40.1588 2.49609C40.4088 3.06641 40.5338 3.75 40.5338 4.54688C40.5338 5.25 40.3541 5.88672 39.9947 6.45703C39.6353 7.01953 39.1353 7.48047 38.4947 7.83984C37.8619 8.19922 37.1197 8.42969 36.2681 8.53125L35.4595 9.08203ZM35.3541 17.0625H30.2447L31.522 15.2227H35.3541C36.0728 15.2227 36.6822 15.0977 37.1822 14.8477C37.69 14.5977 38.0767 14.2461 38.3423 13.793C38.608 13.332 38.7408 12.7891 38.7408 12.1641C38.7408 11.5312 38.6275 10.9844 38.4009 10.5234C38.1744 10.0625 37.8189 9.70703 37.3345 9.45703C36.8502 9.20703 36.2252 9.08203 35.4595 9.08203H32.2369L32.2603 7.26563H36.6666L37.147 7.92187C37.9673 7.99219 38.6627 8.22656 39.233 8.625C39.8033 9.01562 40.2369 9.51562 40.5338 10.125C40.8384 10.7344 40.9908 11.4062 40.9908 12.1406C40.9908 13.2031 40.7564 14.1016 40.2877 14.8359C39.8267 15.5625 39.1744 16.1172 38.3306 16.5C37.4869 16.875 36.4947 17.0625 35.3541 17.0625Z",
				fill: "currentColor"
			}),
			D("path", {
				d: "M52.0505 15.2227V17.0625H43.0153V15.2227H52.0505ZM43.4723 0V17.0625H41.2106V0H43.4723ZM50.8552 7.33594V9.17578H43.0153V7.33594H50.8552ZM51.9333 0V1.85156H43.0153V0H51.9333Z",
				fill: "currentColor"
			})
		], -1)]));
	}
}), [["__scopeId", "data-v-de309827"]]), $l = { class: "col ellipsis" }, eu = { class: "text-h6 ellipsis" }, tu = { class: "row q-col-gutter-md" }, nu = { class: "col-6" }, ru = { class: "text-subtitle2 text-grey-7 q-mb-xs" }, iu = {
	class: "ai-assist-panel",
	"data-qa-ai-field-assist-original": ""
}, au = ["innerHTML"], ou = { class: "col-6" }, su = { class: "row items-center justify-between no-wrap q-mb-xs" }, cu = { class: "text-subtitle2 text-grey-7" }, lu = {
	key: 0,
	class: "relative-position"
}, uu = {
	class: "ai-assist-panel",
	"data-qa-ai-field-assist-result": ""
}, du = {
	key: 0,
	class: "column items-center justify-center full-height"
}, fu = { class: "text-grey-6 q-mt-sm" }, pu = {
	key: 1,
	class: "text-negative"
}, mu = {
	key: 0,
	class: "ai-diff"
}, hu = ["title"], gu = ["innerHTML"], _u = {
	key: 3,
	class: "text-grey-5"
}, vu = { class: "row q-gutter-xs q-mb-sm" }, yu = {
	key: 0,
	class: "q-mb-sm"
}, bu = { class: "text-caption text-grey-6 q-ml-lg" }, xu = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "ai-assist.dialog",
	props: {
		descriptor: {},
		engine: {}
	},
	emits: [...xe.emits],
	setup(t) {
		let n = t, { dialogRef: r, onDialogHide: i, onDialogOK: o } = xe(), { t: f } = rt(), m = M(""), h = M(void 0), g = M(!1), _ = M(void 0), v = M(void 0), y = M(!1), b = M(!1), te = C(() => n.descriptor.label || f("aiFieldAssist.fieldFallback")), ne = C(() => n.descriptor.rules.format === "html"), x = C(() => _.value !== void 0), re = C(() => !!m.value.trim() || !!h.value), ie = C(() => jl(n.descriptor.value, n.descriptor.rules.allowedTags)), ae = C(() => _.value === void 0 ? "" : jl(_.value, n.descriptor.rules.allowedTags)), se = C(() => n.descriptor.offeredContext ?? []), ce = M(!1), le = C(() => ne.value && b.value && _.value !== void 0 ? Yl(n.descriptor.value, _.value) : {
			tooLarge: !1,
			segments: []
		}), S = C(() => le.value.segments);
		qe(le, (e) => {
			e.tooLarge && (ce.value = !0, b.value = !1);
		});
		let ue = C(() => ne.value && x.value && !g.value), de = C(() => ue.value && ce.value);
		function fe(e) {
			let t = e.text.trim().length > 0;
			return [
				`ai-diff__${e.type}`,
				t && e.marks.bold && "ai-diff__bold",
				t && e.marks.italic && "ai-diff__italic",
				t && !!e.marks.link && "ai-diff__link",
				t && e.marks.heading > 0 && "ai-diff__heading"
			];
		}
		function pe(e) {
			if (!(e.type !== "format" || !e.changed?.length)) return f("aiFieldAssist.formatChanged", { marks: e.changed.map((e) => f(`aiFieldAssist.marks.${e}`)).join(", ") });
		}
		let he = C(() => (n.descriptor.actions ?? Xl).map((e) => ({
			value: e,
			label: f(`aiFieldAssist.actions.${e}`),
			hint: f(`aiFieldAssist.actionHints.${e}`)
		})));
		function _e(e) {
			h.value = h.value === e ? void 0 : e;
		}
		let ve;
		async function ye() {
			if (!re.value || g.value) return;
			ve?.abort(), ve = new AbortController();
			let { signal: e } = ve;
			g.value = !0, v.value = void 0, b.value = !1, ce.value = !1;
			try {
				let t = await n.engine.run({
					value: n.descriptor.value,
					rules: n.descriptor.rules,
					context: y.value && se.value.length ? se.value : void 0,
					action: h.value,
					freePrompt: m.value.trim() || void 0
				}, { signal: e });
				if (e.aborted) return;
				t.status === "completed" && t.result !== void 0 ? _.value = t.result : v.value = f("aiFieldAssist.error");
			} catch {
				e.aborted || (v.value = f("aiFieldAssist.error"));
			} finally {
				g.value = !1;
			}
		}
		Ie(() => ve?.abort());
		function be() {
			_.value !== void 0 && (n.descriptor.apply(_.value), o());
		}
		return (n, o) => (j(), w(P(p), {
			ref_key: "dialogRef",
			ref: r,
			"data-qa-ai-field-assist-dialog": "",
			onHide: P(i)
		}, {
			default: F(() => [k(P(s), { class: "ai-assist-dialog" }, {
				default: F(() => [
					k(P(l), { class: "row items-center q-pb-none no-wrap" }, {
						default: F(() => [
							D("div", $l, [D("div", eu, N(te.value), 1)]),
							k(Ql, { class: "q-mx-sm" }),
							Je(k(P(a), {
								"data-qa-ai-field-assist-dismiss-button": "",
								icon: "close",
								flat: "",
								round: "",
								dense: ""
							}, null, 512), [[P(e)]])
						]),
						_: 1
					}),
					k(P(l), null, {
						default: F(() => [D("div", tu, [D("div", nu, [D("div", ru, N(P(f)("aiFieldAssist.original")), 1), D("div", iu, [ne.value ? (j(), E("div", {
							key: 0,
							innerHTML: ie.value
						}, null, 8, au)) : (j(), E(Ce, { key: 1 }, [O(N(t.descriptor.value), 1)], 64))])]), D("div", ou, [D("div", su, [D("div", cu, N(P(f)("aiFieldAssist.result")), 1), ue.value ? (j(), E("div", lu, [k(P(me), {
							modelValue: b.value,
							"onUpdate:modelValue": o[0] ||= (e) => b.value = e,
							"data-qa-ai-field-assist-diff-toggle": "",
							dense: "",
							size: "sm",
							disable: de.value,
							label: P(f)("aiFieldAssist.showChanges")
						}, null, 8, [
							"modelValue",
							"disable",
							"label"
						]), de.value ? (j(), w(P(ge), {
							key: 0,
							anchor: "top middle",
							self: "bottom middle",
							"data-qa-ai-field-assist-diff-too-large": ""
						}, {
							default: F(() => [O(N(P(f)("aiFieldAssist.diffTooLarge")), 1)]),
							_: 1
						})) : T("", !0)])) : T("", !0)]), D("div", uu, [g.value ? (j(), E("div", du, [k(P(oe), {
							color: "primary",
							size: "40px"
						}), D("div", fu, N(P(f)("aiFieldAssist.loading")), 1)])) : v.value ? (j(), E("div", pu, N(v.value), 1)) : _.value === void 0 ? (j(), E("div", _u, N(P(f)("aiFieldAssist.resultPlaceholder")), 1)) : (j(), E(Ce, { key: 2 }, [b.value && !de.value ? (j(), E("div", mu, [(j(!0), E(Ce, null, Ve(S.value, (e, t) => (j(), E("span", {
							key: t,
							class: Ne(fe(e)),
							title: pe(e)
						}, N(e.text), 11, hu))), 128))])) : ne.value ? (j(), E("div", {
							key: 1,
							innerHTML: ae.value
						}, null, 8, gu)) : (j(), E(Ce, { key: 2 }, [O(N(_.value), 1)], 64))], 64))])])])]),
						_: 1
					}),
					k(P(l), { class: "q-pt-none" }, {
						default: F(() => [
							D("div", vu, [(j(!0), E(Ce, null, Ve(he.value, (e) => (j(), w(P(d), {
								key: e.value,
								"data-qa-ai-field-assist-action": e.value,
								clickable: "",
								color: h.value === e.value ? "primary" : "cyan-1",
								"text-color": h.value === e.value ? "white" : "dark",
								disable: g.value,
								onClick: (t) => _e(e.value)
							}, {
								default: F(() => [O(N(e.label) + " ", 1), k(P(ge), {
									anchor: "top middle",
									self: "bottom middle"
								}, {
									default: F(() => [O(N(e.hint), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, [
								"data-qa-ai-field-assist-action",
								"color",
								"text-color",
								"disable",
								"onClick"
							]))), 128))]),
							se.value.length ? (j(), E("div", yu, [k(P(u), {
								modelValue: y.value,
								"onUpdate:modelValue": o[1] ||= (e) => y.value = e,
								"data-qa-ai-field-assist-context-checkbox": "",
								dense: "",
								size: "sm",
								disable: g.value,
								label: P(f)("aiFieldAssist.useContext")
							}, null, 8, [
								"modelValue",
								"disable",
								"label"
							]), D("div", bu, N(P(f)("aiFieldAssist.useContextHint")), 1)])) : T("", !0),
							k(P(ee), {
								modelValue: m.value,
								"onUpdate:modelValue": o[2] ||= (e) => m.value = e,
								"data-qa-ai-field-assist-prompt-input": "",
								type: "textarea",
								autogrow: "",
								outlined: "",
								dense: "",
								disable: g.value,
								label: P(f)("aiFieldAssist.promptLabel"),
								onKeyup: Ye(Xe(ye, ["ctrl"]), ["enter"])
							}, null, 8, [
								"modelValue",
								"disable",
								"label",
								"onKeyup"
							])
						]),
						_: 1
					}),
					k(P(c), { class: "q-px-md q-pb-md" }, {
						default: F(() => [
							x.value ? (j(), w(P(a), {
								key: 0,
								"data-qa-ai-field-assist-retry-button": "",
								color: "primary",
								icon: "refresh",
								label: P(f)("aiFieldAssist.regenerate"),
								disable: g.value || !re.value,
								onClick: ye
							}, null, 8, ["label", "disable"])) : (j(), w(P(a), {
								key: 1,
								"data-qa-ai-field-assist-generate-button": "",
								color: "primary",
								icon: "ai-prompt",
								label: P(f)("aiFieldAssist.generate"),
								disable: g.value || !re.value,
								onClick: ye
							}, null, 8, ["label", "disable"])),
							Je(k(P(a), {
								"data-qa-ai-field-assist-cancel-button": "",
								outline: "",
								color: "secondary",
								icon: "close",
								label: P(f)("aiFieldAssist.cancel")
							}, null, 8, ["label"]), [[P(e)]]),
							x.value ? (j(), w(P(a), {
								key: 2,
								"data-qa-ai-field-assist-accept-button": "",
								color: "positive",
								icon: "check",
								label: P(f)("aiFieldAssist.accept"),
								disable: g.value,
								onClick: be
							}, null, 8, ["label", "disable"])) : T("", !0)
						]),
						_: 1
					})
				]),
				_: 1
			})]),
			_: 1
		}, 8, ["onHide"]));
	}
}), [["__scopeId", "data-v-05bc86b3"]]), Su = Symbol("AiEngine");
function Cu(e) {
	ze(Su, e);
}
function wu() {
	return Oe(Su, void 0);
}
var Tu = Symbol("AiContextResolver");
function Eu(e) {
	ze(Tu, e);
}
function Du() {
	return Oe(Tu, void 0);
}
//#endregion
//#region src/ai-assist/useAiAssist.ts
function Ou() {
	let e = wu(), n = C(() => !!e);
	function r(n) {
		e && t.create({
			component: xu,
			componentProps: {
				descriptor: n,
				engine: e
			}
		});
	}
	return {
		isAvailable: n,
		openAiAssist: r
	};
}
//#endregion
//#region src/ai-assist/ai-assist.button.vue
var ku = /* @__PURE__ */ A({
	__name: "ai-assist.button",
	props: { getDescriptor: { type: Function } },
	setup(e) {
		let t = e, { t: n } = rt(), { isAvailable: r, openAiAssist: i } = Ou();
		function o() {
			i(t.getDescriptor());
		}
		return (e, t) => P(r) ? (j(), w(P(a), {
			key: 0,
			"data-qa-ai-field-assist-button": "",
			flat: "",
			dense: "",
			round: "",
			size: "md",
			icon: "ai-prompt",
			color: "primary",
			onClick: Xe(o, ["stop"])
		}, {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "bottom middle"
			}, {
				default: F(() => [O(N(P(n)("aiFieldAssist.buttonTooltip")), 1)]),
				_: 1
			})]),
			_: 1
		})) : T("", !0);
	}
}), Au = "You edit a single content field for a CMS editor.\nReturn ONLY the resulting field value.\nDo not add explanations, comments, labels, surrounding quotes, or follow-up questions.\nKeep the same language as the input unless the instruction explicitly asks to translate.\n\nSafety rules (always apply; they override stylistic goals):\n\n1) Sources & attribution\n- Keep all source references, citations, links, footnotes, and attribution markers.\n- Do not remove, rewrite, or relocate them unless the editor instruction explicitly asks to change sources.\n\n2) Facts & meaning\n- Preserve factual meaning, names, numbers, products, and specific terms (e.g. do not turn \"Autobahn\" into \"Bahn\").\n- Prefer leaving a constraint unmet over changing meaning to fit length or style.\n\n3) Length changes\n- Do not shorten or lengthen the text unless the selected action or editor instruction asks for it.\n- If asked to shorten and you cannot without losing facts or sources, keep meaning intact and shorten only what is safe — never invent filler or distort terms to hit a length.\n\n4) Grammar quality\n- Do not introduce new spelling, grammar, or punctuation errors.\n- Prefer a slightly less elegant phrasing over an incorrect one. Preserve correct constructions (including valid German word order).\n\n5) Scope of changes\n- Only perform changes required by the selected action and/or the editor instruction.\n- Do not add extra rewrites, synonyms, restructuring, or formatting beyond that scope (e.g. if asked only to bold passages, bold only — do not reword).", ju = {
	basic: "Improve wording and readability while keeping the original meaning, facts, and sources. Do not shorten or expand unless asked. Do not introduce grammatical errors.",
	correct: "Fix spelling, grammar and punctuation only. Do not change the meaning or the style.",
	seo: "Optimize for search engines while keeping meaning, facts, and sources intact. Do not drop attributions. Do not introduce grammatical errors. Do not shorten solely to fit a limit if that would change meaning."
};
function Mu(e) {
	if (e.rules.format === "html") {
		let t = e.rules.allowedTags?.length ? ` using only these tags: ${e.rules.allowedTags.join(", ")}` : "";
		return e.rules.inline ? [
			`Return inline HTML only${t}.`,
			"Do not add block-level tags (p, div, h1-h6, ul, ol, li, blockquote), and do not wrap the result in a paragraph.",
			"Do not use markdown or code fences."
		].join(" ") : [
			`Return valid HTML${t}.`,
			"Preserve the existing formatting and block structure of the input.",
			"Do not use wrapper tags (html, body, article), markdown, or code fences."
		].join(" ");
	}
	return "Return plain text only, without markdown or HTML tags.";
}
function Nu(e) {
	let t = [Au, Mu(e)];
	if (e.action && t.push(ju[e.action]), e.rules.language && t.push(e.rules.language), e.rules.constraints.length && t.push(`Constraints to follow:\n${e.rules.constraints.map((e) => `- ${e}`).join("\n")}`), e.freePrompt && t.push(`Editor instruction: ${e.freePrompt}`), e.context?.length) {
		let n = e.context.map((e) => `<${e.key}>\n${e.value}\n</${e.key}>`).join("\n");
		t.push(`Reference context (do not return this, use it only to inform the result):\n${n}`);
	}
	return t.join("\n\n");
}
//#endregion
//#region src/ai-assist/createAiFieldEngine.ts
var Pu = 2e3, Fu = 45;
function Iu(e) {
	let t = e.trim(), n = t.match(/^```(?:html|markdown|md|text)?\s*\r?\n([\s\S]*?)\r?\n```$/i);
	return n?.[1] ? n[1].trim() : t;
}
function Lu(e) {
	let t = mc(`AiFieldAssist-${e}`, `/cms/ai-assist/${e}`).getEntityAPIClient();
	async function n(e, n) {
		for (let r = 1; r <= Fu; r++) {
			if (n?.aborted) return {
				status: "failed",
				error: "aborted"
			};
			try {
				let { data: n } = await t.get(`transform/${e}`);
				if (n.status === "completed") return {
					status: "completed",
					result: Iu(n.result ?? "")
				};
				if (n.status === "failed") return {
					status: "failed",
					error: n.error ?? void 0
				};
			} catch (e) {
				console.error("AI field-assist: failed to fetch transform result, retrying", e);
			}
			r < Fu && await new Promise((e) => setTimeout(e, Pu));
		}
		return {
			status: "failed",
			error: "timeout"
		};
	}
	return { async run(e, r) {
		let { data: i } = await t.post("transform", {
			prompt: { system_prompt: Nu(e) },
			data: e.value
		});
		return i.job_id ? n(i.job_id, r?.signal) : {
			status: "failed",
			error: "init failed"
		};
	} };
}
//#endregion
//#region src/ai-assist/harvestAiHints.ts
function Ru(e) {
	if (typeof e != "function" || !("aiHint" in e)) return;
	let { aiHint: t } = e;
	return typeof t == "string" && t.trim().length > 0 ? t : void 0;
}
function zu(e) {
	return Array.isArray(e) ? e.map(Ru).filter((e) => e !== void 0) : [];
}
function Bu({ rules: e, targetLength: t, maxLength: n, minLength: r }) {
	let i = zu(e);
	return typeof n == "number" && typeof t == "number" ? i.push(`Aim for about ${t} characters, and never exceed ${n} characters.`) : typeof n == "number" ? i.push(`Maximum ${n} characters.`) : typeof t == "number" && i.push(`Aim for about ${t} characters.`), typeof r == "number" && i.push(`Minimum ${r} characters.`), [...new Set(i)];
}
//#endregion
//#region src/ai-assist/useAiFieldDescriptor.ts
function Vu(e) {
	let t = Du();
	function n() {
		let n = e.getTargetLength?.(), r = e.getMaxLength?.(), i = e.getMinLength?.(), a = e.getContextScope?.() ?? [], o = t && a.length ? t(a) : void 0;
		return {
			value: e.getValue(),
			label: e.getLabel?.(),
			apply: e.apply,
			actions: e.getActions?.(),
			offeredContext: o?.length ? o : void 0,
			rules: {
				format: e.format,
				targetLength: n,
				maxLength: r,
				minLength: i,
				language: e.getLanguage?.(),
				allowedTags: e.allowedTags,
				inline: e.getInline?.() ?? !1,
				constraints: Bu({
					rules: e.getRules?.(),
					targetLength: n,
					maxLength: r,
					minLength: i
				})
			}
		};
	}
	return { getDescriptor: n };
}
//#endregion
//#region src/components/bf-brand.icon.vue?vue&type=script&setup=true&lang.ts
var Hu = [
	"src",
	"alt",
	"title"
], Uu = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "bf-brand.icon",
	props: {
		brand: {},
		small: {
			type: Boolean,
			default: !1
		},
		style: { default: "text" }
	},
	setup(e) {
		let t = q("bunte-logo.svg"), n = q("chip.svg"), r = q("fitforfun-logo.svg"), i = q("focus-online.svg"), a = q("finanzen100-logo.svg"), o = q("mittier-logo.svg"), s = q("mitsternen-logo-rectangular.svg"), c = q("mitbeziehung-logo-rectangular.svg"), l = q("tvtoday.svg"), u = q("tvspielfilm-logo.svg"), d = q("bunte_color.png"), f = q("chip_color.png"), p = q("fitforfun_color.png"), m = q("focus_color.png"), h = q("finanzen100_color.svg"), g = q("mittier_color.svg"), ee = q("mitsternen-logo.svg"), _ = q("mitbeziehung-square.svg"), v = q("tvspielfilm_color.png"), y = q("tvtoday_color.png"), b = e, te = {
			bunte: {
				brandTitle: "BUNTE.de",
				textLogo: t,
				colorLogo: d
			},
			chip: {
				brandTitle: "CHIP",
				textLogo: n,
				colorLogo: f
			},
			focus: {
				brandTitle: "FOCUS online",
				textLogo: i,
				colorLogo: m
			},
			fitforfun: {
				brandTitle: "FIT FOR FUN",
				textLogo: r,
				colorLogo: p
			},
			finanzen100: {
				brandTitle: "Finanzen100",
				textLogo: a,
				colorLogo: h
			},
			mittier: {
				brandTitle: "Mit Tier",
				textLogo: o,
				colorLogo: g
			},
			mitsternen: {
				brandTitle: "Mit Sternen",
				textLogo: s,
				colorLogo: ee
			},
			mitbeziehung: {
				brandTitle: "Mit Beziehung",
				textLogo: c,
				colorLogo: _
			},
			tvspielfilm: {
				brandTitle: "TV Spielfilm",
				textLogo: u,
				colorLogo: v
			},
			tvtoday: {
				brandTitle: "TV Today",
				textLogo: l,
				colorLogo: y
			}
		}, ne = C(() => {
			let e = te[b.brand];
			if (!e) throw Error(`Brand icon configuration not found for: ${b.brand}`);
			return e;
		}), x = C(() => ne.value?.brandTitle ?? b.brand), re = C(() => b.style === "text" ? ne.value?.textLogo ?? "" : ne.value?.colorLogo ?? ""), ie = C(() => ({
			small: b.small,
			big: !b.small
		}));
		return (t, n) => (j(), E("img", je({
			src: re.value,
			alt: e.brand,
			class: ie.value
		}, t.$attrs, { title: x.value }), null, 16, Hu));
	}
}), [["__scopeId", "data-v-373bbdcc"]]), Wu = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "bf-brand-based-state",
	props: {
		brandStates: {},
		brandIconSizePx: { default: 35 },
		iconsPerRow: { default: void 0 }
	},
	emits: ["brand:click"],
	setup(e) {
		let t = q("bunte_bw.png"), n = q("bunte_color.png"), r = q("chip_bw.png"), i = q("chip_color.png"), a = q("finanzen100_color.svg"), o = q("finanzen100_w.svg"), s = q("fitforfun_bw.png"), c = q("fitforfun_color.png"), l = q("focus_bw.png"), u = q("focus_color.png"), d = q("mitbeziehung-bw.svg"), f = q("mitbeziehung-square.svg"), p = q("mitsternen-logo.svg"), m = q("mitsternen-logo-black.svg"), h = q("mittier_bw.svg"), ee = {
			bunteDisabled: t,
			bunteActive: n,
			chipDisabled: r,
			chipActive: i,
			fitforfunDisabled: s,
			fitforfunActive: c,
			focusDisabled: l,
			focusActive: u,
			finanzen100Disabled: o,
			finanzen100Active: a,
			mittierActive: q("mittier_color.svg"),
			mittierDisabled: h,
			mitsternenDisabled: m,
			mitsternenActive: p,
			mitbeziehungDisabled: d,
			mitbeziehungActive: f,
			tvspielfilmDisabled: q("tvspielfilm_bw.png"),
			tvspielfilmActive: q("tvspielfilm_color.png"),
			tvtodayDisabled: q("tvtoday_bw.png"),
			tvtodayActive: q("tvtoday_color.png")
		}, _ = e, v = C(() => _.iconsPerRow ? "bf-brand-based-state--grid" : "bf-brand-based-state--inline"), y = C(() => _.iconsPerRow ? { gridTemplateColumns: `repeat(${_.iconsPerRow}, auto)` } : void 0), b = C(() => _.brandStates.map((e) => ({
			image: ee[e.active ? `${e.brand}Active` : `${e.brand}Disabled`],
			brand: e.brand,
			isActive: e.active
		})).filter((e) => e.image));
		return (t, n) => (j(), E("div", je({
			class: ["bf-brand-based-state", v.value],
			style: y.value
		}, t.$attrs), [(j(!0), E(Ce, null, Ve(b.value, (n) => (j(), w(P(g), {
			key: n.image,
			src: n.image,
			position: "center",
			width: `${e.brandIconSizePx}px`,
			height: `${e.brandIconSizePx}px`,
			"data-qa-state-icon-active": `${n.brand}:${n.isActive}`,
			fit: "cover",
			ratio: "1/1",
			class: Ne({ "q-mr-xs": !e.iconsPerRow }),
			onClick: (e) => t.$emit("brand:click", n.brand)
		}, null, 8, [
			"src",
			"width",
			"height",
			"data-qa-state-icon-active",
			"class",
			"onClick"
		]))), 128))], 16));
	}
}), [["__scopeId", "data-v-e39537c7"]]), Gu = /* @__PURE__ */ A({
	__name: "bf-entity-no-edit-icon",
	props: { tooltipLabel: {} },
	setup(e) {
		return (t, n) => (j(), w(P(h), je({
			color: "primary",
			name: "mdi-pencil-off-outline",
			size: "x-large"
		}, t.$attrs), {
			default: F(() => [e.tooltipLabel ? (j(), w(P(ge), {
				key: 0,
				anchor: "top middle",
				class: "text-caption",
				self: "center left",
				style: { backgroundColor: "var(--tooltip-bg)" }
			}, {
				default: F(() => [O(N(e.tooltipLabel), 1)]),
				_: 1
			})) : T("", !0)]),
			_: 1
		}, 16));
	}
}), Ku = /* @__PURE__ */ A({
	__name: "bf-entity-state.icon",
	props: { state: { default: "draft" } },
	setup(e) {
		let t = e, n = {
			draft: "grey-7",
			schedule: "blue",
			publish: "green",
			unpublish: "red"
		}, r = {
			draft: "edit",
			schedule: "clock",
			publish: "check-circle",
			unpublish: "minus-circle"
		}, i = C(() => r[t.state]);
		return (e, r) => (j(), w(P(h), je({
			name: i.value,
			color: n[t.state]
		}, e.$attrs), null, 16, ["name", "color"]));
	}
}), qu = /* @__PURE__ */ A({
	__name: "bf-entity-state.selector",
	props: {
		modelValue: {},
		showRescheduledOption: { type: Boolean },
		states: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = C({
			get: () => n.modelValue ?? "",
			set: (e) => r("update:modelValue", e || void 0)
		}), { t: a } = B(), o = () => {
			let e = [
				{
					label: a("entityState.dpAll"),
					value: ""
				},
				{
					label: a("entityState.dpDraft"),
					value: "draft"
				},
				{
					label: a("entityState.dpSchedule"),
					value: "schedule"
				},
				{
					label: a("entityState.dpPublished"),
					value: "publish"
				},
				{
					label: a("entityState.dpExpired"),
					value: "unpublish"
				},
				{
					label: a("entityState.dpRescheduled"),
					value: "rescheduled"
				}
			];
			return n.states ? n.states.map((t) => e.find((e) => e.value === t)).filter((e) => e !== void 0) : e.filter((e) => e.value !== "rescheduled" || n.showRescheduledOption);
		};
		return (e, t) => (j(), w(P(re), je({
			modelValue: i.value,
			"onUpdate:modelValue": t[0] ||= (e) => i.value = e,
			"data-qa-state-dropdown": i.value,
			options: o(),
			label: P(a)("entityState.status"),
			"dropdown-icon": "expand_more",
			"emit-value": "",
			"map-options": "",
			outlined: "",
			dense: ""
		}, e.$attrs), {
			option: F((e) => [k(P(_), je(e.itemProps, { "data-qa-state-dropdown-option": e.opt.value }), {
				default: F(() => [k(P(y), null, {
					default: F(() => [O(N(e.opt.label), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040, ["data-qa-state-dropdown-option"])]),
			_: 1
		}, 16, [
			"modelValue",
			"data-qa-state-dropdown",
			"options",
			"label"
		]));
	}
}), Ju = 100;
function Yu(e) {
	let t = e.querySelector("input, textarea");
	return t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement ? t : null;
}
function Xu(e, t, n) {
	if (!(t == null || n == null)) try {
		e.setSelectionRange(t, n);
	} catch {}
}
function Zu(e) {
	if (e.__germanQuotes__) return;
	let t = Yu(e);
	if (!t) return;
	let n = ye(() => {
		if (t.readOnly || t.disabled || !it(t.value)) return;
		let e = t.selectionStart, n = t.selectionEnd, r = at(t.value);
		r !== t.value && (t.value = r, t.dispatchEvent(new Event("input", { bubbles: !0 })), requestAnimationFrame(() => Xu(t, e, n)));
	}, Ju), r = () => n();
	t.addEventListener("input", r), e.__germanQuotes__ = {
		input: t,
		handler: r
	};
}
function Qu(e) {
	let t = e.__germanQuotes__;
	t && (t.input.removeEventListener("input", t.handler), delete e.__germanQuotes__);
}
var $u = {
	mounted(e, t) {
		t.value !== !1 && Zu(e);
	},
	updated(e, t) {
		let n = e.__germanQuotes__ != null, r = t.value !== !1;
		r && !n && Zu(e), !r && n && Qu(e);
	},
	unmounted(e) {
		Qu(e);
	}
}, ed = ["textContent"], td = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "bf-limited-text.input",
	props: /* @__PURE__ */ Ae({
		maxPerfectLength: { default: void 0 },
		maxLength: { default: void 0 },
		hasGermanQuotes: {
			type: Boolean,
			default: !0
		},
		aiAssist: {
			type: Boolean,
			default: !1
		},
		aiAssistContextScope: { default: void 0 },
		aiAssistActions: { default: void 0 }
	}, {
		modelValue: { default: "" },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let { t } = rt(), n = e, r = Ge(e, "modelValue"), i = We(), a = C(() => !!(i.disable ?? i.disabled ?? i.readonly));
		function o(e) {
			if (e !== void 0) return Array.isArray(e) ? e : [e];
		}
		let { getDescriptor: s } = Vu({
			getValue: () => r.value,
			format: "plain",
			apply: (e) => {
				r.value = e.trim();
			},
			getRules: () => i.rules,
			getTargetLength: () => n.maxPerfectLength,
			getMaxLength: () => n.maxLength,
			getLanguage: () => n.hasGermanQuotes ? "If the text already contains quotation marks, format them as German typographic quotes („ … “). Do not add surrounding or extra quotation marks." : void 0,
			getContextScope: () => o(n.aiAssistContextScope),
			getLabel: () => typeof i.label == "string" ? i.label : void 0,
			getActions: () => n.aiAssistActions
		}), c = C(() => !n.maxPerfectLength && !n.maxLength ? {
			state: "normal",
			text: `${t("articlesEdit.length")}:`
		} : n.maxPerfectLength && r.value.length <= n.maxPerfectLength ? {
			state: "perfect",
			icon: "check-circle",
			text: t("articlesEdit.seoPerfect")
		} : n.maxLength && r.value.length <= n.maxLength ? {
			state: "okay",
			icon: "check",
			text: t("articlesEdit.seoOkay")
		} : {
			state: "long",
			icon: "alert-circle",
			text: t("articlesEdit.seoLong")
		}), l = C(() => {
			let e = n.maxPerfectLength ? `(${r.value.length}/${n.maxPerfectLength})` : `${r.value.length}`;
			return `${c.value.text} ${e}`;
		});
		return (t, n) => Je((j(), w(P(ee), je(t.$attrs, {
			modelValue: r.value,
			"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
			"bottom-slots": ""
		}), we({
			counter: F(() => [D("div", { class: Ne(["text-length-info q-mt-xxs", c.value?.state]) }, [k(P(h), { name: c.value.icon }, null, 8, ["name"]), D("span", {
				"data-qa-article-word-counter": "",
				class: "text-length-info__message",
				textContent: N(l.value)
			}, null, 8, ed)], 2)]),
			_: 2
		}, [e.aiAssist && !a.value ? {
			name: "append",
			fn: F(() => [k(ku, { "get-descriptor": P(s) }, null, 8, ["get-descriptor"])]),
			key: "0"
		} : void 0]), 1040, ["modelValue"])), [[P($u), e.hasGermanQuotes]]);
	}
}), [["__scopeId", "data-v-7560643a"]]), Y;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(Y ||= {}), Object.freeze(Y);
var nd;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(nd ||= {}), Object.freeze(nd), Object.freeze([
	Y.MITTIER,
	Y.MITSTERNEN,
	Y.MITBEZIEHUNG,
	Y.TVTODAY,
	Y.TVSPIELFILM
]), Object.freeze({
	[Y.BUNTE]: "bunte",
	[Y.CHIP]: "chip",
	[Y.FOCUS]: "focus",
	[Y.FITFORFUN]: "fitforfun",
	[Y.FINANZEN100]: "finanzen100",
	[Y.MITTIER]: "default-verticals",
	[Y.MITSTERNEN]: "default-verticals",
	[Y.MITBEZIEHUNG]: "default-verticals",
	[Y.TVTODAY]: "default",
	[Y.TVSPIELFILM]: "default"
}), Object.freeze(Object.values(Y)), Object.freeze(Object.values(nd)), Y.BUNTE, Y.CHIP, Y.FOCUS, Y.FITFORFUN, Y.TVSPIELFILM, Y.TVTODAY, Y.BUNTE, Y.CHIP, Y.FOCUS, Y.FITFORFUN, Y.TVSPIELFILM, Y.TVTODAY;
//#endregion
//#region src/components/bf-logo.icon.vue?vue&type=script&setup=true&lang.ts
var rd = ["src", "alt"], id = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "bf-logo.icon",
	props: { brands: {} },
	setup(e) {
		let t = ol("bunte.svg"), n = ol("bunte-unused.svg"), r = ol("chip.svg"), i = ol("chip-unused.svg"), a = ol("focus.svg"), o = ol("focus-unused.svg"), s = ol("mitsternen.svg"), c = ol("mitsternen-unused.svg"), l = ol("mittier.svg"), u = ol("unused-mittier.svg"), d = e, f = {
			bunte: t,
			chip: r,
			focus: a,
			mittier: l,
			mitsternen: s
		}, p = {
			bunte: n,
			chip: i,
			focus: o,
			mittier: u,
			mitsternen: c
		}, m = [
			Y.FOCUS,
			Y.BUNTE,
			Y.CHIP,
			Y.MITTIER,
			Y.MITSTERNEN
		], h = (e) => (d.brands.includes(e) ? f[e] : p[e]) || "";
		return (e, t) => (j(), E("div", null, [(j(), E(Ce, null, Ve(m, (t) => D("img", je({
			key: t,
			src: h(t),
			alt: t,
			class: "big q-mr-sm"
		}, { ref_for: !0 }, e.$attrs), null, 16, rd)), 64))]));
	}
}), [["__scopeId", "data-v-48e3daee"]]), ad = /* @__PURE__ */ A({
	__name: "bf-scheduled-change-icon",
	props: {
		scheduleDate: {},
		index: {},
		entity: {}
	},
	setup(e) {
		let { t } = rt();
		return (n, r) => (j(), w(P(h), Pe({
			size: "16px",
			[`scheduled-lock-${e.entity}` || ""]: e.index,
			name: "schedule-lock"
		}), {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(t)("newsArticleList.scheduledChangeToolTipMessage")) + " " + N(e.scheduleDate), 1)]),
				_: 1
			})]),
			_: 1
		}, 16));
	}
}), od;
(function(e) {
	e.LOCAL = "local", e.LOCAL_K8S = "local_k8s", e.LOCAL_E2E = "local_e2e", e.SANDBOX = "sandbox", e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.TEST = "test";
})(od ||= {});
//#endregion
//#region ../../../ctf-config/dist/configHelper.js
function sd(e) {
	return cd(e);
}
function cd(e) {
	return Object.getOwnPropertyNames(e).forEach((t) => {
		let n = e[t];
		n && (typeof n == "object" || typeof n == "function") && !Object.isFrozen(n) && cd(n);
	}), Object.freeze(e);
}
function ld(e, t) {
	let n = {};
	for (let r in {
		...t,
		...e
	}) if (typeof t[r] == "object" && !Array.isArray(t[r]) && t[r] !== null && e && r in e) {
		let i = e[r], a = t[r];
		n[r] = ld(i, a);
	} else e && r in e && typeof e[r] == "function" ? n[r] = e[r].bind(n) : typeof t[r] == "function" ? n[r] = t[r].bind(n) : e && r in e ? n[r] = e[r] : n[r] = t[r];
	return n;
}
function ud(e) {
	return Object.values(od).find((t) => t === e) !== void 0;
}
function dd() {
	let e = process.env.APP_ENV;
	if (e === void 0) throw Error("APP_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
	if (!ud(e)) throw Error(`APP_ENV=${e}. Allowed values=${Object.values(od).join(", ")}`);
	return e;
}
var fd = /* @__PURE__ */ new WeakMap(), pd = /* @__PURE__ */ new WeakMap();
function md(e, t) {
	let n = fd.get(e), r = n?.get(t);
	if (r !== void 0) return r;
	let { base: i, ...a } = e, o;
	o = typeof process > "u" ? a.local : a[dd()];
	let s = pd.get(e);
	s === void 0 && (s = o ? ld(o, i) : i, pd.set(e, s));
	let { _: c, ...l } = s, u = l[t], d = sd(u ? ld(u, c) : c);
	return n || (n = /* @__PURE__ */ new Map(), fd.set(e, n)), n.set(t, d), d;
}
function X() {
	return typeof process > "u" ? "" : process.env.BRANCH_SANDBOX_NAME ? `${process.env.BRANCH_SANDBOX_NAME}.` : "";
}
//#endregion
//#region ../../../ctf-config/dist/configs/rendering.brand.config.js
var hd;
(function(e) {
	e.PageNavigation = "pageNavigation", e.MoreButton = "moreButton";
})(hd ||= {});
var gd;
(function(e) {
	e.AQUA = "aqua", e.BLACK = "black", e.BLUE = "blue", e.RED = "red", e.GRAY = "gray", e.BRAND = "brand", e.TRANSPARENT = "transparent";
})(gd ||= {});
var _d = 3600, vd = {
	recentArticle: 60,
	oldArticle: 600
}, yd = {
	recentArticle: _d,
	oldArticle: _d
}, bd = {
	recentArticle: 60,
	oldArticle: 60
}, xd = {
	base: {
		_: {
			hostname: "",
			origin: "",
			legacyOrigin: "",
			brandPrefix: "",
			brandDescription: "",
			brandSocialLinks: [],
			brandAboutText: "",
			brandLogo: {
				url: "",
				width: 0,
				height: 0
			},
			CWCUrl: "",
			f100ChartWidget: {
				isEnabled: !1,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			mostReadArticleTitlePlaceholder: "Leere meistgelesene Artikel der Woche",
			newsletterSubscriptionApi: "https://api.bf-bfnewsletter-sandbox.aws.bfops.io",
			newsletterLdsApi: "https://lds.bf-lds-production.aws.bfops.io:8000",
			newsletterLdsSlug: "nl_p1_bf_nleinwilligung",
			pagination: {
				author: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 50,
					startOffset: 0,
					paginationButtonName: hd.PageNavigation
				},
				channel: {
					isEnabled: !1,
					pageLimit: 20,
					teasersPerPage: 50,
					startOffset: 0,
					paginationButtonName: hd.PageNavigation
				},
				tags: {
					isEnabled: !1,
					pageLimit: 20,
					teasersPerPage: 16,
					startOffset: 6,
					paginationButtonName: hd.PageNavigation
				},
				hubPages: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 16,
					startOffset: 6,
					paginationButtonName: hd.PageNavigation
				},
				partner: {
					isEnabled: !0,
					pageLimit: 20,
					teasersPerPage: 20,
					startOffset: 0,
					paginationButtonName: hd.PageNavigation
				}
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			feed: {
				rss: { isEnabled: !0 },
				yahoo: { isEnabled: !0 },
				msn: { isEnabled: !0 },
				msnGallery: { isEnabled: !0 },
				msnVideo: { isEnabled: !0 },
				pushedArticles: { isEnabled: !0 },
				videoPages: { isEnabled: !0 }
			},
			specialChannelSettings: { defaultColor: gd.AQUA },
			appView: { isEnabled: !1 },
			cacheTTL: vd
		},
		focus: {
			hostname: "focus.de",
			brandPrefix: "fol",
			brandTitle: "FOCUS online",
			brandDescription: "Aktuelle Nachrichten und Analysen aus Politik, Wirtschaft, Sport und Gesellschaft - unabhängig, schnell, informativ",
			brandSocialLinks: [
				"https://www.facebook.com/focus.de",
				"https://www.twitter.com/focusonline",
				"https://de.linkedin.com/company/focus-online-news",
				"https://www.youtube.com/user/focusonline",
				"https://www.xing.com/pages/focus-online-karriere",
				"https://de.wikipedia.org/wiki/Focus_Online"
			],
			brandAboutText: "Nachrichtenportal mit aktuellen Themen zu Politik, Wirtschaft, Sport und Gesellschaft",
			brandLogo: {
				url: "/ctf/focus/favicon/fol-logo.png",
				width: 512,
				height: 240
			},
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: {
				defaultColor: gd.AQUA,
				availableColors: [
					gd.AQUA,
					gd.RED,
					gd.BLUE
				]
			},
			articleFeedbackButtonPath: "/static/kontaktformular_59b8c454-2196-4c3d-9446-c67bd4a0dde7.html",
			appView: { isEnabled: !0 },
			cacheTTL: yd,
			pagination: { hubPages: {
				pageLimit: 10,
				startOffset: 40,
				teasersPerPage: 40
			} }
		},
		chip: {
			hostname: "chip.de",
			brandPrefix: "chip",
			brandTitle: "CHIP",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: {
				defaultColor: gd.GRAY,
				availableColors: [gd.GRAY, gd.TRANSPARENT]
			},
			cacheTTL: {
				...yd,
				byArticleType: { download: bd }
			}
		},
		bunte: {
			hostname: "bunte.de",
			brandDescription: "Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.",
			brandPrefix: "bunte",
			brandTitle: "BUNTE",
			brandLogo: {
				url: "/ctf/bunte/favicon/logo-bunte-1000.png",
				width: 1e3,
				height: 1e3
			},
			appView: { isEnabled: !0 },
			brandSocialLinks: [
				"https://www.instagram.com/bunte",
				"https://www.pinterest.de/buntede/",
				"https://www.facebook.com/bunte.de",
				"https://www.youtube.com/user/BUNTEtv",
				"https://www.tiktok.com/@bunte "
			],
			brandAboutText: "Exklusive Promi-News, VIP-News und Videos aus der Welt der Stars und Royals. Auf BUNTE.de bekommst du Entertainment pur und die neusten Lifestyle-Trends.",
			pagination: {
				author: { pageLimit: 200 },
				channel: {
					isEnabled: !0,
					pageLimit: 200,
					teasersPerPage: 50,
					paginationButtonName: hd.PageNavigation
				},
				tags: {
					isEnabled: !0,
					pageLimit: 200
				},
				hubPages: {
					pageLimit: 200,
					startOffset: 8
				}
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: { defaultColor: gd.BLACK },
			cacheTTL: yd
		},
		fitforfun: {
			hostname: "fitforfun.de",
			brandPrefix: "fitforfun",
			brandTitle: "FIT FOR FUN",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			},
			specialChannelSettings: { defaultColor: gd.BRAND }
		},
		finanzen100: {
			hostname: "finanzen100.de",
			brandPrefix: "f100",
			brandTitle: "Finanzen100",
			brandDescription: "Aktuelle Finanznachrichten und Informationen rund um das Thema Börse finden Sie auf Deutschlands innovativstem Finanzportal Finanzen100.",
			brandSocialLinks: [
				"https://www.facebook.com/Finanzen100",
				"https://x.com/Finanzen100",
				"https://www.youtube.com/@Finanzen100",
				"https://www.instagram.com/finanzen100.de"
			],
			brandAboutText: "Finanznachrichten und Infos zu Börse und Aktien - Finanzen100",
			appView: { isEnabled: !0 },
			brandLogo: {
				url: "/ctf/finanzen100/favicon/finanzen100-logo.png",
				width: 512,
				height: 240
			},
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://stage-www.finanzen100.de",
				apiBaseUrl: "https://stage-chart.widget.finanzen100.de"
			},
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mittier: {
			hostname: "mit-tier.de",
			brandPrefix: "mittier",
			brandTitle: "mit Tier",
			brandDescription: "Das digitale Magazin rund um Haustiere – Wissen, News und Ratgeber zu Hund und Katze",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mitsternen: {
			hostname: "mit-sternen.de",
			brandPrefix: "mitsternen",
			brandTitle: "mit Sternen",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		},
		mitbeziehung: {
			hostname: "mit-beziehung.de",
			brandPrefix: "mitbeziehung",
			brandTitle: "mit Beziehung"
		},
		tvtoday: {
			hostname: "tvtoday.de",
			brandPrefix: "tvtoday",
			brandTitle: "TV Today",
			appView: { isEnabled: !0 },
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		},
		tvspielfilm: {
			hostname: "tvspielfilm.de",
			brandPrefix: "tvspielfilm",
			brandTitle: "TV Spielfilm",
			appView: { isEnabled: !0 },
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 }
			}
		}
	},
	local: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	local_k8s: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	local_e2e: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	test: {
		bunte: {
			origin: "https://ctf-local.bunte.de",
			legacyOrigin: "https://ctf-local.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		chip: {
			origin: "https://ctf-local.chip.de",
			legacyOrigin: "https://ctf-local.chip.de",
			CWCUrl: "https://widget-stg.chip.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		focus: {
			origin: "https://ctf-local.focus.de",
			legacyOrigin: "https://ctf-local.focus.de",
			CWCUrl: "https://widget-stg.focus.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "week"
				},
				image: {
					isEnabled: !0,
					interval: "week"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		fitforfun: {
			origin: "https://ctf-local.fitforfun.de",
			legacyOrigin: "https://ctf-local.fitforfun.de",
			CWCUrl: "https://widget-stg.fitforfun.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		finanzen100: {
			origin: "https://ctf-local.finanzen100.de",
			legacyOrigin: "https://ctf-local.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/",
			sitemap: {
				article: {
					isEnabled: !0,
					interval: "month"
				},
				image: {
					isEnabled: !0,
					interval: "month"
				},
				news: { isEnabled: !0 },
				video: {
					isEnabled: !0,
					interval: "month"
				}
			}
		},
		mittier: {
			origin: "https://ctf-local.mit-tier.de",
			legacyOrigin: "https://ctf-local.mit-tier.de",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://ctf-local.mit-sternen.de",
			legacyOrigin: "https://ctf-local.mit-sternen.de",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://ctf-local.mit-beziehung.de",
			legacyOrigin: "https://ctf-local.mit-beziehung.de",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://ctf-local.tvtoday.de",
			legacyOrigin: "https://ctf-local.tvtoday.de",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://ctf-local.tvspielfilm.de",
			legacyOrigin: "https://ctf-local.tvspielfilm.de",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	sandbox: {
		bunte: {
			origin: `https://${X()}bunte.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}bunte.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: `https://${X()}chip.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}chip.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: `https://${X()}focus.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}focus.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: `https://${X()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		finanzen100: {
			origin: `https://${X()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}finanzen100.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mittier: {
			origin: `https://${X()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-tier.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		mitsternen: {
			origin: `https://${X()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-sternen.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: `https://${X()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}mit-beziehung.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: `https://${X()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}tvtoday.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: `https://${X()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
			legacyOrigin: `https://${X()}tvspielfilm.bf-ctf-sandbox.aws.bfops.io`,
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	development: {
		bunte: {
			origin: "https://bunte.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www.dev.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://chip.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www-staging.chip.de",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://focus.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://www-stg.focus.de",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://fitforfun.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://fitforfun.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://mit-tier.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-tier.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://finanzen100.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://stage-www.finanzen100.de",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://mit-sternen.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-sternen.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://mit-beziehung.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://mit-beziehung.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://tvtoday.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://tvtoday.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://tvspielfilm.bf-ctf-development.aws.bfops.io",
			legacyOrigin: "https://tvspielfilm.bf-ctf-development.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	staging: {
		bunte: {
			origin: "https://bunte.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://www.stage.bunte.de",
			CWCUrl: "https://widget-stg.bunte.de/"
		},
		chip: {
			origin: "https://chip.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://chip.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.chip.de/"
		},
		focus: {
			origin: "https://focus.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://focus.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.focus.de/"
		},
		fitforfun: {
			origin: "https://fitforfun.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://fitforfun.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.fitforfun.de/"
		},
		mittier: {
			origin: "https://mit-tier.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-tier.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-tier.de/"
		},
		finanzen100: {
			origin: "https://finanzen100.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://finanzen100.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.finanzen100.de/"
		},
		mitsternen: {
			origin: "https://mit-sternen.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-sternen.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://mit-beziehung.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://mit-beziehung.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://tvtoday.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://tvtoday.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://tvspielfilm.bf-ctf-staging.aws.bfops.io",
			legacyOrigin: "https://tvspielfilm.bf-ctf-staging.aws.bfops.io",
			CWCUrl: "https://widget-stg.tvspielfilm.de/"
		}
	},
	production: {
		_: { newsletterSubscriptionApi: "https://api.bf-bfnewsletter-production.aws.bfops.io" },
		bunte: {
			origin: "https://www.bunte.de",
			legacyOrigin: "https://www.bunte.de",
			CWCUrl: "https://widget.bunte.de/"
		},
		chip: {
			origin: "https://www.chip.de",
			legacyOrigin: "https://www.chip.de",
			CWCUrl: "https://widget.chip.de/"
		},
		focus: {
			origin: "https://www.focus.de",
			legacyOrigin: "https://www.focus.de",
			CWCUrl: "https://widget.focus.de/",
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://www.finanzen100.de",
				apiBaseUrl: "https://chart.widget.finanzen100.de"
			}
		},
		fitforfun: {
			origin: "https://www.fitforfun.de",
			legacyOrigin: "https://www.fitforfun.de",
			CWCUrl: "https://widget.fitforfun.de/"
		},
		finanzen100: {
			origin: "https://www.finanzen100.de",
			legacyOrigin: "https://www.finanzen100.de",
			CWCUrl: "https://widget.finanzen100.de/",
			f100ChartWidget: {
				isEnabled: !0,
				webBaseUrl: "https://www.finanzen100.de",
				apiBaseUrl: "https://chart.widget.finanzen100.de"
			}
		},
		mittier: {
			origin: "https://www.mit-tier.de",
			legacyOrigin: "https://www.mit-tier.de",
			CWCUrl: "https://widget.mit-tier.de/"
		},
		mitsternen: {
			origin: "https://www.mit-sternen.de",
			legacyOrigin: "https://www.mit-sternen.de",
			CWCUrl: "https://widget.mit-sternen.de/"
		},
		mitbeziehung: {
			origin: "https://www.mit-beziehung.de",
			legacyOrigin: "https://www.mit-beziehung.de",
			CWCUrl: "https://widget.mit-beziehung.de/"
		},
		tvtoday: {
			origin: "https://www.tvtoday.de",
			legacyOrigin: "https://www.tvtoday.de",
			CWCUrl: "https://widget.tvtoday.de/"
		},
		tvspielfilm: {
			origin: "https://www.tvspielfilm.de",
			legacyOrigin: "https://www.tvspielfilm.de",
			CWCUrl: "https://widget.tvspielfilm.de/"
		}
	}
}, Sd = (e) => md(xd, e), Cd = {
	key: 1,
	class: "row items-center no-wrap q-gutter-x-xs"
}, wd = { key: 1 }, Td = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "brand-dropdown.selector",
	props: {
		modelValue: { default: "" },
		label: { default: void 0 },
		labelKey: { default: "common.brand" },
		multiple: { type: Boolean },
		rules: { default: void 0 },
		allowBlankOption: {
			type: Boolean,
			default: !0
		},
		blankOptionLabelKey: { default: "common.all" },
		blankOptionValue: { default: "" },
		onlyBrands: { type: Boolean },
		disabledBrands: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		},
		showBrandIcon: {
			type: Boolean,
			default: !1
		},
		iconOnly: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = () => Object.values(Y).map((e) => ({
			label: be.capitalize(Sd(e).hostname || e),
			value: e,
			brandIcon: e
		})), { t: r } = rt(), i = e, a = t, o = C({
			get() {
				return i.multiple && typeof i.modelValue == "string" ? i.modelValue ? (a("update:modelValue", [i.modelValue]), [i.modelValue]) : [] : i.modelValue;
			},
			set(e) {
				a("update:modelValue", e);
			}
		}), s = (e) => i.disabledBrands ? e.filter((e) => !i.disabledBrands?.includes(e.value)) : e, c = C(() => {
			let e = n();
			return !i.multiple && i.allowBlankOption ? [{
				label: r(i.blankOptionLabelKey),
				value: i.blankOptionValue
			}, ...s(e)] : (i.onlyBrands, s(e));
		});
		return (t, n) => (j(), w(P(re), {
			modelValue: o.value,
			"onUpdate:modelValue": n[0] ||= (e) => o.value = e,
			"data-qa-brand-dropDown": o.value,
			options: c.value,
			label: e.label ?? P(r)(e.labelKey),
			multiple: e.multiple,
			"use-chips": e.multiple,
			rules: e.rules,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: "",
			disable: e.disable
		}, {
			option: F((t) => [k(P(_), je(t.itemProps, { "data-qa-brand-dropdown-option": t.opt.value }), {
				default: F(() => [e.showBrandIcon && t.opt.brandIcon ? (j(), w(P(y), {
					key: 0,
					avatar: "",
					class: "brand-dropdown-selector__icon-section"
				}, {
					default: F(() => [k(Uu, {
						brand: t.opt.brandIcon,
						small: ""
					}, null, 8, ["brand"])]),
					_: 2
				}, 1024)) : T("", !0), !e.iconOnly || !t.opt.brandIcon ? (j(), w(P(y), { key: 1 }, {
					default: F(() => [k(P(v), null, {
						default: F(() => [O(N(t.opt.label), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)) : T("", !0)]),
				_: 2
			}, 1040, ["data-qa-brand-dropdown-option"])]),
			"selected-item": F((t) => [e.multiple ? (j(), w(P(d), {
				key: 0,
				"data-qa-pages-brand": "",
				removable: "",
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				class: "capitalize",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt.label), 1)]),
				_: 2
			}, 1032, ["tabindex", "onRemove"])) : e.showBrandIcon ? (j(), E("div", Cd, [t.opt.brandIcon ? (j(), w(Uu, {
				key: 0,
				brand: t.opt.brandIcon,
				small: "",
				class: "brand-dropdown-selector__selected-icon"
			}, null, 8, ["brand"])) : T("", !0), !e.iconOnly || !t.opt.brandIcon ? (j(), E("span", wd, N(t.opt.label), 1)) : T("", !0)])) : (j(), E(Ce, { key: 2 }, [O(N(t.opt.label), 1)], 64))]),
			_: 1
		}, 8, [
			"modelValue",
			"data-qa-brand-dropDown",
			"options",
			"label",
			"multiple",
			"use-chips",
			"rules",
			"disable"
		]));
	}
}), [["__scopeId", "data-v-e0faf359"]]), Ed = ["data-qa-card-item-maintitle", "textContent"], Dd = ["data-qa-card-item-subtitle", "textContent"], Od = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "card-item",
	props: {
		item: {},
		hideButton: { type: Boolean },
		isClickable: { type: Boolean },
		disable: { type: Boolean }
	},
	emits: ["remove-item"],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (j(), w(P(s), {
			flat: "",
			bordered: "",
			class: Ne({ clickable: e.isClickable }),
			"data-qa-card-item": e.item._id
		}, {
			default: F(() => [e.item._id ? (j(), w(P(l), {
				key: 0,
				horizontal: "",
				class: "justify-between"
			}, {
				default: F(() => [
					He(t.$slots, "image", { item: e.item }, void 0, !0),
					k(P(l), { class: "q-pa-sm text-crop-container" }, {
						default: F(() => [D("p", {
							class: "q-my-none text-primary text-crop",
							"data-qa-card-item-maintitle": e.item._id,
							textContent: N(e.item.kicker)
						}, null, 8, Ed), D("p", {
							class: "q-my-none text-crop",
							"data-qa-card-item-subtitle": e.item._id,
							textContent: N(e.item.title)
						}, null, 8, Dd)]),
						_: 1
					}),
					e.hideButton ? T("", !0) : (j(), w(P(c), {
						key: 0,
						align: "right"
					}, {
						default: F(() => [k(P(a), {
							icon: "close",
							class: "text-primary",
							outline: "",
							"data-qa-card-item-remove-button": e.item._id,
							disable: e.disable,
							onClick: r[0] ||= Xe((t) => n("remove-item", e.item._id), ["stop"])
						}, null, 8, ["data-qa-card-item-remove-button", "disable"])]),
						_: 1
					}))
				]),
				_: 3
			})) : T("", !0)]),
			_: 3
		}, 8, ["class", "data-qa-card-item"]));
	}
}), [["__scopeId", "data-v-db3bd77f"]]), kd = /* @__PURE__ */ A({
	__name: "card-list",
	props: {
		items: {},
		hideImage: { type: Boolean },
		hideButton: { type: Boolean },
		isClickable: { type: Boolean },
		disable: { type: Boolean }
	},
	emits: ["card-click", "remove-item"],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (j(!0), E(Ce, null, Ve(e.items, (i, a) => (j(), w(Od, {
			key: i._id,
			item: i,
			class: Ne({ "q-mt-md": a }),
			"hide-image": e.hideImage,
			"hide-button": e.hideButton,
			"is-clickable": e.isClickable,
			disable: e.disable,
			onRemoveItem: r[0] ||= (e) => n("remove-item", e),
			onClick: () => n("card-click", i._id)
		}, {
			image: F(() => [He(t.$slots, "image", { item: i })]),
			_: 2
		}, 1032, [
			"item",
			"class",
			"hide-image",
			"hide-button",
			"is-clickable",
			"disable",
			"onClick"
		]))), 128));
	}
}), Ad = /* @__PURE__ */ A({
	__name: "cms-selector",
	props: /* @__PURE__ */ Ae({
		label: {},
		rules: {},
		multiple: { type: Boolean }
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = [
			"vibe",
			"bunte-stack",
			"escenic",
			"interred",
			"fff-cms",
			"praxistipps"
		], n = e, r = Ge(e, "modelValue", { get: (e) => n.multiple && typeof e == "string" ? [e] : e }), { t: i } = rt(), a = t.map((e) => ({
			label: e.charAt(0).toUpperCase() + e.slice(1),
			value: e
		})), o = C(() => n.multiple ? a : [{
			label: i("cmsSelector.dpAll"),
			value: ""
		}, ...a]);
		return (t, n) => (j(), w(P(re), {
			modelValue: r.value,
			"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
			"data-qa-managed-by-dropdown": "",
			options: o.value,
			label: e.label || P(i)("cmsSelector.label"),
			rules: e.rules,
			multiple: e.multiple,
			"use-chips": e.multiple,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: ""
		}, we({
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(i)("cmsSelector.hint")), 1)]),
				_: 1
			})]),
			_: 2
		}, [e.multiple ? {
			name: "selected-item",
			fn: F((e) => [k(P(d), {
				"data-qa-managed-by-tag": "",
				removable: "",
				dense: "",
				tabindex: e.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (t) => e.removeAtIndex(e.index)
			}, {
				default: F(() => [O(N(e.opt.label), 1)]),
				_: 2
			}, 1032, ["tabindex", "onRemove"])]),
			key: "0"
		} : void 0]), 1032, [
			"modelValue",
			"options",
			"label",
			"rules",
			"multiple",
			"use-chips"
		]));
	}
}), jd = /* @__PURE__ */ A({
	__name: "date-range.selector",
	props: {
		modelValue: {},
		min: { default: void 0 },
		max: { default: void 0 },
		label: { default: "Date" },
		required: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = t, r = e, i = C(() => r.min ? cs(new Date(r.min), "yyyy-MM-dd") : null), a = C(() => r.max ? cs(new Date(r.max), "yyyy-MM-dd") : null), o = C({
			get() {
				return r.modelValue.length === 2 ? {
					from: cs(new Date(r.modelValue[0]), "yyyy-MM-dd"),
					to: cs(new Date(r.modelValue[1]), "yyyy-MM-dd")
				} : {
					from: "",
					to: ""
				};
			},
			set(e) {
				if (typeof e == "string") return n("update:modelValue", [fo(new Date(e)), ho(new Date(e))]);
				if (e.from === "" && e.to === "") return n("update:modelValue", []);
				n("update:modelValue", [fo(new Date(e.from)), ho(new Date(e.to))]);
			}
		}), s = C(() => typeof o.value == "string" ? cs(new Date(o.value), "dd.MM.yyyy") : o.value.from !== "" && o.value.to !== "" ? o.value.from === o.value.to ? cs(new Date(o.value.from), "dd.MM.yyyy") : `${cs(new Date(o.value.from), "dd.MM.yyyy")}-${cs(new Date(o.value.to), "dd.MM.yyyy")}` : ""), c = () => {
			n("update:modelValue", []);
		};
		return (t, n) => (j(), w(P(ee), je({
			"data-qa-date-range-selector": "",
			class: e.required ? "required" : "",
			label: e.label,
			"model-value": s.value,
			"background-color": "white",
			flat: "",
			outlined: ""
		}, t.$attrs, { onClear: c }), {
			append: F(() => [s.value ? (j(), w(P(h), {
				key: 0,
				name: "clear",
				onClick: c
			})) : (j(), w(P(h), {
				key: 1,
				name: "calendar"
			}))]),
			default: F(() => [k(P(x), {
				"transition-show": "scale",
				"transition-hide": "scale"
			}, {
				default: F(() => [k(P(f), {
					modelValue: o.value,
					"onUpdate:modelValue": n[0] ||= (e) => o.value = e,
					"data-qa-date-input": "",
					minimal: "",
					min: i.value,
					max: a.value,
					range: ""
				}, null, 8, [
					"modelValue",
					"min",
					"max"
				])]),
				_: 1
			})]),
			_: 1
		}, 16, [
			"class",
			"label",
			"model-value"
		]));
	}
}), Md = "dd.MM.yyyy", Nd = "dd.MM.yyyy HH:mm", Pd = "DD.MM.YYYY", Fd = "DD.MM.YYYY HH:mm", Id = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "datetime-selector",
	props: {
		modelValue: { default: void 0 },
		min: { default: void 0 },
		max: { default: void 0 },
		label: { default: "Date" },
		icon: { default: "" },
		rules: { default: () => [] },
		required: {
			type: Boolean,
			default: !1
		},
		dateOnly: {
			type: Boolean,
			default: !1
		},
		dense: {
			type: Boolean,
			default: !1
		},
		outlined: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		noClearButton: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(t, { emit: n }) {
		let r = n, i = t, { t: o } = rt(), l = (e) => e ? cs(e, i.dateOnly ? Md : Nd) : "", u = (e) => cs(e, "yyyy/MM/dd"), d = (e) => !(i.min && e < u(i.min) || i.max && e > u(i.max)), p = M(l(i.modelValue)), m = (e, t, n) => {
			let [r] = p.value.split(" ");
			if (i.min && r === cs(i.min, Md)) {
				let r = i.min.getHours(), a = i.min.getMinutes(), o = i.min.getSeconds();
				return e > r ? !0 : e === r ? t === null || t > a || t === a && (n === null || n >= o) : !1;
			}
			if (i.max && r === cs(i.max, Md)) {
				let r = i.max.getHours(), a = i.max.getMinutes(), o = i.max.getSeconds();
				return e < r ? !0 : e === r ? t === null || t < a || t === a && (n === null || n <= o) : !1;
			}
			return !0;
		}, g = M("date"), _ = (e) => e.required ? [i.dateOnly ? El.validDate : El.validDateTime, ...i.rules] : e.rules, v = M(_(i));
		return qe(p, (e) => {
			if (e === "") return r("update:modelValue");
			if (i.dateOnly) {
				let [t, n, i] = e.split(".").map((e) => parseInt(e)), a = i !== void 0 && n !== void 0 ? new Date(i, n - 1, t) : void 0;
				if (mo(a)) return r("update:modelValue", a);
			}
			let t = /([0-9]{2})\.([0-9]{2})\.([0-9]{4}) ([0-9]{2}):([0-9]{2})/[Symbol.match](e)?.map((e) => parseInt(e));
			if (!t) return;
			t.shift();
			let [n, a, o, s, c] = t, l = o !== void 0 && a !== void 0 ? new Date(o, a - 1, n, s, c) : void 0;
			if (mo(l)) return r("update:modelValue", l);
		}), qe(i, (e) => {
			p.value = l(e.modelValue), v.value = _(e);
		}), (n, r) => (j(), w(P(ee), {
			modelValue: p.value,
			"onUpdate:modelValue": r[5] ||= (e) => p.value = e,
			"data-qa-dateTime-selector": "",
			dense: t.dense,
			label: t.label,
			required: t.required,
			rules: v.value,
			outlined: t.outlined,
			class: "q-mr-sm",
			disable: t.disable,
			readonly: t.disable
		}, {
			append: F(() => [p.value === "" && t.icon ? (j(), w(P(h), {
				key: 0,
				name: t.icon
			}, null, 8, ["name"])) : T("", !0), p.value !== "" && !t.noClearButton ? (j(), w(P(h), {
				key: 1,
				name: "close",
				"cursor-pointer": "",
				onClick: r[4] ||= (e) => p.value = ""
			})) : T("", !0)]),
			default: F(() => [t.disable ? T("", !0) : (j(), w(P(x), {
				key: 0,
				"transition-show": "jump-up",
				"transition-hide": "jump-down"
			}, {
				default: F(() => [k(P(s), null, {
					default: F(() => [
						k(P(ue), {
							modelValue: g.value,
							"onUpdate:modelValue": r[0] ||= (e) => g.value = e
						}, {
							default: F(() => [k(P(se), {
								name: "date",
								label: P(o)("components.date")
							}, null, 8, ["label"]), t.dateOnly ? T("", !0) : (j(), w(P(se), {
								key: 0,
								name: "time",
								label: P(o)("components.time")
							}, null, 8, ["label"]))]),
							_: 1
						}, 8, ["modelValue"]),
						k(P(le), {
							modelValue: g.value,
							"onUpdate:modelValue": r[3] ||= (e) => g.value = e,
							class: Ne({ "datetime-picker-wrapper": !t.dateOnly }),
							animated: ""
						}, {
							default: F(() => [k(P(ce), {
								name: "date",
								class: "q-pa-none"
							}, {
								default: F(() => [k(P(ie)), k(P(f), {
									modelValue: p.value,
									"onUpdate:modelValue": r[1] ||= (e) => p.value = e,
									minimal: "",
									mask: t.dateOnly ? Pd : Fd,
									options: d,
									flat: ""
								}, null, 8, ["modelValue", "mask"])]),
								_: 1
							}), t.dateOnly ? T("", !0) : (j(), w(P(ce), {
								key: 0,
								class: "q-pa-none",
								name: "time"
							}, {
								default: F(() => [k(P(pe), {
									modelValue: p.value,
									"onUpdate:modelValue": r[2] ||= (e) => p.value = e,
									mask: Fd,
									options: m,
									flat: "",
									format24h: ""
								}, null, 8, ["modelValue"])]),
								_: 1
							}))]),
							_: 1
						}, 8, ["modelValue", "class"]),
						k(P(c), { align: "right" }, {
							default: F(() => [Je(k(P(a), {
								label: P(o)("common.close"),
								color: "primary",
								flat: ""
							}, null, 8, ["label"]), [[P(e)]])]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}))]),
			_: 1
		}, 8, [
			"modelValue",
			"dense",
			"label",
			"required",
			"rules",
			"outlined",
			"disable",
			"readonly"
		]));
	}
}), [["__scopeId", "data-v-a8addc32"]]), Ld = /* @__PURE__ */ A({
	__name: "item-count-field",
	props: /* @__PURE__ */ Ae({
		max: {},
		min: {},
		label: {}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = Ge(e, "modelValue", { set: (e) => t.min && e < t.min ? t.min : t.max && e > t.max ? t.max : e });
		return (t, r) => (j(), w(P(ee), je(t.$attrs, {
			modelValue: n.value,
			"onUpdate:modelValue": r[0] ||= (e) => n.value = e,
			modelModifiers: { number: !0 },
			type: "number",
			label: e.label,
			class: "required",
			outlined: "",
			dense: ""
		}), null, 16, ["modelValue", "label"]));
	}
}), Rd = /* @__PURE__ */ A({
	__name: "legacy-selector",
	props: /* @__PURE__ */ Ae({
		label: {},
		rules: {}
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = Ge(e, "modelValue"), { t: n } = rt(), r = [
			{
				label: n("legacySelector.dpAll"),
				value: void 0
			},
			{
				label: n("legacySelector.yes"),
				value: !0
			},
			{
				label: n("legacySelector.no"),
				value: !1
			}
		];
		return (i, a) => (j(), w(P(re), {
			modelValue: t.value,
			"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
			"data-qa-legacy-dropdown": "",
			options: r,
			label: e.label || P(n)("legacySelector.label"),
			rules: e.rules,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: ""
		}, {
			default: F(() => [k(P(ge), {
				anchor: "top middle",
				self: "top middle",
				offset: [0, 35],
				class: "bg-grey-10 text-white shadow-4 text-caption"
			}, {
				default: F(() => [O(N(P(n)("legacySelector.hint")), 1)]),
				_: 1
			})]),
			_: 1
		}, 8, [
			"modelValue",
			"label",
			"rules"
		]));
	}
}), zd = class {
	id;
	options;
	constructor(e, t) {
		switch (this.id = t || io(), e) {
			case "confirm-remove-block":
				this.options = {
					title: B().t("components.blockRemoveTitle"),
					message: B().t("components.blockRemoveDescription"),
					persistent: !0,
					cancel: {
						label: B().t("common.cancel"),
						color: "secondary",
						flat: !0
					},
					ok: B().t("common.yesRemove"),
					class: "text-center"
				};
				break;
			default: this.options = e;
		}
	}
};
function Bd(e, t) {
	let n = e.dialogs.findIndex((e) => e.id === t);
	if (n !== -1) {
		let t = e.dialogs[n];
		if (!t) {
			let t = /* @__PURE__ */ Error(`Attempted to hide dialog on index ${n} that does not exist in dialog store ${JSON.stringify(e.dialogs)}`);
			throw t.name = "DialogStoreError:hideDialog", t;
		}
		t.isVisible = !1, e.dialogs.splice(n, 1);
	}
}
function Vd(e, t) {
	t.hasDismissHandlerAttached ||= (t.actions.onDismiss(() => Bd(e, t.id)), !0);
}
function Hd(e, n, r) {
	return n.options = r, n.actions.update(r), n.isVisible ? n.actions : (n.isVisible = !0, n.actions = t.create(r), Vd(e, n), n.actions);
}
function Ud(e, n, r) {
	let i = t.create(r), a = {
		id: n,
		isVisible: !0,
		hasDismissHandlerAttached: !1,
		options: r,
		actions: i
	};
	return Vd(e, a), e.dialogs.push(a), i;
}
var Wd = Be({
	dialogs: [],
	showDialog(e) {
		let { id: t, options: n } = e, r = this.dialogs.find((e) => e.id === t);
		return r ? Hd(this, r, n) : Ud(this, t, n);
	},
	updateDialog(e) {
		let { id: t, options: n } = e, r = this.dialogs.find((e) => e.id === t);
		if (!r) {
			let t = /* @__PURE__ */ Error(`Attempted to update non existing dialog with id ${e.id} in dialog store ${JSON.stringify(this.dialogs)}`);
			throw t.name = "DialogStoreError:updateDialog", t;
		}
		return Hd(this, r, n);
	},
	isDialogVisible(e) {
		if (!e && this.dialogs.length) return !0;
		if (!e) return !1;
		let t = typeof e == "string" ? e : e.id;
		return this.dialogs.some((e) => e.id === t && e.isVisible);
	}
});
Wd.showDialog = Wd.showDialog.bind(Wd), Wd.updateDialog = Wd.updateDialog.bind(Wd), Wd.isDialogVisible = Wd.isDialogVisible.bind(Wd);
var Gd = () => Wd, Kd = {
	key: 0,
	"data-qa-article-schedule-banner": "",
	class: "banner q-py-sm q-px-md align-center q-mb-lg"
}, qd = { class: "banner-icon" }, Jd = {
	class: "q-pa-sm",
	"data-qa-article-schedule-common-banner": ""
}, Yd = { class: "button-group" }, Xd = {
	key: 1,
	class: "banner q-pa-sm align-center q-mb-lg"
}, Zd = { class: "banner-icon" }, Qd = {
	"data-qa-article-schedule-edit-banner": "",
	class: "q-pa-sm"
}, $d = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "schedule-change-info-banner",
	props: {
		scheduleDate: {},
		changedBy: { default: "" },
		disableButtonsInBanner: { type: Boolean },
		showBasicsBanner: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["remove-schedule", "edit-schedule"],
	setup(e, { emit: t }) {
		let { t: n } = rt(), r = t, { showDialog: i } = Gd(), o = e, s = () => {
			i(new zd({
				title: n("scheduledChanges.remove.changesTitle"),
				message: n("scheduledChanges.remove.changesText"),
				ok: {
					class: "text-center",
					label: n("common.yes")
				},
				cancel: {
					title: n("common.cancel"),
					color: "secondary",
					flat: !0
				},
				focus: "cancel"
			})).onOk(() => {
				r("remove-schedule");
			});
		}, c = async () => {
			i(new zd({
				title: n("scheduledChanges.edit.changesTitle"),
				html: !0,
				message: `
        ${n("scheduledChanges.edit.changesText.articleScheduledOn")} ${o.scheduleDate} ${n("common.doneBy")} ${o.changedBy}.
        ${n("scheduledChanges.edit.changesText.warningScheduledChangesPresent")}<br><br>
        ${n("scheduledChanges.edit.changesText.questionScheduledChangesWillBeOverwritten")}
      `,
				ok: {
					label: n("common.yes"),
					class: "text-center"
				},
				cancel: {
					title: n("common.cancel"),
					color: "secondary",
					flat: !0
				},
				focus: "cancel"
			})).onOk(async () => {
				r("edit-schedule");
			});
		};
		return (t, r) => e.showBasicsBanner ? (j(), E("div", Kd, [
			D("div", qd, [k(P(h), { name: "info" })]),
			D("div", Jd, N(P(n)("common.scheduleBannerText")) + " " + N(o.scheduleDate) + " " + N(P(n)("common.doneBy")) + " " + N(o.changedBy), 1),
			D("div", Yd, [k(P(a), {
				"data-qa-article-remove-changes": "",
				class: "custom-button",
				outline: "",
				disable: e.disableButtonsInBanner,
				label: P(n)("common.removeChange"),
				onClick: s
			}, null, 8, ["disable", "label"]), k(P(a), {
				disable: e.disableButtonsInBanner,
				"data-qa-article-edit-changes": "",
				class: "custom-button",
				outline: "",
				label: P(n)("common.editChange"),
				onClick: c
			}, null, 8, ["disable", "label"])])
		])) : (j(), E("div", Xd, [D("div", Zd, [k(P(h), { name: "info" })]), D("div", Qd, N(P(n)("scheduledChanges.edit.changesText.editingBannerInfo")) + " " + N(o.scheduleDate), 1)]));
	}
}), [["__scopeId", "data-v-1df95484"]]), ef = 6, tf = /* @__PURE__ */ A({
	__name: "list-pagination",
	props: { pagination: {} },
	setup(e) {
		let t = e, n = C({
			get() {
				return t.pagination?.currentPage ?? 1;
			},
			set(e) {
				t.pagination?.goToPage(e);
			}
		}), r = C(() => {
			let e = t.pagination?.currentPage ?? 1, n = t.pagination?.nextPageLink;
			return e + (n && Number(new URL(n).searchParams.get("page")) > e ? 1 : 0);
		}), i = C(() => r.value >= ef ? ef : r.value);
		return (t, a) => (j(), w(P(ne), {
			modelValue: n.value,
			"onUpdate:modelValue": a[0] ||= (e) => n.value = e,
			max: r.value,
			"max-pages": i.value,
			disable: e.pagination?.loading,
			"direction-links": "",
			"icon-prev": "fast_rewind",
			"icon-next": "fast_forward",
			"active-color": "primary"
		}, null, 8, [
			"modelValue",
			"max",
			"max-pages",
			"disable"
		]));
	}
}), nf = (e) => {
	let t = nl();
	return qe(() => t.loggedIn, (n, r) => {
		r === !1 && n === !0 && t.wasLoggedIn && e();
	}, { deep: !0 }), {};
}, rf = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : typeof e == "number" ? String(e) : e, af = (e) => Array.isArray(e) ? e.map(rf) : rf(e), of = (e) => e != null, sf = (e, t) => Object.fromEntries(Object.entries(e).filter(([e]) => t.includes(e))), cf = (e, t) => [...new Set([...Object.keys(e ?? {}), ...Object.keys(t)])].filter((e) => e !== "page"), lf = (e, t, n, r) => {
	let i = Object.entries(e).filter(([e]) => !t.has(e)), a = Object.fromEntries(i), o = Object.entries(n).filter(([e, t]) => e !== "page" && of(t)).map(([e, t]) => [e, af(t)]);
	for (let [e, t] of o) a[e] = t;
	return r > 1 && (a.page = String(r)), a;
}, uf = (e) => JSON.stringify(Object.keys(e).sort().map((t) => {
	let n = e[t];
	return Array.isArray(n) ? [t, [...n].map(String)] : [t, n === void 0 ? void 0 : String(n)];
})), df = (e, t) => uf(e) === uf(t), ff = () => {
	let e = lt().currentRoute.value.query.page;
	return Array.isArray(e) ? 1 : parseInt(e ?? "1");
}, pf = (e, t, n = {}) => {
	let r = lt(), i = r.currentRoute.value, a = cf(t.defaultParameters, i.query), o = sf(i.query, a), s = new Set([...a, "page"]), c, l = 0, u = ye((e) => e(), 350), d, f = async (e) => {
		if (!t.updateUrl) return !0;
		for (let e of Object.keys(d.parameters)) s.add(e);
		let n = r.currentRoute.value, i = lf(n.query, s, d.parameters, e);
		if (df(n.query, i)) return !0;
		let a = r.resolve({
			query: i,
			hash: n.hash
		});
		c = a.fullPath;
		let o = await r.replace({
			query: i,
			hash: n.hash
		});
		if (st(o, ot.aborted) || st(o, ot.cancelled)) return c = void 0, !1;
		let l = r.currentRoute.value;
		return l.name === n.name && l.fullPath === a.fullPath ? (c = void 0, !0) : (c = void 0, !1);
	};
	d = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...o
		} : { ...o },
		results: [],
		currentPage: n.currentPage ?? ff(),
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		async loadResults(n = !1) {
			this.loading = !0;
			let r = ++l;
			try {
				let i = Object.fromEntries(Object.entries(this.parameters).filter(([, e]) => of(e))), { list: a, page: o, previous: s, next: c } = await e.listEntities({ params: {
					...i,
					page: n ? 1 : this.currentPage || 1,
					size: t.pageSize
				} });
				if (r !== l) return;
				this.results = a, this.currentPage = a.length && o || 1, this.previousPageLink = s, this.nextPageLink = c;
			} finally {
				r === l && (this.loading = !1);
			}
		},
		async clearSearch() {
			u.cancel();
			for (let e of Object.keys(this.parameters)) s.add(e);
			this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.currentPage = 1, await f(1) && await this.loadResults(!0);
		},
		async updateUrl() {
			await f(d.currentPage);
		},
		goToPage(e) {
			this.currentPage = e, (async () => {
				await f(e) && await this.loadResults();
			})();
		}
	});
	let p = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = d.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : of(n) ? e + 1 : e, 0);
	}), m = (e = !1) => d.loadResults(e);
	return nf(m), qe([() => d.parameters], async () => {
		let e = t.defaultPageReset ?? !0, n = e ? 1 : d.currentPage;
		e && (d.currentPage = 1), await f(n) && u(() => d.loadResults(e));
	}, { deep: !0 }), qe(r.currentRoute, (e, n) => {
		if (c && e.fullPath === c) {
			c = void 0;
			return;
		}
		n.name === e.name && Object.values(e.query).length === 0 && (d.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, d.currentPage = 1);
	}), qe(p, (e) => {
		d.activeFiltersCount = e;
	}), Fe(m), Ie(() => {
		l += 1, u.cancel();
	}), d;
}, mf = (e, t, n = {}) => {
	let r = lt(), i = r.currentRoute.value, a = cf(t.defaultParameters, i.query), o = sf(i.query, a), s = new Set([...a, "page"]), c, l = 0, u = ye((e) => e(), 350), d, f = async (e) => {
		if (!t.updateUrl) return !0;
		for (let e of Object.keys(d.parameters)) s.add(e);
		let n = r.currentRoute.value, i = lf(n.query, s, d.parameters, e);
		if (df(n.query, i)) return !0;
		let a = r.resolve({
			query: i,
			hash: n.hash
		});
		c = a.fullPath;
		let o = await r.replace({
			query: i,
			hash: n.hash
		});
		if (st(o, ot.aborted) || st(o, ot.cancelled)) return c = void 0, !1;
		let l = r.currentRoute.value;
		return l.name === n.name && l.fullPath === a.fullPath ? (c = void 0, !0) : (c = void 0, !1);
	};
	d = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...o
		} : { ...o },
		results: [],
		coreResults: [],
		companions: t.initialCompanions,
		currentPage: n.currentPage ?? ff(),
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		async loadResults(n = !1) {
			this.loading = !0;
			let r = ++l;
			try {
				let i = Object.fromEntries(Object.entries(this.parameters).filter(([, e]) => of(e))), { list: a, page: o, previous: s, next: c } = await e.listEntities({ params: {
					...i,
					page: n ? 1 : this.currentPage || 1,
					size: t.pageSize
				} }), u = await Promise.all(Object.entries(t.companionFetchers).map(async ([e, t]) => [e, await t({
					coreResults: a,
					currentPage: o || 1,
					parameters: this.parameters
				})]));
				if (r !== l) return;
				let d = u.reduce((e, [t, n]) => ({
					...e,
					[t]: n
				}), {});
				this.coreResults = a, this.companions = d, this.results = t.mapResults ? t.mapResults(a, d) : a, this.currentPage = a.length && o || 1, this.previousPageLink = s, this.nextPageLink = c;
			} finally {
				r === l && (this.loading = !1);
			}
		},
		async clearSearch() {
			u.cancel();
			for (let e of Object.keys(this.parameters)) s.add(e);
			this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.currentPage = 1, await f(1) && await this.loadResults(!0);
		},
		async updateUrl() {
			await f(d.currentPage);
		},
		goToPage(e) {
			this.currentPage = e, (async () => {
				await f(e) && await this.loadResults();
			})();
		}
	});
	let p = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = d.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : of(n) ? e + 1 : e, 0);
	}), m = (e = !1) => d.loadResults(e);
	return nf(m), qe([() => d.parameters], async () => {
		let e = t.defaultPageReset ?? !0, n = e ? 1 : d.currentPage;
		e && (d.currentPage = 1), await f(n) && u(() => d.loadResults(e));
	}, { deep: !0 }), qe(r.currentRoute, (e, n) => {
		if (c && e.fullPath === c) {
			c = void 0;
			return;
		}
		n.name === e.name && Object.values(e.query).length === 0 && (d.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, d.currentPage = 1);
	}), qe(p, (e) => {
		d.activeFiltersCount = e;
	}), Fe(m), Ie(() => {
		l += 1, u.cancel();
	}), d;
}, hf = {
	dialog: !1,
	multi: !1
}, gf = "History", _f = mc(gf), { listEntities: vf } = _f, yf = async (e) => ((await vf({ params: {
	entityId: e,
	page: 1,
	size: 1
} })).list ?? []).pop(), bf = (e) => {
	e.use(_e, {
		plugins: {
			Notify: r,
			Dialog: t,
			Loading: n
		},
		lang: Xa()
	});
}, xf = () => !0, Sf = {
	date: xf,
	time: xf,
	fulltime: xf,
	timeOrFulltime: xf,
	email: xf,
	hexColor: xf,
	hexaColor: xf,
	hexOrHexaColor: xf,
	rgbColor: xf,
	rgbaColor: xf,
	rgbOrRgbaColor: xf,
	hexOrRgbColor: xf,
	hexaOrRgbaColor: xf,
	anyColor: xf
}, Cf = (e, t) => {
	if (!t) return "";
	let n;
	return t.reverse().forEach((t) => {
		if (typeof t == "function") {
			let r = t(e, Sf);
			typeof r == "string" && r.length && (n = r);
		}
	}), n || "";
}, wf = (e, t) => e?.map((e) => ({
	...e,
	style: (e) => t?.(e) ? {
		background: "var(--app-bg)",
		cursor: "not-allowed"
	} : ""
})) || [], Tf = {
	class: "self-center full-width no-outline text-black",
	"data-qa-history-entity-create-date": ""
}, Ef = {
	class: "self-center full-width no-outline text-black",
	"data-qa-history-entity-first-published-date": ""
}, Df = ["data-qa-history-last-change-by-row"], Of = ["data-qa-history-action-row"], kf = ["data-qa-history-description-row"], Af = ["data-qa-history-modifiedAt-row"], jf = /* @__PURE__ */ A({
	__name: "history-tab",
	props: {
		entity: {},
		entityId: {},
		entityCreateDate: {},
		entityFirstPublishedDate: {},
		dateFormat: {}
	},
	setup(e, { expose: t }) {
		let n = e, { t: r } = rt(), i = pf(_f, {
			updateUrl: !1,
			defaultPageReset: !1,
			defaultParameters: { entityId: n.entityId }
		});
		t({ search: i });
		let a = (e) => e ? n.dateFormat ? cs(new Date(e), n.dateFormat) : zs(e) : "-", o = a(n.entityCreateDate), s = a(n.entityFirstPublishedDate), c = (e) => {
			if (!e) return "";
			let t = "";
			return e.state ? t = e.state ? `${e.state.oldValue} => ${e.state.newValue}` : "" : e._description && (t = r(`historyEntryDescriptions.${e._description}`)), t;
		}, l = wf([
			{
				name: "modifiedBy",
				align: "left",
				label: r("articlesVersions.modifiedBy"),
				field: (e) => e.actorLabel
			},
			{
				name: "action",
				align: "left",
				label: r("common.action"),
				field: (e) => e.action
			},
			{
				name: "description",
				align: "left",
				label: r("common.description"),
				field: (e) => e.changes
			},
			{
				name: "modifiedAt",
				align: "left",
				label: r("articlesVersions.modifiedAt"),
				field: (e) => e.createDate
			}
		]);
		return (t, n) => (j(), E(Ce, null, [
			e.entityCreateDate ? (j(), w(P(m), {
				key: 0,
				class: "q-mb-sm",
				standout: "bg-teal-1",
				dense: ""
			}, {
				default: F(() => [D("div", Tf, N(P(r)("historyEntryDescriptions.createDate", { date: P(o) })), 1)]),
				_: 1
			})) : T("", !0),
			e.entityFirstPublishedDate ? (j(), w(P(m), {
				key: 1,
				class: "q-mb-sm",
				standout: "bg-teal-1",
				dense: ""
			}, {
				default: F(() => [D("div", Ef, N(P(r)("historyEntryDescriptions.firstPublishedDate", { date: P(s) })), 1)]),
				_: 1
			})) : T("", !0),
			k(P(S), {
				columns: P(l),
				rows: P(i).results,
				"rows-per-page-options": [0],
				flat: "",
				"hide-bottom": "",
				"row-key": "name",
				"table-header-class": "text-grey-8"
			}, {
				"header-cell": F((e) => [k(P(fe), {
					props: e,
					"data-qa-column-header": e.col.name
				}, {
					default: F(() => [O(N(e.col.label), 1)]),
					_: 2
				}, 1032, ["props", "data-qa-column-header"])]),
				"body-cell-modifiedBy": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-last-change-by-row": e?.rowIndex }, N(e.row.actorLabel), 9, Df)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-action": F((t) => [k(P(de), { props: t }, {
					default: F(() => [D("span", { "data-qa-history-action-row": t?.rowIndex }, N(e.entity + " " + t.row.action), 9, Of)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-description": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-description-row": e?.rowIndex }, N(c(e.row.changes)), 9, kf)]),
					_: 2
				}, 1032, ["props"])]),
				"body-cell-modifiedAt": F((e) => [k(P(de), { props: e }, {
					default: F(() => [D("span", { "data-qa-history-modifiedAt-row": e?.rowIndex }, N(a(e.row.createDate)), 9, Af)]),
					_: 2
				}, 1032, ["props"])]),
				_: 1
			}, 8, ["columns", "rows"]),
			Je(k(tf, {
				pagination: P(i),
				class: "justify-center"
			}, null, 8, ["pagination"]), [[Ke, P(i).nextPageLink || P(i).previousPageLink]])
		], 64));
	}
}), Mf = /* @__PURE__ */ A({
	__name: "tag-input",
	props: /* @__PURE__ */ Ae({
		name: {},
		label: {},
		disable: {
			type: Boolean,
			default: !1
		},
		readonly: {
			type: Boolean,
			default: !1
		},
		rules: { default: () => [] }
	}, {
		modelValue: { default: () => [] },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = Ge(e, "modelValue"), n = M(), r = (e) => {
			if (e.includes(" ") || e.includes(",")) {
				let r = e.replace(/[,\s]/g, "");
				t.value.includes(r) || t.value.push(r), n.value && n.value.updateInputValue("");
			}
		};
		return (i, a) => (j(), w(P(re), je({
			ref_key: "clearTags",
			ref: n
		}, i.$attrs, {
			modelValue: t.value,
			"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
			"use-input": "",
			"use-chips": "",
			multiple: "",
			"new-value-mode": "add-unique",
			dense: "",
			outlined: "",
			"hide-dropdown-icon": "",
			"dropdown-icon": "expand_more",
			label: e.label,
			"data-qa": `${e.name}-input`,
			rules: e.rules,
			disable: e.disable,
			readonly: e.readonly,
			onInputValue: r
		}), {
			"selected-item": F((t) => [k(P(d), {
				"data-qa": e.name,
				removable: "",
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt), 1)]),
				_: 2
			}, 1032, [
				"data-qa",
				"tabindex",
				"onRemove"
			])]),
			_: 1
		}, 16, [
			"modelValue",
			"label",
			"data-qa",
			"rules",
			"disable",
			"readonly"
		]));
	}
}), Nf = /* @__PURE__ */ A({
	__name: "tag-selector",
	props: /* @__PURE__ */ Ae({
		name: { default: "" },
		label: {},
		options: { default: () => [] },
		fetchLabel: {
			type: Function,
			default: void 0
		},
		autocomplete: {
			type: Boolean,
			default: !1
		},
		filterFnAsync: {
			type: Function,
			default: void 0
		},
		loading: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		},
		readonly: {
			type: Boolean,
			default: !1
		},
		rules: { default: () => [] }
	}, {
		modelValue: {
			required: !0,
			default: () => []
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = Ge(e, "modelValue"), r = M([]), i = M(), a = async (e) => {
			let n = t.options.find((t) => t.value === e)?.label;
			return n ||= await t.fetchLabel?.(e), n || e;
		}, o = (e, n) => {
			let r = t.options.find((t) => t.label === e);
			r && (i.value?.updateInputValue(""), n(r));
		}, s = (e, n) => {
			n(async () => {
				if (t.autocomplete) {
					if (t.filterFnAsync) {
						r.value = await t.filterFnAsync(e);
						return;
					}
					r.value = t.options.filter((t) => t.label.includes(e));
				}
			});
		}, c = () => {
			i.value?.updateInputValue("");
		}, l = () => {
			i.value?.setOptionIndex(-1);
		};
		return qe(() => t.options, (e) => {
			r.value = e;
		}), (t, u) => (j(), w(P(re), je({
			ref_key: "selectRef",
			ref: i
		}, t.$attrs, {
			modelValue: n.value,
			"onUpdate:modelValue": u[0] ||= (e) => n.value = e,
			options: r.value,
			"use-input": "",
			"use-chips": "",
			multiple: "",
			"new-value-mode": "add-unique",
			dense: "",
			outlined: "",
			label: e.label,
			"hide-dropdown-icon": "",
			"dropdown-icon": "expand_more",
			"map-options": "",
			[`data-qa-${e.name}-selector` || ""]: e.name,
			loading: e.loading,
			rules: e.rules,
			disable: e.disable,
			readonly: e.readonly,
			onNewValue: o,
			onFilter: s,
			onAdd: c,
			onInputValue: l
		}), we({
			"selected-item": F((t) => [k(P(d), {
				"data-qa-tag": "",
				removable: !e.disable && !e.readonly,
				dense: "",
				tabindex: t.tabindex,
				color: "cyan-1",
				"text-color": "dark",
				onRemove: (e) => t.removeAtIndex(t.index)
			}, {
				default: F(() => [O(N(t.opt.label || a(t)), 1)]),
				_: 2
			}, 1032, [
				"removable",
				"tabindex",
				"onRemove"
			])]),
			_: 2
		}, [Ve(t.$slots, (e, n) => ({
			name: n,
			fn: F((e) => [He(t.$slots, n, Pe(Ee(e ?? {})))])
		}))]), 1040, [
			"modelValue",
			"options",
			"label",
			"loading",
			"rules",
			"disable",
			"readonly"
		]));
	}
}), Pf = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "toggle-button",
	props: /* @__PURE__ */ Ae({
		options: {},
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = C(() => t.options.filter((e) => e.slot && e.tooltip)), r = Ge(e, "modelValue");
		return (t, i) => (j(), w(P(o), je(t.$attrs, {
			modelValue: r.value,
			"onUpdate:modelValue": i[0] ||= (e) => r.value = e,
			unelevated: "",
			outline: "",
			options: e.options,
			disable: e.disable,
			class: "toggle-button"
		}), we({ _: 2 }, [Ve(n.value, (e) => ({
			name: e.slot,
			fn: F(() => [k(P(ge), null, {
				default: F(() => [O(N(e.tooltip), 1)]),
				_: 2
			}, 1024)])
		}))]), 1040, [
			"modelValue",
			"options",
			"disable"
		]));
	}
}), [["__scopeId", "data-v-5d75c462"]]), Ff = (e) => {
	let t = M(null), n = M(null), r = M(!0);
	return {
		dragOverId: n,
		insertBefore: r,
		onDragStart: (e) => t.value = e,
		onDragOver: (e, i) => {
			if (e.preventDefault(), !t.value || t.value === i) return;
			n.value = i;
			let a = e.currentTarget;
			if (!(a instanceof HTMLElement)) return;
			let { left: o, width: s } = a.getBoundingClientRect();
			r.value = e.clientX < o + s / 2;
		},
		onDragLeave: () => n.value = null,
		onDrop: (n) => {
			if (!t.value || t.value === n) return;
			let i = [...e.value], a = i.indexOf(t.value);
			if (a === -1) return;
			i.splice(a, 1);
			let o = i.indexOf(n);
			o !== -1 && (i.splice(r.value ? o : o + 1, 0, t.value), e.value = i);
		},
		onDragEnd: () => {
			t.value = null, n.value = null;
		}
	};
}, If = typeof global == "object" && global && global.Object === Object && global, Lf = typeof self == "object" && self && self.Object === Object && self, Rf = If || Lf || Function("return this")(), zf = Rf.Symbol, Bf = Object.prototype, Vf = Bf.hasOwnProperty, Hf = Bf.toString, Uf = zf ? zf.toStringTag : void 0;
function Wf(e) {
	var t = Vf.call(e, Uf), n = e[Uf];
	try {
		e[Uf] = void 0;
		var r = !0;
	} catch {}
	var i = Hf.call(e);
	return r && (t ? e[Uf] = n : delete e[Uf]), i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_objectToString.js
var Gf = Object.prototype.toString;
function Kf(e) {
	return Gf.call(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGetTag.js
var qf = "[object Null]", Jf = "[object Undefined]", Yf = zf ? zf.toStringTag : void 0;
function Xf(e) {
	return e == null ? e === void 0 ? Jf : qf : Yf && Yf in Object(e) ? Wf(e) : Kf(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isObjectLike.js
function Zf(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isSymbol.js
var Qf = "[object Symbol]";
function $f(e) {
	return typeof e == "symbol" || Zf(e) && Xf(e) == Qf;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayMap.js
function ep(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArray.js
var tp = Array.isArray, np = Infinity, rp = zf ? zf.prototype : void 0, ip = rp ? rp.toString : void 0;
function ap(e) {
	if (typeof e == "string") return e;
	if (tp(e)) return ep(e, ap) + "";
	if ($f(e)) return ip ? ip.call(e) : "";
	var t = e + "";
	return t == "0" && 1 / e == -np ? "-0" : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isObject.js
function op(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/identity.js
function sp(e) {
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isFunction.js
var cp = "[object AsyncFunction]", lp = "[object Function]", up = "[object GeneratorFunction]", dp = "[object Proxy]";
function fp(e) {
	if (!op(e)) return !1;
	var t = Xf(e);
	return t == lp || t == up || t == cp || t == dp;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_coreJsData.js
var pp = Rf["__core-js_shared__"], mp = function() {
	var e = /[^.]+$/.exec(pp && pp.keys && pp.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function hp(e) {
	return !!mp && mp in e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_toSource.js
var gp = Function.prototype.toString;
function _p(e) {
	if (e != null) {
		try {
			return gp.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsNative.js
var vp = /[\\^$.*+?()[\]{}|]/g, yp = /^\[object .+?Constructor\]$/, bp = Function.prototype, xp = Object.prototype, Sp = bp.toString, Cp = xp.hasOwnProperty, wp = RegExp("^" + Sp.call(Cp).replace(vp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Tp(e) {
	return !op(e) || hp(e) ? !1 : (fp(e) ? wp : yp).test(_p(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getValue.js
function Ep(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getNative.js
function Dp(e, t) {
	var n = Ep(e, t);
	return Tp(n) ? n : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_WeakMap.js
var Op = Dp(Rf, "WeakMap"), kp = Object.create, Ap = function() {
	function e() {}
	return function(t) {
		if (!op(t)) return {};
		if (kp) return kp(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_apply.js
function jp(e, t, n) {
	switch (n.length) {
		case 0: return e.call(t);
		case 1: return e.call(t, n[0]);
		case 2: return e.call(t, n[0], n[1]);
		case 3: return e.call(t, n[0], n[1], n[2]);
	}
	return e.apply(t, n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copyArray.js
function Mp(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_shortOut.js
var Np = 800, Pp = 16, Fp = Date.now;
function Ip(e) {
	var t = 0, n = 0;
	return function() {
		var r = Fp(), i = Pp - (r - n);
		if (n = r, i > 0) {
			if (++t >= Np) return arguments[0];
		} else t = 0;
		return e.apply(void 0, arguments);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/constant.js
function Lp(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_defineProperty.js
var Rp = function() {
	try {
		var e = Dp(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}(), zp = Ip(Rp ? function(e, t) {
	return Rp(e, "toString", {
		configurable: !0,
		enumerable: !1,
		value: Lp(t),
		writable: !0
	});
} : sp);
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayEach.js
function Bp(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isIndex.js
var Vp = 9007199254740991, Hp = /^(?:0|[1-9]\d*)$/;
function Up(e, t) {
	var n = typeof e;
	return t ??= Vp, !!t && (n == "number" || n != "symbol" && Hp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssignValue.js
function Wp(e, t, n) {
	t == "__proto__" && Rp ? Rp(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/eq.js
function Gp(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_assignValue.js
var Kp = Object.prototype.hasOwnProperty;
function qp(e, t, n) {
	var r = e[t];
	(!(Kp.call(e, t) && Gp(r, n)) || n === void 0 && !(t in e)) && Wp(e, t, n);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copyObject.js
function Jp(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? Wp(n, s, c) : qp(n, s, c);
	}
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_overRest.js
var Yp = Math.max;
function Xp(e, t, n) {
	return t = Yp(t === void 0 ? e.length - 1 : t, 0), function() {
		for (var r = arguments, i = -1, a = Yp(r.length - t, 0), o = Array(a); ++i < a;) o[i] = r[t + i];
		i = -1;
		for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
		return s[t] = n(o), jp(e, this, s);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isLength.js
var Zp = 9007199254740991;
function Qp(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Zp;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArrayLike.js
function $p(e) {
	return e != null && Qp(e.length) && !fp(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isPrototype.js
var em = Object.prototype;
function tm(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || em);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseTimes.js
function nm(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsArguments.js
var rm = "[object Arguments]";
function im(e) {
	return Zf(e) && Xf(e) == rm;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isArguments.js
var am = Object.prototype, om = am.hasOwnProperty, sm = am.propertyIsEnumerable, cm = im(function() {
	return arguments;
}()) ? im : function(e) {
	return Zf(e) && om.call(e, "callee") && !sm.call(e, "callee");
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/stubFalse.js
function lm() {
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isBuffer.js
var um = typeof exports == "object" && exports && !exports.nodeType && exports, dm = um && typeof module == "object" && module && !module.nodeType && module, fm = dm && dm.exports === um ? Rf.Buffer : void 0, pm = (fm ? fm.isBuffer : void 0) || lm, mm = "[object Arguments]", hm = "[object Array]", gm = "[object Boolean]", _m = "[object Date]", vm = "[object Error]", ym = "[object Function]", bm = "[object Map]", xm = "[object Number]", Sm = "[object Object]", Cm = "[object RegExp]", wm = "[object Set]", Tm = "[object String]", Em = "[object WeakMap]", Dm = "[object ArrayBuffer]", Om = "[object DataView]", km = "[object Float32Array]", Am = "[object Float64Array]", jm = "[object Int8Array]", Mm = "[object Int16Array]", Nm = "[object Int32Array]", Pm = "[object Uint8Array]", Fm = "[object Uint8ClampedArray]", Im = "[object Uint16Array]", Lm = "[object Uint32Array]", Z = {};
Z[km] = Z[Am] = Z[jm] = Z[Mm] = Z[Nm] = Z[Pm] = Z[Fm] = Z[Im] = Z[Lm] = !0, Z[mm] = Z[hm] = Z[Dm] = Z[gm] = Z[Om] = Z[_m] = Z[vm] = Z[ym] = Z[bm] = Z[xm] = Z[Sm] = Z[Cm] = Z[wm] = Z[Tm] = Z[Em] = !1;
function Rm(e) {
	return Zf(e) && Qp(e.length) && !!Z[Xf(e)];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseUnary.js
function zm(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nodeUtil.js
var Bm = typeof exports == "object" && exports && !exports.nodeType && exports, Vm = Bm && typeof module == "object" && module && !module.nodeType && module, Hm = Vm && Vm.exports === Bm && If.process, Um = function() {
	try {
		return Vm && Vm.require && Vm.require("util").types || Hm && Hm.binding && Hm.binding("util");
	} catch {}
}(), Wm = Um && Um.isTypedArray, Gm = Wm ? zm(Wm) : Rm, Km = Object.prototype.hasOwnProperty;
function qm(e, t) {
	var n = tp(e), r = !n && cm(e), i = !n && !r && pm(e), a = !n && !r && !i && Gm(e), o = n || r || i || a, s = o ? nm(e.length, String) : [], c = s.length;
	for (var l in e) (t || Km.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Up(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_overArg.js
function Jm(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeKeys.js
var Ym = Jm(Object.keys, Object), Xm = Object.prototype.hasOwnProperty;
function Zm(e) {
	if (!tm(e)) return Ym(e);
	var t = [];
	for (var n in Object(e)) Xm.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/keys.js
function Qm(e) {
	return $p(e) ? qm(e) : Zm(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeKeysIn.js
function $m(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseKeysIn.js
var eh = Object.prototype.hasOwnProperty;
function th(e) {
	if (!op(e)) return $m(e);
	var t = tm(e), n = [];
	for (var r in e) r == "constructor" && (t || !eh.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/keysIn.js
function nh(e) {
	return $p(e) ? qm(e, !0) : th(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isKey.js
var rh = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ih = /^\w*$/;
function ah(e, t) {
	if (tp(e)) return !1;
	var n = typeof e;
	return n == "number" || n == "symbol" || n == "boolean" || e == null || $f(e) ? !0 : ih.test(e) || !rh.test(e) || t != null && e in Object(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_nativeCreate.js
var oh = Dp(Object, "create");
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashClear.js
function sh() {
	this.__data__ = oh ? oh(null) : {}, this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashDelete.js
function ch(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashGet.js
var lh = "__lodash_hash_undefined__", uh = Object.prototype.hasOwnProperty;
function dh(e) {
	var t = this.__data__;
	if (oh) {
		var n = t[e];
		return n === lh ? void 0 : n;
	}
	return uh.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashHas.js
var fh = Object.prototype.hasOwnProperty;
function ph(e) {
	var t = this.__data__;
	return oh ? t[e] !== void 0 : fh.call(t, e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_hashSet.js
var mh = "__lodash_hash_undefined__";
function hh(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = oh && t === void 0 ? mh : t, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Hash.js
function gh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
gh.prototype.clear = sh, gh.prototype.delete = ch, gh.prototype.get = dh, gh.prototype.has = ph, gh.prototype.set = hh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheClear.js
function _h() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_assocIndexOf.js
function vh(e, t) {
	for (var n = e.length; n--;) if (Gp(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheDelete.js
var yh = Array.prototype.splice;
function bh(e) {
	var t = this.__data__, n = vh(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : yh.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheGet.js
function xh(e) {
	var t = this.__data__, n = vh(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheHas.js
function Sh(e) {
	return vh(this.__data__, e) > -1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_listCacheSet.js
function Ch(e, t) {
	var n = this.__data__, r = vh(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_ListCache.js
function wh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
wh.prototype.clear = _h, wh.prototype.delete = bh, wh.prototype.get = xh, wh.prototype.has = Sh, wh.prototype.set = Ch;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Map.js
var Th = Dp(Rf, "Map");
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheClear.js
function Eh() {
	this.size = 0, this.__data__ = {
		hash: new gh(),
		map: new (Th || wh)(),
		string: new gh()
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isKeyable.js
function Dh(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getMapData.js
function Oh(e, t) {
	var n = e.__data__;
	return Dh(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheDelete.js
function kh(e) {
	var t = Oh(this, e).delete(e);
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheGet.js
function Ah(e) {
	return Oh(this, e).get(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheHas.js
function jh(e) {
	return Oh(this, e).has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapCacheSet.js
function Mh(e, t) {
	var n = Oh(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_MapCache.js
function Nh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Nh.prototype.clear = Eh, Nh.prototype.delete = kh, Nh.prototype.get = Ah, Nh.prototype.has = jh, Nh.prototype.set = Mh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/memoize.js
var Ph = "Expected a function";
function Fh(e, t) {
	if (typeof e != "function" || t != null && typeof t != "function") throw TypeError(Ph);
	var n = function() {
		var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
		if (a.has(i)) return a.get(i);
		var o = e.apply(this, r);
		return n.cache = a.set(i, o) || a, o;
	};
	return n.cache = new (Fh.Cache || Nh)(), n;
}
Fh.Cache = Nh;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_memoizeCapped.js
var Ih = 500;
function Lh(e) {
	var t = Fh(e, function(e) {
		return n.size === Ih && n.clear(), e;
	}), n = t.cache;
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stringToPath.js
var Rh = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, zh = /\\(\\)?/g, Bh = Lh(function(e) {
	var t = [];
	return e.charCodeAt(0) === 46 && t.push(""), e.replace(Rh, function(e, n, r, i) {
		t.push(r ? i.replace(zh, "$1") : n || e);
	}), t;
});
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/toString.js
function Vh(e) {
	return e == null ? "" : ap(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_castPath.js
function Hh(e, t) {
	return tp(e) ? e : ah(e, t) ? [e] : Bh(Vh(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_toKey.js
var Uh = Infinity;
function Wh(e) {
	if (typeof e == "string" || $f(e)) return e;
	var t = e + "";
	return t == "0" && 1 / e == -Uh ? "-0" : t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGet.js
function Gh(e, t) {
	t = Hh(t, e);
	for (var n = 0, r = t.length; e != null && n < r;) e = e[Wh(t[n++])];
	return n && n == r ? e : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayPush.js
function Kh(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_isFlattenable.js
var qh = zf ? zf.isConcatSpreadable : void 0;
function Jh(e) {
	return tp(e) || cm(e) || !!(qh && e && e[qh]);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseFlatten.js
function Yh(e, t, n, r, i) {
	var a = -1, o = e.length;
	for (n ||= Jh, i ||= []; ++a < o;) {
		var s = e[a];
		t > 0 && n(s) ? t > 1 ? Yh(s, t - 1, n, r, i) : Kh(i, s) : r || (i[i.length] = s);
	}
	return i;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/flatten.js
function Xh(e) {
	return e != null && e.length ? Yh(e, 1) : [];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_flatRest.js
function Zh(e) {
	return zp(Xp(e, void 0, Xh), e + "");
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getPrototype.js
var Qh = Jm(Object.getPrototypeOf, Object), $h = "[object Object]", eg = Function.prototype, tg = Object.prototype, ng = eg.toString, rg = tg.hasOwnProperty, ig = ng.call(Object);
function ag(e) {
	if (!Zf(e) || Xf(e) != $h) return !1;
	var t = Qh(e);
	if (t === null) return !0;
	var n = rg.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n instanceof n && ng.call(n) == ig;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseSlice.js
function og(e, t, n) {
	var r = -1, i = e.length;
	t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
	for (var a = Array(i); ++r < i;) a[r] = e[r + t];
	return a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackClear.js
function sg() {
	this.__data__ = new wh(), this.size = 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackDelete.js
function cg(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackGet.js
function lg(e) {
	return this.__data__.get(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackHas.js
function ug(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_stackSet.js
var dg = 200;
function fg(e, t) {
	var n = this.__data__;
	if (n instanceof wh) {
		var r = n.__data__;
		if (!Th || r.length < dg - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Nh(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Stack.js
function pg(e) {
	var t = this.__data__ = new wh(e);
	this.size = t.size;
}
pg.prototype.clear = sg, pg.prototype.delete = cg, pg.prototype.get = lg, pg.prototype.has = ug, pg.prototype.set = fg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssign.js
function mg(e, t) {
	return e && Jp(t, Qm(t), e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseAssignIn.js
function hg(e, t) {
	return e && Jp(t, nh(t), e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneBuffer.js
var gg = typeof exports == "object" && exports && !exports.nodeType && exports, _g = gg && typeof module == "object" && module && !module.nodeType && module, vg = _g && _g.exports === gg ? Rf.Buffer : void 0, yg = vg ? vg.allocUnsafe : void 0;
function bg(e, t) {
	if (t) return e.slice();
	var n = e.length, r = yg ? yg(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arrayFilter.js
function xg(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/stubArray.js
function Sg() {
	return [];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getSymbols.js
var Cg = Object.prototype.propertyIsEnumerable, wg = Object.getOwnPropertySymbols, Tg = wg ? function(e) {
	return e == null ? [] : (e = Object(e), xg(wg(e), function(t) {
		return Cg.call(e, t);
	}));
} : Sg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copySymbols.js
function Eg(e, t) {
	return Jp(e, Tg(e), t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getSymbolsIn.js
var Dg = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) Kh(t, Tg(e)), e = Qh(e);
	return t;
} : Sg;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_copySymbolsIn.js
function Og(e, t) {
	return Jp(e, Dg(e), t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseGetAllKeys.js
function kg(e, t, n) {
	var r = t(e);
	return tp(e) ? r : Kh(r, n(e));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getAllKeys.js
function Ag(e) {
	return kg(e, Qm, Tg);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_getAllKeysIn.js
function jg(e) {
	return kg(e, nh, Dg);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_DataView.js
var Mg = Dp(Rf, "DataView"), Ng = Dp(Rf, "Promise"), Pg = Dp(Rf, "Set"), Fg = "[object Map]", Ig = "[object Object]", Lg = "[object Promise]", Rg = "[object Set]", zg = "[object WeakMap]", Bg = "[object DataView]", Vg = _p(Mg), Hg = _p(Th), Ug = _p(Ng), Wg = _p(Pg), Gg = _p(Op), Kg = Xf;
(Mg && Kg(new Mg(/* @__PURE__ */ new ArrayBuffer(1))) != Bg || Th && Kg(new Th()) != Fg || Ng && Kg(Ng.resolve()) != Lg || Pg && Kg(new Pg()) != Rg || Op && Kg(new Op()) != zg) && (Kg = function(e) {
	var t = Xf(e), n = t == Ig ? e.constructor : void 0, r = n ? _p(n) : "";
	if (r) switch (r) {
		case Vg: return Bg;
		case Hg: return Fg;
		case Ug: return Lg;
		case Wg: return Rg;
		case Gg: return zg;
	}
	return t;
});
var qg = Kg, Jg = Object.prototype.hasOwnProperty;
function Yg(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && Jg.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_Uint8Array.js
var Xg = Rf.Uint8Array;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneArrayBuffer.js
function Zg(e) {
	var t = new e.constructor(e.byteLength);
	return new Xg(t).set(new Xg(e)), t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneDataView.js
function Qg(e, t) {
	var n = t ? Zg(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneRegExp.js
var $g = /\w*$/;
function e_(e) {
	var t = new e.constructor(e.source, $g.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneSymbol.js
var t_ = zf ? zf.prototype : void 0, n_ = t_ ? t_.valueOf : void 0;
function r_(e) {
	return n_ ? Object(n_.call(e)) : {};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cloneTypedArray.js
function i_(e, t) {
	var n = t ? Zg(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_initCloneByTag.js
var a_ = "[object Boolean]", o_ = "[object Date]", s_ = "[object Map]", c_ = "[object Number]", l_ = "[object RegExp]", u_ = "[object Set]", d_ = "[object String]", f_ = "[object Symbol]", p_ = "[object ArrayBuffer]", m_ = "[object DataView]", h_ = "[object Float32Array]", g_ = "[object Float64Array]", __ = "[object Int8Array]", v_ = "[object Int16Array]", y_ = "[object Int32Array]", b_ = "[object Uint8Array]", x_ = "[object Uint8ClampedArray]", S_ = "[object Uint16Array]", C_ = "[object Uint32Array]";
function w_(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case p_: return Zg(e);
		case a_:
		case o_: return new r(+e);
		case m_: return Qg(e, n);
		case h_:
		case g_:
		case __:
		case v_:
		case y_:
		case b_:
		case x_:
		case S_:
		case C_: return i_(e, n);
		case s_: return new r();
		case c_:
		case d_: return new r(e);
		case l_: return e_(e);
		case u_: return new r();
		case f_: return r_(e);
	}
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_initCloneObject.js
function T_(e) {
	return typeof e.constructor == "function" && !tm(e) ? Ap(Qh(e)) : {};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsMap.js
var E_ = "[object Map]";
function D_(e) {
	return Zf(e) && qg(e) == E_;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isMap.js
var O_ = Um && Um.isMap, k_ = O_ ? zm(O_) : D_, A_ = "[object Set]";
function j_(e) {
	return Zf(e) && qg(e) == A_;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isSet.js
var M_ = Um && Um.isSet, N_ = M_ ? zm(M_) : j_, P_ = 1, F_ = 2, I_ = 4, L_ = "[object Arguments]", R_ = "[object Array]", z_ = "[object Boolean]", B_ = "[object Date]", V_ = "[object Error]", H_ = "[object Function]", U_ = "[object GeneratorFunction]", W_ = "[object Map]", G_ = "[object Number]", K_ = "[object Object]", q_ = "[object RegExp]", J_ = "[object Set]", Y_ = "[object String]", X_ = "[object Symbol]", Z_ = "[object WeakMap]", Q_ = "[object ArrayBuffer]", $_ = "[object DataView]", ev = "[object Float32Array]", tv = "[object Float64Array]", nv = "[object Int8Array]", rv = "[object Int16Array]", iv = "[object Int32Array]", av = "[object Uint8Array]", ov = "[object Uint8ClampedArray]", sv = "[object Uint16Array]", cv = "[object Uint32Array]", Q = {};
Q[L_] = Q[R_] = Q[Q_] = Q[$_] = Q[z_] = Q[B_] = Q[ev] = Q[tv] = Q[nv] = Q[rv] = Q[iv] = Q[W_] = Q[G_] = Q[K_] = Q[q_] = Q[J_] = Q[Y_] = Q[X_] = Q[av] = Q[ov] = Q[sv] = Q[cv] = !0, Q[V_] = Q[H_] = Q[Z_] = !1;
function lv(e, t, n, r, i, a) {
	var o, s = t & P_, c = t & F_, l = t & I_;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!op(e)) return e;
	var u = tp(e);
	if (u) {
		if (o = Yg(e), !s) return Mp(e, o);
	} else {
		var d = qg(e), f = d == H_ || d == U_;
		if (pm(e)) return bg(e, s);
		if (d == K_ || d == L_ || f && !i) {
			if (o = c || f ? {} : T_(e), !s) return c ? Og(e, hg(o, e)) : Eg(e, mg(o, e));
		} else {
			if (!Q[d]) return i ? e : {};
			o = w_(e, d, s);
		}
	}
	a ||= new pg();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), N_(e) ? e.forEach(function(r) {
		o.add(lv(r, t, n, r, e, a));
	}) : k_(e) && e.forEach(function(r, i) {
		o.set(i, lv(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? jg : Ag : c ? nh : Qm)(e);
	return Bp(m || e, function(r, i) {
		m && (i = r, r = e[i]), qp(o, i, lv(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/cloneDeep.js
var uv = 1, dv = 4;
function fv(e) {
	return lv(e, uv | dv);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setCacheAdd.js
var pv = "__lodash_hash_undefined__";
function mv(e) {
	return this.__data__.set(e, pv), this;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setCacheHas.js
function hv(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_SetCache.js
function gv(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.__data__ = new Nh(); ++t < n;) this.add(e[t]);
}
gv.prototype.add = gv.prototype.push = mv, gv.prototype.has = hv;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_arraySome.js
function _v(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_cacheHas.js
function vv(e, t) {
	return e.has(t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalArrays.js
var yv = 1, bv = 2;
function xv(e, t, n, r, i, a) {
	var o = n & yv, s = e.length, c = t.length;
	if (s != c && !(o && c > s)) return !1;
	var l = a.get(e), u = a.get(t);
	if (l && u) return l == t && u == e;
	var d = -1, f = !0, p = n & bv ? new gv() : void 0;
	for (a.set(e, t), a.set(t, e); ++d < s;) {
		var m = e[d], h = t[d];
		if (r) var g = o ? r(h, m, d, t, e, a) : r(m, h, d, e, t, a);
		if (g !== void 0) {
			if (g) continue;
			f = !1;
			break;
		}
		if (p) {
			if (!_v(t, function(e, t) {
				if (!vv(p, t) && (m === e || i(m, e, n, r, a))) return p.push(t);
			})) {
				f = !1;
				break;
			}
		} else if (!(m === h || i(m, h, n, r, a))) {
			f = !1;
			break;
		}
	}
	return a.delete(e), a.delete(t), f;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_mapToArray.js
function Sv(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e, r) {
		n[++t] = [r, e];
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_setToArray.js
function Cv(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e) {
		n[++t] = e;
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalByTag.js
var wv = 1, Tv = 2, Ev = "[object Boolean]", Dv = "[object Date]", Ov = "[object Error]", kv = "[object Map]", Av = "[object Number]", jv = "[object RegExp]", Mv = "[object Set]", Nv = "[object String]", Pv = "[object Symbol]", Fv = "[object ArrayBuffer]", Iv = "[object DataView]", Lv = zf ? zf.prototype : void 0, Rv = Lv ? Lv.valueOf : void 0;
function zv(e, t, n, r, i, a, o) {
	switch (n) {
		case Iv:
			if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
			e = e.buffer, t = t.buffer;
		case Fv: return !(e.byteLength != t.byteLength || !a(new Xg(e), new Xg(t)));
		case Ev:
		case Dv:
		case Av: return Gp(+e, +t);
		case Ov: return e.name == t.name && e.message == t.message;
		case jv:
		case Nv: return e == t + "";
		case kv: var s = Sv;
		case Mv:
			var c = r & wv;
			if (s ||= Cv, e.size != t.size && !c) return !1;
			var l = o.get(e);
			if (l) return l == t;
			r |= Tv, o.set(e, t);
			var u = xv(s(e), s(t), r, i, a, o);
			return o.delete(e), u;
		case Pv: if (Rv) return Rv.call(e) == Rv.call(t);
	}
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_equalObjects.js
var Bv = 1, Vv = Object.prototype.hasOwnProperty;
function Hv(e, t, n, r, i, a) {
	var o = n & Bv, s = Ag(e), c = s.length;
	if (c != Ag(t).length && !o) return !1;
	for (var l = c; l--;) {
		var u = s[l];
		if (!(o ? u in t : Vv.call(t, u))) return !1;
	}
	var d = a.get(e), f = a.get(t);
	if (d && f) return d == t && f == e;
	var p = !0;
	a.set(e, t), a.set(t, e);
	for (var m = o; ++l < c;) {
		u = s[l];
		var h = e[u], g = t[u];
		if (r) var ee = o ? r(g, h, u, t, e, a) : r(h, g, u, e, t, a);
		if (!(ee === void 0 ? h === g || i(h, g, n, r, a) : ee)) {
			p = !1;
			break;
		}
		m ||= u == "constructor";
	}
	if (p && !m) {
		var _ = e.constructor, v = t.constructor;
		_ != v && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v) && (p = !1);
	}
	return a.delete(e), a.delete(t), p;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsEqualDeep.js
var Uv = 1, Wv = "[object Arguments]", Gv = "[object Array]", Kv = "[object Object]", qv = Object.prototype.hasOwnProperty;
function Jv(e, t, n, r, i, a) {
	var o = tp(e), s = tp(t), c = o ? Gv : qg(e), l = s ? Gv : qg(t);
	c = c == Wv ? Kv : c, l = l == Wv ? Kv : l;
	var u = c == Kv, d = l == Kv, f = c == l;
	if (f && pm(e)) {
		if (!pm(t)) return !1;
		o = !0, u = !1;
	}
	if (f && !u) return a ||= new pg(), o || Gm(e) ? xv(e, t, n, r, i, a) : zv(e, t, c, n, r, i, a);
	if (!(n & Uv)) {
		var p = u && qv.call(e, "__wrapped__"), m = d && qv.call(t, "__wrapped__");
		if (p || m) {
			var h = p ? e.value() : e, g = m ? t.value() : t;
			return a ||= new pg(), i(h, g, n, r, a);
		}
	}
	return f ? (a ||= new pg(), Hv(e, t, n, r, i, a)) : !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseIsEqual.js
function Yv(e, t, n, r, i) {
	return e === t ? !0 : e == null || t == null || !Zf(e) && !Zf(t) ? e !== e && t !== t : Jv(e, t, n, r, Yv, i);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/last.js
function Xv(e) {
	var t = e == null ? 0 : e.length;
	return t ? e[t - 1] : void 0;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_parent.js
function Zv(e, t) {
	return t.length < 2 ? e : Gh(e, og(t, 0, -1));
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/isEqual.js
function Qv(e, t) {
	return Yv(e, t);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_baseUnset.js
var $v = Object.prototype.hasOwnProperty;
function ey(e, t) {
	t = Hh(t, e);
	var n = -1, r = t.length;
	if (!r) return !0;
	for (var i = e == null || typeof e != "object" && typeof e != "function"; ++n < r;) {
		var a = t[n];
		if (typeof a == "string") {
			if (a === "__proto__" && !$v.call(e, "__proto__")) return !1;
			if (a === "constructor" && n + 1 < r && typeof t[n + 1] == "string" && t[n + 1] === "prototype") {
				if (i && n === 0) continue;
				return !1;
			}
		}
	}
	var o = Zv(e, t);
	return o == null || delete o[Wh(Xv(t))];
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/_customOmitClone.js
function ty(e) {
	return ag(e) ? void 0 : e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/omit.js
var ny = 1, ry = 2, iy = 4, ay = Zh(function(e, t) {
	var n = {};
	if (e == null) return n;
	var r = !1;
	t = ep(t, function(t) {
		return t = Hh(t, e), r ||= t.length > 1, t;
	}), Jp(e, jg(e), n), r && (n = lv(n, ny | ry | iy, ty));
	for (var i = t.length; i--;) ey(n, t[i]);
	return n;
});
//#endregion
//#region src/composables/useChangesWatch.ts
function oy({ watchedValue: e, ignoredRootKeys: t = [], onValueChange: n }) {
	let r = (e) => ay(e, t), i = M(fv(r(e.value))), a = M(!1);
	qe(() => r(e.value), (e, t) => {
		let r = !Qv(i.value, e);
		a.value = r, n && n({
			isChanged: r,
			newValue: e,
			oldValue: t,
			initValue: i
		});
	}, { deep: !0 });
	function o(t = e) {
		a.value = !1, i.value = fv(r(t.value));
	}
	return {
		initValue: i,
		isWatchedValueChanged: a,
		resetChangesWatcher: o
	};
}
//#endregion
//#region src/components/dialogs/changes-watch.dialog.vue?vue&type=script&setup=true&lang.ts
var sy = {
	key: 0,
	class: "text-center"
}, cy = ["textContent"], ly = ["textContent"], uy = /* @__PURE__ */ yc(/* @__PURE__ */ A({
	__name: "changes-watch.dialog",
	props: {
		initValue: {},
		currentValue: {},
		ignoredRootKeys: {}
	},
	emits: [...xe.emits],
	setup(e) {
		let t = nl(), n = M(!1), r = C(() => t.hasRight("changes-diff:read")), i = C(() => n.value && r.value), { dialogRef: o, onDialogCancel: u, onDialogOK: d } = xe(), f = e;
		function m(e) {
			return JSON.stringify(e ?? {}, null, 2);
		}
		function h(e, t) {
			let n = new Blob([t], { type: "application/json" }), r = URL.createObjectURL(n), i = document.createElement("a");
			i.href = r, i.download = e, i.click(), URL.revokeObjectURL(r);
		}
		async function g(e) {
			e === "initial" && h("initial.json", m(f.initValue?.value)), e === "current" && h("current.json", m(f.currentValue?.value));
		}
		return (t, f) => (j(), w(P(p), {
			ref_key: "dialogRef",
			ref: o,
			persistent: ""
		}, {
			default: F(() => [k(P(s), { class: Ne(["changes-dialog", { "changes-dialog--diff-shown": i.value }]) }, {
				default: F(() => [
					k(P(l), { class: "changes-header" }, {
						default: F(() => [i.value ? T("", !0) : (j(), E("div", sy, [D("h6", {
							class: "text-h6 q-pb-md",
							textContent: N(t.$t("changesWatch.dialog.title"))
						}, null, 8, cy), D("p", { textContent: N(t.$t("changesWatch.dialog.text")) }, null, 8, ly)])), i.value ? (j(), w(P(c), {
							key: 1,
							align: "between"
						}, {
							default: F(() => [k(P(a), {
								dense: "",
								flat: "",
								icon: "download",
								label: t.$t("changesWatch.dialog.downloadInitial"),
								onClick: f[0] ||= (e) => g("initial")
							}, null, 8, ["label"]), k(P(a), {
								dense: "",
								flat: "",
								icon: "download",
								label: t.$t("changesWatch.dialog.downloadCurrent"),
								onClick: f[1] ||= (e) => g("current")
							}, null, 8, ["label"])]),
							_: 1
						})) : T("", !0)]),
						_: 1
					}),
					i.value ? (j(), w(P(l), {
						key: 0,
						class: "changes-body q-pa-none"
					}, {
						default: F(() => [(j(), w(Ue(P(Gx)), {
							"old-value": e.initValue,
							"new-value": e.currentValue,
							"ignored-root-keys": e.ignoredRootKeys
						}, null, 8, [
							"old-value",
							"new-value",
							"ignored-root-keys"
						]))]),
						_: 1
					})) : T("", !0),
					k(P(c), {
						class: "changes-footer",
						align: "right"
					}, {
						default: F(() => [
							r.value ? (j(), w(P(a), {
								key: 0,
								icon: n.value ? "eye-off" : "eye",
								flat: "",
								label: t.$t("changesWatch.dialog.inspect"),
								color: "warning",
								onClick: f[2] ||= () => n.value = !n.value
							}, null, 8, ["icon", "label"])) : T("", !0),
							k(P(a), {
								flat: "",
								label: t.$t("changesWatch.dialog.stay"),
								color: "secondary",
								onClick: P(u)
							}, null, 8, ["label", "onClick"]),
							k(P(a), {
								flat: "",
								label: t.$t("changesWatch.dialog.leave"),
								color: "primary",
								onClick: P(d)
							}, null, 8, ["label", "onClick"])
						]),
						_: 1
					})
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 512));
	}
}), [["__scopeId", "data-v-20203376"]]);
//#endregion
//#region src/composables/useConfirmChangesDialog.ts
function dy({ watchedValue: e, ignoredRootKeys: n = [], onValueChange: r }) {
	let i = lt(), a = !1, o = (e) => {
		a = e;
	}, s = (e) => {
		window.onbeforeunload = e ? () => e : null;
	}, { resetChangesWatcher: c, isWatchedValueChanged: l, initValue: u } = oy({
		watchedValue: e,
		ignoredRootKeys: n,
		onValueChange: (e) => {
			r && r(e), s(e.isChanged);
		}
	});
	function d(e) {
		s(!1), c(e);
	}
	return ct((r, o, c) => {
		if (a) {
			c();
			return;
		}
		if (!l.value || o.name === r.name) {
			s(l.value), c();
			return;
		}
		c(!1), t.create({
			component: uy,
			componentProps: {
				initValue: u,
				currentValue: e,
				ignoredRootKeys: n
			}
		}).onOk(async () => {
			d(e), await i.push(r);
		});
	}), {
		initValue: u,
		isWatchedValueChanged: l,
		resetChangesWatcher: d,
		setPreventOnLeaveAlert: o
	};
}
//#endregion
//#region src/composables/useDetectOutsideClick.ts
var fy = (e, t) => {
	if (!e) return { listener: () => {} };
	let n = (n) => {
		n.target !== e.value && n.composedPath().includes(e.value) || typeof t == "function" && t();
	};
	return Le(() => {
		window.addEventListener("click", n);
	}), Ie(() => {
		window.removeEventListener("click", n);
	}), { listener: n };
};
//#endregion
//#region src/composables/useEntityQuery.ts
async function py(e, t) {
	e?.length && await Promise.all(e.map((e) => e(t)));
}
function my(e) {
	let { entityId: t, entityEndpoint: n, api: r, entityStore: i, entityStoreDefaults: a, resetStoreOnComponentUnmount: o = !0, resetCachedDataOnBeforeRouteLeave: s = !0, serverResponseCallbacks: c } = e, l = ft(), u = (e) => P(t) === e, d = (e, t = i) => !!e?.changeDate && !!t?.value?.changeDate && e._id === t.value._id && new Date(e?.changeDate).getTime() === new Date(t.value?.changeDate).getTime(), f = (e) => {
		e && i?.value && (i.value = e);
	}, p = (e) => {
		e && i?.value && (i.value = {
			...i.value,
			...e
		});
	}, m = C(() => [n, P(t)]), { data: h, isLoading: g, refetch: ee } = dt({
		queryKey: m,
		enabled: C(() => !!P(t)),
		queryFn: async ({ signal: e }) => {
			let n = P(t);
			if (!n) throw Error("Query tried to fetch entity with unknown id");
			try {
				let t = await r.getEntity(n, { signal: e });
				return u(n) && (d(t) || (f(t), await py(c, {
					method: "GET",
					status: "success",
					payload: t
				}))), t;
			} catch (e) {
				throw await py(c, {
					method: "GET",
					status: "error",
					payload: e
				}), e;
			}
		}
	}), { isPending: _, mutateAsync: v } = ut({
		mutationKey: m,
		mutationFn: r.postEntity,
		onSuccess: async (e) => {
			l.setQueryData(m.value, e), f(e), await py(c, {
				method: "POST",
				status: "success",
				payload: e
			});
		},
		onError: async (e) => {
			await py(c, {
				method: "POST",
				status: "error",
				payload: e
			});
		}
	}), { isPending: y, mutateAsync: b } = ut({
		mutationKey: m,
		mutationFn: (e) => {
			let i = P(t);
			if (!i) throw Error(`Attempted ${n} PUT request with undefined uuid!`);
			return r.putEntity(i, e);
		},
		onSuccess: async (e) => {
			u(e._id) && (l.setQueryData(m.value, e), f(e), await py(c, {
				method: "PUT",
				status: "success",
				payload: e
			}));
		},
		onError: async (e) => {
			await py(c, {
				method: "PUT",
				status: "error",
				payload: e
			});
		}
	}), { isPending: te, mutateAsync: ne } = ut({
		mutationKey: m,
		mutationFn: (e) => r.deleteEntity(e),
		onSuccess: async () => {
			l.removeQueries({
				queryKey: m.value,
				exact: !0
			}), p(fv(a)), await py(c, {
				method: "DELETE",
				status: "success",
				payload: void 0
			});
		},
		onError: async (e) => {
			await py(c, {
				method: "DELETE",
				status: "error",
				payload: e
			});
		}
	}), x = C(() => _.value || y.value || te.value), re = C(() => g.value || x.value), ie = async (e) => await v(e), ae = async (e) => await b(e), oe = async (e) => {
		await ne(e);
	}, se = async () => {
		let e = P(t);
		if (!e) throw Error("Query tried to fetch and sync entity with unknown id");
		try {
			let t = await r.getEntity(e);
			return l.setQueryData([n, e], t), u(e) ? (f(t), await py(c, {
				method: "GET",
				status: "success",
				payload: t
			}), t) : t;
		} catch (e) {
			throw await py(c, {
				method: "GET",
				status: "error",
				payload: e
			}), e;
		}
	}, ce = () => {
		P(t) && (l.removeQueries({
			queryKey: m.value,
			exact: !0
		}), l.setQueryData(m.value, void 0));
	};
	return Re(() => {
		o && (ce(), p(fv(a)));
	}), ct(() => {
		s && ce();
	}), {
		fetchedEntity: h,
		clearFetchedEntityCache: ce,
		createEntity: ie,
		updateEntity: ae,
		fetchEntity: ee,
		enforcedFetchAndSyncEntityStore: se,
		deleteEntity: oe,
		isFetchingEntity: g,
		isPendingEntityCreation: _,
		isPendingEntityUpdate: y,
		isPendingEntityDelete: te,
		isPendingEntityChangeRequest: x,
		isPendingEntityRequest: re
	};
}
//#endregion
//#region src/composables/useGermanQuoteTransform.ts
function hy(e, t = 100) {
	return ye((t) => {
		if (typeof t != "string" || !it(t)) return;
		let n = at(t);
		n !== t && e(n);
	}, t);
}
//#endregion
//#region src/composables/useInfiniteSearch.ts
var gy = (e) => e instanceof Date ? e.toISOString() : typeof e == "boolean" ? e ? "true" : "false" : e, _y = (e) => Array.isArray(e) ? e.map(gy) : gy(e), vy = () => {
	let e = lt().currentRoute.value.query.page;
	return Array.isArray(e) ? 1 : parseInt(e ?? "1");
}, yy = (e, t, n = {}) => {
	let r = n.currentPage ?? vy(), i = lt(), a = i.currentRoute.value.query, o = null, s = Be({
		loading: !1,
		searchFields: t.searchFields,
		parameters: t.defaultParameters ? {
			...t.defaultParameters,
			...a
		} : { ...a },
		hiddenParameters: t.hiddenParameters,
		results: [],
		resultIds: /* @__PURE__ */ new Set(),
		lastPollResults: [],
		previousPage: r ? r - 1 : 0,
		currentPage: r,
		nextPage: r ? r + 1 : 0,
		previousPageLink: void 0,
		nextPageLink: void 0,
		changedParameters: 0,
		activeFiltersCount: 0,
		lastPollDateTime: void 0,
		isPolling: !1,
		isPollingActive: !1,
		async loadResults(n = !1) {
			if (!this.loading) {
				this.loading = !0, n && (this.resultIds = /* @__PURE__ */ new Set(), this.lastPollResults = [], this.results = [], this.lastPollDateTime = void 0);
				let { list: r, page: i, previous: a, next: o } = await e.listEntities({
					params: {
						...this.parameters,
						page: n ? 1 : this.currentPage || 1,
						size: t.pageSize
					},
					...this.reqPayload ? { data: this.reqPayload } : {}
				});
				this.dedupAndStoreNewResults(r), this.previousPage = i - 1 || 0, this.currentPage = i || 1, this.nextPage = i + 1 || 2, this.previousPageLink = a, this.nextPageLink = o, await this.updateUrl(), this.loading = !1;
			}
		},
		clearSearch() {
			return this.parameters = t.defaultParameters ? { ...t.defaultParameters } : {}, this.loadResults(!0);
		},
		async updateUrl() {
			if (t.updateUrl) {
				let e = Object.assign({}, s.parameters), t = Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0).map(([e, t]) => [e, _y(t)]));
				s.hiddenParameters?.length && s.hiddenParameters.forEach((e) => {
					delete t[e];
				}), await i.replace({ query: t });
			}
		},
		async goToPage(e) {
			this.currentPage = e, await this.loadResults();
		},
		dedupAndStoreNewResults(e, t = !1) {
			let n = e.filter((e) => e._id && !this.resultIds.has(e._id));
			this.results = t ? [...n, ...this.results] : [...this.results, ...n], t && (this.lastPollResults = n);
			let r = n.map((e) => e._id).filter((e) => typeof e == "string");
			this.resultIds = new Set(Array.from(this.resultIds).concat(r));
		},
		async pollForNewResults(t, n, r) {
			if (!(this.loading || this.isPolling)) {
				if (n !== i.currentRoute.value.path) {
					this.stopPolling();
					return;
				}
				this.isPolling = !0;
				try {
					let { list: n } = await e.listEntities({
						params: {
							...this.parameters,
							page: 1,
							size: t,
							...r ? { [r]: this.lastPollDateTime } : {}
						},
						...this.reqPayload ? { data: this.reqPayload } : {}
					}), i = n.findIndex((e) => e._id === this.results[0]?._id);
					i >= 0 && n.splice(i), this.dedupAndStoreNewResults(n, !0), this.lastPollDateTime = /* @__PURE__ */ new Date(), this.isPolling = !1;
				} catch (e) {
					console.error(e), this.stopPolling();
				}
			}
		},
		startPolling(e, n = t.pageSize || 20, r) {
			if (o || !e) return;
			let a = i.currentRoute.value.path;
			o = setInterval(() => {
				s.pollForNewResults(n, a, r).catch((e) => console.error(e));
			}, e), this.isPollingActive = !0;
		},
		stopPolling() {
			o && (clearInterval(o), o = null, this.isPollingActive = !1, this.lastPollResults = [], this.isPolling = !1);
		},
		removeRecordByUuid(e) {
			let t = this.results.findIndex((t) => t._id === e);
			t !== -1 && (this.results.splice(t, 1), this.resultIds.delete(e));
		}
	}), c = C(() => {
		let e = 0, { dateFrom: t, dateTo: n, ...r } = s.parameters;
		t && n && e++;
		let i = Object.entries(r);
		return e += i.reduce((e, [t, n]) => t === "page" ? e : typeof n == "object" && n ? Object.keys(n).length === 0 ? e : e + 1 : typeof n == "string" ? n.length === 0 ? e : e + 1 : n === void 0 ? e : e + 1, 0);
	}), l = ye((e = !1) => s.loadResults(e), 350);
	return nf(l), qe([() => s.parameters, () => s.reqPayload], () => (s.results = [], s.currentPage = 1, s.previousPage = 0, l(!0)), { deep: !0 }), qe(i.currentRoute, (e, t) => {
		t.name === e.name && Object.values(e.query).length === 0 && (s.parameters = {});
	}), qe(c, (e) => {
		s.activeFiltersCount = e;
	}), l(), s;
}, { showDialog: by } = Gd(), xy = (e) => {
	let t = {
		publish: [],
		unpublish: [],
		draft: [],
		schedule: [],
		rePublishInFuture: []
	}, n = (e, n) => (t[e].push(n), () => {
		t[e] = t[e].filter((e) => e !== n);
	}), r = (e, t) => n(e, () => new Promise((e) => by(t).onOk(() => e(!0)).onCancel(() => e(!1)))), i = async (n) => {
		for (let r of t[n]) if (!await r(e.value)) return !1;
		return !0;
	}, a = async (t) => e.value.state === t ? !0 : await i(t) ? (e.value.state = t === "rePublishInFuture" ? "schedule" : t, t === "schedule" && !e.value.displayDate && (e.value.displayDate = e.value.publishDate), !0) : !1;
	return {
		async checkTransition() {
			let { publishDate: t, unpublishDate: n, state: r } = e.value;
			return r === "publish" && t && t > /* @__PURE__ */ new Date() ? a("rePublishInFuture") : t ? t ? a(n && n < /* @__PURE__ */ new Date() ? "unpublish" : t <= /* @__PURE__ */ new Date() ? "publish" : "schedule") : !0 : a("draft");
		},
		onDraft(e) {
			return n("draft", e), this;
		},
		onSchedule(e) {
			return n("schedule", e), this;
		},
		onPublish(e) {
			return n("publish", e), this;
		},
		onUnpublish(e) {
			return n("draft", e), this;
		},
		onRePublishInFuture(e) {
			return n("rePublishInFuture", e), this;
		},
		onDraftDialog(e) {
			return r("draft", e), this;
		},
		onScheduleDialog(e) {
			return r("schedule", e), this;
		},
		onPublishDialog(e) {
			return r("publish", e), this;
		},
		onUnpublishDialog(e) {
			return r("unpublish", e), this;
		},
		onRePublishInFutureDialog(e) {
			return r("rePublishInFuture", e), this;
		},
		saveDraft: () => a("draft"),
		schedule: () => a("schedule"),
		publish: () => a("publish"),
		unpublish: () => a("unpublish")
	};
}, Sy = (e, t) => new Promise(async (n) => {
	await Me(async () => {
		let r = await e.value?.validate(!0) || !1;
		if (!r) {
			n({
				canProceed: !1,
				isFormValid: r
			});
			return;
		}
		n({
			canProceed: await t(),
			isFormValid: r
		});
	});
}), Cy = (e, t, n) => ({
	async saveDraft(r = !1) {
		return Sy(e, () => new Promise((e) => {
			by(n.draft()).onOk(async () => {
				r && (t.value.publishDate = void 0, t.value.displayDate = void 0, t.value.unpublishDate = void 0), t.value.state = "draft", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async schedule() {
		return Sy(e, () => new Promise((e) => {
			by(n.schedule()).onOk(async () => {
				t.value.state = "schedule", t.value.displayDate || (t.value.displayDate = t.value.publishDate), e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async publish(r = !1) {
		return Sy(e, () => new Promise((e) => {
			by(n.publish()).onOk(async () => {
				r && ((!t.value.publishDate || t.value.publishDate < /* @__PURE__ */ new Date()) && (t.value.publishDate = /* @__PURE__ */ new Date()), t.value.displayDate || (t.value.displayDate = t.value.type === "GALLERY" ? void 0 : /* @__PURE__ */ new Date()), t.value.unpublishDate && t.value.unpublishDate <= /* @__PURE__ */ new Date() && (t.value.unpublishDate = void 0)), t.value.state = "publish", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	},
	async unpublish(r = !1) {
		return Sy(e, () => new Promise((e) => {
			by(n.unpublish()).onOk(async () => {
				r && (t.value.unpublishDate = /* @__PURE__ */ new Date()), t.value.state = "unpublish", e(!0);
			}).onCancel(() => e(!1)).onDismiss(() => e(!1));
		}));
	}
}), wy = (e) => {
	let t = () => {
		document.title = `${B().t(e)} - Burda Forward Editor`;
	};
	Le(t), qe(B().locale, t);
}, Ty = Object.create(null);
Ty.open = "0", Ty.close = "1", Ty.ping = "2", Ty.pong = "3", Ty.message = "4", Ty.upgrade = "5", Ty.noop = "6";
var Ey = Object.create(null);
Object.keys(Ty).forEach((e) => {
	Ey[Ty[e]] = e;
});
var Dy = {
	type: "error",
	data: "parser error"
}, Oy = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", ky = typeof ArrayBuffer == "function", Ay = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, jy = ({ type: e, data: t }, n, r) => Oy && t instanceof Blob ? n ? r(t) : My(t, r) : ky && (t instanceof ArrayBuffer || Ay(t)) ? n ? r(t) : My(new Blob([t]), r) : r(Ty[e] + (t || "")), My = (e, t) => {
	let n = new FileReader();
	return n.onload = function() {
		let e = n.result.split(",")[1];
		t("b" + (e || ""));
	}, n.readAsDataURL(e);
};
function Ny(e) {
	return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
var Py;
function Fy(e, t) {
	if (Oy && e.data instanceof Blob) return e.data.arrayBuffer().then(Ny).then(t);
	if (ky && (e.data instanceof ArrayBuffer || Ay(e.data))) return t(Ny(e.data));
	jy(e, !1, (e) => {
		Py ||= new TextEncoder(), t(Py.encode(e));
	});
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-parser@5.2.3/node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
var Iy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ly = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < 64; e++) Ly[Iy.charCodeAt(e)] = e;
var Ry = (e) => {
	let t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
	e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
	let l = new ArrayBuffer(t), u = new Uint8Array(l);
	for (r = 0; r < n; r += 4) a = Ly[e.charCodeAt(r)], o = Ly[e.charCodeAt(r + 1)], s = Ly[e.charCodeAt(r + 2)], c = Ly[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
	return l;
}, zy = typeof ArrayBuffer == "function", By = (e, t) => {
	if (typeof e != "string") return {
		type: "message",
		data: Hy(e, t)
	};
	let n = e.charAt(0);
	return n === "b" ? {
		type: "message",
		data: Vy(e.substring(1), t)
	} : Ey[n] ? e.length > 1 ? {
		type: Ey[n],
		data: e.substring(1)
	} : { type: Ey[n] } : Dy;
}, Vy = (e, t) => zy ? Hy(Ry(e), t) : {
	base64: !0,
	data: e
}, Hy = (e, t) => {
	switch (t) {
		case "blob": return e instanceof Blob ? e : new Blob([e]);
		default: return e instanceof ArrayBuffer ? e : e.buffer;
	}
}, Uy = "", Wy = (e, t) => {
	let n = e.length, r = Array(n), i = 0;
	e.forEach((e, a) => {
		jy(e, !1, (e) => {
			r[a] = e, ++i === n && t(r.join(Uy));
		});
	});
}, Gy = (e, t) => {
	let n = e.split(Uy), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = By(n[e], t);
		if (r.push(i), i.type === "error") break;
	}
	return r;
};
function Ky() {
	return new TransformStream({ transform(e, t) {
		Fy(e, (n) => {
			let r = n.length, i;
			if (r < 126) i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
			else if (r < 65536) {
				i = new Uint8Array(3);
				let e = new DataView(i.buffer);
				e.setUint8(0, 126), e.setUint16(1, r);
			} else {
				i = new Uint8Array(9);
				let e = new DataView(i.buffer);
				e.setUint8(0, 127), e.setBigUint64(1, BigInt(r));
			}
			e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
		});
	} });
}
var qy;
function Jy(e) {
	return e.reduce((e, t) => e + t.length, 0);
}
function Yy(e, t) {
	if (e[0].length === t) return e.shift();
	let n = new Uint8Array(t), r = 0;
	for (let i = 0; i < t; i++) n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
	return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function Xy(e, t) {
	qy ||= new TextDecoder();
	let n = [], r = 0, i = -1, a = !1;
	return new TransformStream({ transform(o, s) {
		for (n.push(o);;) {
			if (r === 0) {
				if (Jy(n) < 1) break;
				let e = Yy(n, 1);
				a = (e[0] & 128) == 128, i = e[0] & 127, r = i < 126 ? 3 : i === 126 ? 1 : 2;
			} else if (r === 1) {
				if (Jy(n) < 2) break;
				let e = Yy(n, 2);
				i = new DataView(e.buffer, e.byteOffset, e.length).getUint16(0), r = 3;
			} else if (r === 2) {
				if (Jy(n) < 8) break;
				let e = Yy(n, 8), t = new DataView(e.buffer, e.byteOffset, e.length), a = t.getUint32(0);
				if (a > 2 ** 21 - 1) {
					s.enqueue(Dy);
					break;
				}
				i = a * 2 ** 32 + t.getUint32(4), r = 3;
			} else {
				if (Jy(n) < i) break;
				let e = Yy(n, i);
				s.enqueue(By(a ? e : qy.decode(e), t)), r = 0;
			}
			if (i === 0 || i > e) {
				s.enqueue(Dy);
				break;
			}
		}
	} });
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/@socket.io+component-emitter@3.1.2/node_modules/@socket.io/component-emitter/lib/esm/index.js
function Zy(e) {
	if (e) return Qy(e);
}
function Qy(e) {
	for (var t in Zy.prototype) e[t] = Zy.prototype[t];
	return e;
}
Zy.prototype.on = Zy.prototype.addEventListener = function(e, t) {
	return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
}, Zy.prototype.once = function(e, t) {
	function n() {
		this.off(e, n), t.apply(this, arguments);
	}
	return n.fn = t, this.on(e, n), this;
}, Zy.prototype.off = Zy.prototype.removeListener = Zy.prototype.removeAllListeners = Zy.prototype.removeEventListener = function(e, t) {
	if (this._callbacks = this._callbacks || {}, arguments.length == 0) return this._callbacks = {}, this;
	var n = this._callbacks["$" + e];
	if (!n) return this;
	if (arguments.length == 1) return delete this._callbacks["$" + e], this;
	for (var r, i = 0; i < n.length; i++) if (r = n[i], r === t || r.fn === t) {
		n.splice(i, 1);
		break;
	}
	return n.length === 0 && delete this._callbacks["$" + e], this;
}, Zy.prototype.emit = function(e) {
	this._callbacks = this._callbacks || {};
	for (var t = Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
	if (n) {
		n = n.slice(0);
		for (var r = 0, i = n.length; r < i; ++r) n[r].apply(this, t);
	}
	return this;
}, Zy.prototype.emitReserved = Zy.prototype.emit, Zy.prototype.listeners = function(e) {
	return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
}, Zy.prototype.hasListeners = function(e) {
	return !!this.listeners(e).length;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/globalThis.browser.js
var $y = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/util.js
function eb(e, ...t) {
	return t.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
}
var tb = $y.setTimeout, nb = $y.clearTimeout;
function rb(e, t) {
	t.useNativeTimers ? (e.setTimeoutFn = tb.bind($y), e.clearTimeoutFn = nb.bind($y)) : (e.setTimeoutFn = $y.setTimeout.bind($y), e.clearTimeoutFn = $y.clearTimeout.bind($y));
}
var ib = 1.33;
function ab(e) {
	return typeof e == "string" ? ob(e) : Math.ceil((e.byteLength || e.size) * ib);
}
function ob(e) {
	let t = 0, n = 0;
	for (let r = 0, i = e.length; r < i; r++) t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
	return n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/contrib/parseqs.js
function sb(e) {
	let t = "";
	for (let n in e) e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
	return t;
}
function cb(e) {
	let t = {}, n = e.split("&");
	for (let e = 0, r = n.length; e < r; e++) {
		let r = n[e].split("=");
		t[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
	}
	return t;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transport.js
var lb = class extends Error {
	constructor(e, t, n) {
		super(e), this.description = t, this.context = n, this.type = "TransportError";
	}
}, ub = class extends Zy {
	constructor(e) {
		super(), this.writable = !1, rb(this, e), this.opts = e, this.query = e.query, this.socket = e.socket;
	}
	onError(e, t, n) {
		return super.emitReserved("error", new lb(e, t, n)), this;
	}
	open() {
		return this.readyState = "opening", this.doOpen(), this;
	}
	close() {
		return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
	}
	send(e) {
		this.readyState === "open" && this.write(e);
	}
	onOpen() {
		this.readyState = "open", this.writable = !0, super.emitReserved("open");
	}
	onData(e) {
		let t = By(e, this.socket.binaryType);
		this.onPacket(t);
	}
	onPacket(e) {
		super.emitReserved("packet", e);
	}
	onClose(e) {
		this.readyState = "closed", super.emitReserved("close", e);
	}
	pause(e) {}
	createUri(e, t = {}) {
		return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
	}
	_hostname() {
		let e = this.opts.hostname;
		return e.indexOf(":") === -1 ? e : "[" + e + "]";
	}
	_port() {
		return this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
	}
	_query(e) {
		let t = sb(e);
		return t.length ? "?" + t : "";
	}
}, db = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), fb = 64, pb = {}, mb = 0, hb = 0, gb;
function _b(e) {
	let t = "";
	do
		t = db[e % fb] + t, e = Math.floor(e / fb);
	while (e > 0);
	return t;
}
function vb() {
	let e = _b(+/* @__PURE__ */ new Date());
	return e === gb ? e + "." + _b(mb++) : (mb = 0, gb = e);
}
for (; hb < fb; hb++) pb[db[hb]] = hb;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/contrib/has-cors.js
var yb = !1;
try {
	yb = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {}
var bb = yb;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/xmlhttprequest.browser.js
function xb(e) {
	let t = e.xdomain;
	try {
		if (typeof XMLHttpRequest < "u" && (!t || bb)) return new XMLHttpRequest();
	} catch {}
	if (!t) try {
		return new $y[["Active", "Object"].join("X")]("Microsoft.XMLHTTP");
	} catch {}
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/polling.js
function Sb() {}
var Cb = (function() {
	return new xb({ xdomain: !1 }).responseType != null;
})(), wb = class extends ub {
	constructor(e) {
		if (super(e), this.polling = !1, typeof location < "u") {
			let t = location.protocol === "https:", n = location.port;
			n ||= t ? "443" : "80", this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
		}
		let t = e && e.forceBase64;
		this.supportsBinary = Cb && !t, this.opts.withCredentials && (this.cookieJar = void 0);
	}
	get name() {
		return "polling";
	}
	doOpen() {
		this.poll();
	}
	pause(e) {
		this.readyState = "pausing";
		let t = () => {
			this.readyState = "paused", e();
		};
		if (this.polling || !this.writable) {
			let e = 0;
			this.polling && (e++, this.once("pollComplete", function() {
				--e || t();
			})), this.writable || (e++, this.once("drain", function() {
				--e || t();
			}));
		} else t();
	}
	poll() {
		this.polling = !0, this.doPoll(), this.emitReserved("poll");
	}
	onData(e) {
		Gy(e, this.socket.binaryType).forEach((e) => {
			if (this.readyState === "opening" && e.type === "open" && this.onOpen(), e.type === "close") return this.onClose({ description: "transport closed by the server" }), !1;
			this.onPacket(e);
		}), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
	}
	doClose() {
		let e = () => {
			this.write([{ type: "close" }]);
		};
		this.readyState === "open" ? e() : this.once("open", e);
	}
	write(e) {
		this.writable = !1, Wy(e, (e) => {
			this.doWrite(e, () => {
				this.writable = !0, this.emitReserved("drain");
			});
		});
	}
	uri() {
		let e = this.opts.secure ? "https" : "http", t = this.query || {};
		return !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = vb()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.createUri(e, t);
	}
	request(e = {}) {
		return Object.assign(e, {
			xd: this.xd,
			cookieJar: this.cookieJar
		}, this.opts), new Tb(this.uri(), e);
	}
	doWrite(e, t) {
		let n = this.request({
			method: "POST",
			data: e
		});
		n.on("success", t), n.on("error", (e, t) => {
			this.onError("xhr post error", e, t);
		});
	}
	doPoll() {
		let e = this.request();
		e.on("data", this.onData.bind(this)), e.on("error", (e, t) => {
			this.onError("xhr poll error", e, t);
		}), this.pollXhr = e;
	}
}, Tb = class e extends Zy {
	constructor(e, t) {
		super(), rb(this, t), this.opts = t, this.method = t.method || "GET", this.uri = e, this.data = t.data === void 0 ? null : t.data, this.create();
	}
	create() {
		var t;
		let n = eb(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
		n.xdomain = !!this.opts.xd;
		let r = this.xhr = new xb(n);
		try {
			r.open(this.method, this.uri, !0);
			try {
				if (this.opts.extraHeaders) {
					r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
					for (let e in this.opts.extraHeaders) this.opts.extraHeaders.hasOwnProperty(e) && r.setRequestHeader(e, this.opts.extraHeaders[e]);
				}
			} catch {}
			if (this.method === "POST") try {
				r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
			} catch {}
			try {
				r.setRequestHeader("Accept", "*/*");
			} catch {}
			(t = this.opts.cookieJar) == null || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (r.timeout = this.opts.requestTimeout), r.onreadystatechange = () => {
				var e;
				r.readyState === 3 && ((e = this.opts.cookieJar) == null || e.parseCookies(r)), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
					this.onError(typeof r.status == "number" ? r.status : 0);
				}, 0));
			}, r.send(this.data);
		} catch (e) {
			this.setTimeoutFn(() => {
				this.onError(e);
			}, 0);
			return;
		}
		typeof document < "u" && (this.index = e.requestsCount++, e.requests[this.index] = this);
	}
	onError(e) {
		this.emitReserved("error", e, this.xhr), this.cleanup(!0);
	}
	cleanup(t) {
		if (!(this.xhr === void 0 || this.xhr === null)) {
			if (this.xhr.onreadystatechange = Sb, t) try {
				this.xhr.abort();
			} catch {}
			typeof document < "u" && delete e.requests[this.index], this.xhr = null;
		}
	}
	onLoad() {
		let e = this.xhr.responseText;
		e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this.cleanup());
	}
	abort() {
		this.cleanup();
	}
};
if (Tb.requestsCount = 0, Tb.requests = {}, typeof document < "u") {
	if (typeof attachEvent == "function") attachEvent("onunload", Eb);
	else if (typeof addEventListener == "function") {
		let e = "onpagehide" in $y ? "pagehide" : "unload";
		addEventListener(e, Eb, !1);
	}
}
function Eb() {
	for (let e in Tb.requests) Tb.requests.hasOwnProperty(e) && Tb.requests[e].abort();
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/transports/websocket-constructor.browser.js
var Db = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, t) => t(e, 0), Ob = $y.WebSocket || $y.MozWebSocket, kb = "arraybuffer", Ab = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", jb = {
	websocket: class extends ub {
		constructor(e) {
			super(e), this.supportsBinary = !e.forceBase64;
		}
		get name() {
			return "websocket";
		}
		doOpen() {
			if (!this.check()) return;
			let e = this.uri(), t = this.opts.protocols, n = Ab ? {} : eb(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
			this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
			try {
				this.ws = Ab ? new Ob(e, t, n) : t ? new Ob(e, t) : new Ob(e);
			} catch (e) {
				return this.emitReserved("error", e);
			}
			this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
		}
		addEventListeners() {
			this.ws.onopen = () => {
				this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
			}, this.ws.onclose = (e) => this.onClose({
				description: "websocket connection closed",
				context: e
			}), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
		}
		write(e) {
			this.writable = !1;
			for (let t = 0; t < e.length; t++) {
				let n = e[t], r = t === e.length - 1;
				jy(n, this.supportsBinary, (e) => {
					try {
						this.ws.send(e);
					} catch {}
					r && Db(() => {
						this.writable = !0, this.emitReserved("drain");
					}, this.setTimeoutFn);
				});
			}
		}
		doClose() {
			this.ws !== void 0 && (this.ws.close(), this.ws = null);
		}
		uri() {
			let e = this.opts.secure ? "wss" : "ws", t = this.query || {};
			return this.opts.timestampRequests && (t[this.opts.timestampParam] = vb()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
		}
		check() {
			return !!Ob;
		}
	},
	webtransport: class extends ub {
		get name() {
			return "webtransport";
		}
		doOpen() {
			typeof WebTransport == "function" && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
				this.onClose();
			}).catch((e) => {
				this.onError("webtransport error", e);
			}), this.transport.ready.then(() => {
				this.transport.createBidirectionalStream().then((e) => {
					let t = Xy(2 ** 53 - 1, this.socket.binaryType), n = e.readable.pipeThrough(t).getReader(), r = Ky();
					r.readable.pipeTo(e.writable), this.writer = r.writable.getWriter();
					let i = () => {
						n.read().then(({ done: e, value: t }) => {
							e || (this.onPacket(t), i());
						}).catch((e) => {});
					};
					i();
					let a = { type: "open" };
					this.query.sid && (a.data = `{"sid":"${this.query.sid}"}`), this.writer.write(a).then(() => this.onOpen());
				});
			}));
		}
		write(e) {
			this.writable = !1;
			for (let t = 0; t < e.length; t++) {
				let n = e[t], r = t === e.length - 1;
				this.writer.write(n).then(() => {
					r && Db(() => {
						this.writable = !0, this.emitReserved("drain");
					}, this.setTimeoutFn);
				});
			}
		}
		doClose() {
			var e;
			(e = this.transport) == null || e.close();
		}
	},
	polling: wb
}, Mb = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Nb = [
	"source",
	"protocol",
	"authority",
	"userInfo",
	"user",
	"password",
	"host",
	"port",
	"relative",
	"path",
	"directory",
	"file",
	"query",
	"anchor"
];
function Pb(e) {
	if (e.length > 2e3) throw "URI too long";
	let t = e, n = e.indexOf("["), r = e.indexOf("]");
	n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
	let i = Mb.exec(e || ""), a = {}, o = 14;
	for (; o--;) a[Nb[o]] = i[o] || "";
	return n != -1 && r != -1 && (a.source = t, a.host = a.host.substring(1, a.host.length - 1).replace(/;/g, ":"), a.authority = a.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), a.ipv6uri = !0), a.pathNames = Fb(a, a.path), a.queryKey = Ib(a, a.query), a;
}
function Fb(e, t) {
	let n = t.replace(/\/{2,9}/g, "/").split("/");
	return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function Ib(e, t) {
	let n = {};
	return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(e, t, r) {
		t && (n[t] = r);
	}), n;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/engine.io-client@6.5.4_supports-color@8.1.1/node_modules/engine.io-client/build/esm/socket.js
var Lb = class e extends Zy {
	constructor(e, t = {}) {
		super(), this.binaryType = kb, this.writeBuffer = [], e && typeof e == "object" && (t = e, e = null), e ? (e = Pb(e), t.hostname = e.host, t.secure = e.protocol === "https" || e.protocol === "wss", t.port = e.port, e.query && (t.query = e.query)) : t.host && (t.hostname = Pb(t.host).host), rb(this, t), this.secure = t.secure == null ? typeof location < "u" && location.protocol === "https:" : t.secure, t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = t.transports || [
			"polling",
			"websocket",
			"webtransport"
		], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
			path: "/engine.io",
			agent: !1,
			withCredentials: !1,
			upgrade: !0,
			timestampParam: "t",
			rememberUpgrade: !1,
			addTrailingSlash: !0,
			rejectUnauthorized: !0,
			perMessageDeflate: { threshold: 1024 },
			transportOptions: {},
			closeOnBeforeunload: !1
		}, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = cb(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
			this.transport && (this.transport.removeAllListeners(), this.transport.close());
		}, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
			this.onClose("transport close", { description: "network connection lost" });
		}, addEventListener("offline", this.offlineEventListener, !1))), this.open();
	}
	createTransport(e) {
		let t = Object.assign({}, this.opts.query);
		t.EIO = 4, t.transport = e, this.id && (t.sid = this.id);
		let n = Object.assign({}, this.opts, {
			query: t,
			socket: this,
			hostname: this.hostname,
			secure: this.secure,
			port: this.port
		}, this.opts.transportOptions[e]);
		return new jb[e](n);
	}
	open() {
		let t;
		if (this.opts.rememberUpgrade && e.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) t = "websocket";
		else if (this.transports.length === 0) {
			this.setTimeoutFn(() => {
				this.emitReserved("error", "No transports available");
			}, 0);
			return;
		} else t = this.transports[0];
		this.readyState = "opening";
		try {
			t = this.createTransport(t);
		} catch {
			this.transports.shift(), this.open();
			return;
		}
		t.open(), this.setTransport(t);
	}
	setTransport(e) {
		this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (e) => this.onClose("transport close", e));
	}
	probe(t) {
		let n = this.createTransport(t), r = !1;
		e.priorWebsocketSuccess = !1;
		let i = () => {
			r || (n.send([{
				type: "ping",
				data: "probe"
			}]), n.once("packet", (t) => {
				if (!r) if (t.type === "pong" && t.data === "probe") {
					if (this.upgrading = !0, this.emitReserved("upgrading", n), !n) return;
					e.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
						r || this.readyState !== "closed" && (u(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
					});
				} else {
					let e = /* @__PURE__ */ Error("probe error");
					e.transport = n.name, this.emitReserved("upgradeError", e);
				}
			}));
		};
		function a() {
			r || (r = !0, u(), n.close(), n = null);
		}
		let o = (e) => {
			let t = /* @__PURE__ */ Error("probe error: " + e);
			t.transport = n.name, a(), this.emitReserved("upgradeError", t);
		};
		function s() {
			o("transport closed");
		}
		function c() {
			o("socket closed");
		}
		function l(e) {
			n && e.name !== n.name && a();
		}
		let u = () => {
			n.removeListener("open", i), n.removeListener("error", o), n.removeListener("close", s), this.off("close", c), this.off("upgrading", l);
		};
		n.once("open", i), n.once("error", o), n.once("close", s), this.once("close", c), this.once("upgrading", l), this.upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
			r || n.open();
		}, 200) : n.open();
	}
	onOpen() {
		if (this.readyState = "open", e.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade) {
			let e = 0, t = this.upgrades.length;
			for (; e < t; e++) this.probe(this.upgrades[e]);
		}
	}
	onPacket(e) {
		if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), this.resetPingTimeout(), e.type) {
			case "open":
				this.onHandshake(JSON.parse(e.data));
				break;
			case "ping":
				this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
				break;
			case "error":
				let t = /* @__PURE__ */ Error("server error");
				t.code = e.data, this.onError(t);
				break;
			case "message":
				this.emitReserved("data", e.data), this.emitReserved("message", e.data);
				break;
		}
	}
	onHandshake(e) {
		this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
	}
	resetPingTimeout() {
		this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
			this.onClose("ping timeout");
		}, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
	}
	onDrain() {
		this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
	}
	flush() {
		if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
			let e = this.getWritablePackets();
			this.transport.send(e), this.prevBufferLen = e.length, this.emitReserved("flush");
		}
	}
	getWritablePackets() {
		if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1)) return this.writeBuffer;
		let e = 1;
		for (let t = 0; t < this.writeBuffer.length; t++) {
			let n = this.writeBuffer[t].data;
			if (n && (e += ab(n)), t > 0 && e > this.maxPayload) return this.writeBuffer.slice(0, t);
			e += 2;
		}
		return this.writeBuffer;
	}
	write(e, t, n) {
		return this.sendPacket("message", e, t, n), this;
	}
	send(e, t, n) {
		return this.sendPacket("message", e, t, n), this;
	}
	sendPacket(e, t, n, r) {
		if (typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = null), this.readyState === "closing" || this.readyState === "closed") return;
		n ||= {}, n.compress = !1 !== n.compress;
		let i = {
			type: e,
			data: t,
			options: n
		};
		this.emitReserved("packetCreate", i), this.writeBuffer.push(i), r && this.once("flush", r), this.flush();
	}
	close() {
		let e = () => {
			this.onClose("forced close"), this.transport.close();
		}, t = () => {
			this.off("upgrade", t), this.off("upgradeError", t), e();
		}, n = () => {
			this.once("upgrade", t), this.once("upgradeError", t);
		};
		return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
			this.upgrading ? n() : e();
		}) : this.upgrading ? n() : e()), this;
	}
	onError(t) {
		e.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
	}
	onClose(e, t) {
		(this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this.prevBufferLen = 0);
	}
	filterUpgrades(e) {
		let t = [], n = 0, r = e.length;
		for (; n < r; n++) ~this.transports.indexOf(e[n]) && t.push(e[n]);
		return t;
	}
};
Lb.protocol = 4, Lb.protocol;
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/url.js
function Rb(e, t = "", n) {
	let r = e;
	n ||= typeof location < "u" && location, e ??= n.protocol + "//" + n.host, typeof e == "string" && (e.charAt(0) === "/" && (e = e.charAt(1) === "/" ? n.protocol + e : n.host + e), /^(https?|wss?):\/\//.test(e) || (e = n === void 0 ? "https://" + e : n.protocol + "//" + e), r = Pb(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
	let i = r.host.indexOf(":") === -1 ? r.host : "[" + r.host + "]";
	return r.id = r.protocol + "://" + i + ":" + r.port + t, r.href = r.protocol + "://" + i + (n && n.port === r.port ? "" : ":" + r.port), r;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/is-binary.js
var zb = typeof ArrayBuffer == "function", Bb = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, Vb = Object.prototype.toString, Hb = typeof Blob == "function" || typeof Blob < "u" && Vb.call(Blob) === "[object BlobConstructor]", Ub = typeof File == "function" || typeof File < "u" && Vb.call(File) === "[object FileConstructor]";
function Wb(e) {
	return zb && (e instanceof ArrayBuffer || Bb(e)) || Hb && e instanceof Blob || Ub && e instanceof File;
}
function Gb(e, t) {
	if (!e || typeof e != "object") return !1;
	if (Array.isArray(e)) {
		for (let t = 0, n = e.length; t < n; t++) if (Gb(e[t])) return !0;
		return !1;
	}
	if (Wb(e)) return !0;
	if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1) return Gb(e.toJSON(), !0);
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t) && Gb(e[t])) return !0;
	return !1;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/binary.js
function Kb(e) {
	let t = [], n = e.data, r = e;
	return r.data = qb(n, t), r.attachments = t.length, {
		packet: r,
		buffers: t
	};
}
function qb(e, t, n) {
	if (!e) return e;
	if (Wb(e)) {
		let n = {
			_placeholder: !0,
			num: t.length
		};
		return t.push(e), n;
	} else if (Array.isArray(e)) {
		let n = Array(e.length);
		for (let r = 0; r < e.length; r++) n[r] = qb(e[r], t);
		return n;
	} else if (typeof e == "object" && !(e instanceof Date)) {
		if (e.toJSON && typeof e.toJSON == "function" && !n) return qb(e.toJSON(), t, !0);
		let r = {};
		for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = qb(e[n], t));
		return r;
	}
	return e;
}
function Jb(e, t) {
	return e.data = Yb(e.data, t), delete e.attachments, e;
}
function Yb(e, t) {
	if (!e) return e;
	if (e && e._placeholder === !0) {
		if (typeof e.num == "number" && e.num >= 0 && e.num < t.length) return t[e.num];
		throw Error("illegal attachments");
	} else if (Array.isArray(e)) for (let n = 0; n < e.length; n++) e[n] = Yb(e[n], t);
	else if (typeof e == "object") for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && (e[n] = Yb(e[n], t));
	return e;
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-parser@4.2.7_supports-color@8.1.1/node_modules/socket.io-parser/build/esm/index.js
var Xb = /* @__PURE__ */ bt({
	Decoder: () => $b,
	Encoder: () => Qb,
	PacketType: () => $,
	isPacketValid: () => ox,
	protocol: () => 5
}), Zb = [
	"connect",
	"connect_error",
	"disconnect",
	"disconnecting",
	"newListener",
	"removeListener"
], $;
(function(e) {
	e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})($ ||= {});
var Qb = class {
	constructor(e) {
		this.replacer = e;
	}
	encode(e) {
		return (e.type === $.EVENT || e.type === $.ACK) && Gb(e) ? this.encodeAsBinary({
			type: e.type === $.EVENT ? $.BINARY_EVENT : $.BINARY_ACK,
			nsp: e.nsp,
			data: e.data,
			id: e.id
		}) : [this.encodeAsString(e)];
	}
	encodeAsString(e) {
		let t = "" + e.type;
		return (e.type === $.BINARY_EVENT || e.type === $.BINARY_ACK) && (t += e.attachments + "-"), e.nsp && e.nsp !== "/" && (t += e.nsp + ","), e.id != null && (t += e.id), e.data != null && (t += JSON.stringify(e.data, this.replacer)), t;
	}
	encodeAsBinary(e) {
		let t = Kb(e), n = this.encodeAsString(t.packet), r = t.buffers;
		return r.unshift(n), r;
	}
}, $b = class e extends Zy {
	constructor(e) {
		super(), this.opts = Object.assign({
			reviver: void 0,
			maxAttachments: 10
		}, typeof e == "function" ? { reviver: e } : e);
	}
	add(e) {
		let t;
		if (typeof e == "string") {
			if (this.reconstructor) throw Error("got plaintext data when reconstructing a packet");
			t = this.decodeString(e);
			let n = t.type === $.BINARY_EVENT;
			n || t.type === $.BINARY_ACK ? (t.type = n ? $.EVENT : $.ACK, this.reconstructor = new ex(t)) : super.emitReserved("decoded", t);
		} else if (Wb(e) || e.base64) if (this.reconstructor) t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
		else throw Error("got binary data when not reconstructing a packet");
		else throw Error("Unknown type: " + e);
	}
	decodeString(t) {
		let n = 0, r = { type: Number(t.charAt(0)) };
		if ($[r.type] === void 0) throw Error("unknown packet type " + r.type);
		if (r.type === $.BINARY_EVENT || r.type === $.BINARY_ACK) {
			let e = n + 1;
			for (; t.charAt(++n) !== "-" && n != t.length;);
			let i = t.substring(e, n);
			if (i != Number(i) || t.charAt(n) !== "-") throw Error("Illegal attachments");
			let a = Number(i);
			if (!nx(a) || a < 1) throw Error("Illegal attachments");
			if (a > this.opts.maxAttachments) throw Error("too many attachments");
			r.attachments = a;
		}
		if (t.charAt(n + 1) === "/") {
			let e = n + 1;
			for (; ++n && !(t.charAt(n) === "," || n === t.length););
			r.nsp = t.substring(e, n);
		} else r.nsp = "/";
		let i = t.charAt(n + 1);
		if (i !== "" && Number(i) == i) {
			let e = n + 1;
			for (; ++n;) {
				let e = t.charAt(n);
				if (e == null || Number(e) != e) {
					--n;
					break;
				}
				if (n === t.length) break;
			}
			r.id = Number(t.substring(e, n + 1));
		}
		if (t.charAt(++n)) {
			let i = this.tryParse(t.substr(n));
			if (e.isPayloadValid(r.type, i)) r.data = i;
			else throw Error("invalid payload");
		}
		return r;
	}
	tryParse(e) {
		try {
			return JSON.parse(e, this.opts.reviver);
		} catch {
			return !1;
		}
	}
	static isPayloadValid(e, t) {
		switch (e) {
			case $.CONNECT: return ix(t);
			case $.DISCONNECT: return t === void 0;
			case $.CONNECT_ERROR: return typeof t == "string" || ix(t);
			case $.EVENT:
			case $.BINARY_EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && Zb.indexOf(t[0]) === -1);
			case $.ACK:
			case $.BINARY_ACK: return Array.isArray(t);
		}
	}
	destroy() {
		this.reconstructor &&= (this.reconstructor.finishedReconstruction(), null);
	}
}, ex = class {
	constructor(e) {
		this.packet = e, this.buffers = [], this.reconPack = e;
	}
	takeBinaryData(e) {
		if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
			let e = Jb(this.reconPack, this.buffers);
			return this.finishedReconstruction(), e;
		}
		return null;
	}
	finishedReconstruction() {
		this.reconPack = null, this.buffers = [];
	}
};
function tx(e) {
	return typeof e == "string";
}
var nx = Number.isInteger || function(e) {
	return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
};
function rx(e) {
	return e === void 0 || nx(e);
}
function ix(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function ax(e, t) {
	switch (e) {
		case $.CONNECT: return t === void 0 || ix(t);
		case $.DISCONNECT: return t === void 0;
		case $.EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && Zb.indexOf(t[0]) === -1);
		case $.ACK: return Array.isArray(t);
		case $.CONNECT_ERROR: return typeof t == "string" || ix(t);
		default: return !1;
	}
}
function ox(e) {
	return tx(e.nsp) && rx(e.id) && ax(e.type, e.data);
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/on.js
function sx(e, t, n) {
	return e.on(t, n), function() {
		e.off(t, n);
	};
}
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/socket.js
var cx = Object.freeze({
	connect: 1,
	connect_error: 1,
	disconnect: 1,
	disconnecting: 1,
	newListener: 1,
	removeListener: 1
}), lx = class extends Zy {
	constructor(e, t, n) {
		super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
	}
	get disconnected() {
		return !this.connected;
	}
	subEvents() {
		if (this.subs) return;
		let e = this.io;
		this.subs = [
			sx(e, "open", this.onopen.bind(this)),
			sx(e, "packet", this.onpacket.bind(this)),
			sx(e, "error", this.onerror.bind(this)),
			sx(e, "close", this.onclose.bind(this))
		];
	}
	get active() {
		return !!this.subs;
	}
	connect() {
		return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
	}
	open() {
		return this.connect();
	}
	send(...e) {
		return e.unshift("message"), this.emit.apply(this, e), this;
	}
	emit(e, ...t) {
		if (cx.hasOwnProperty(e)) throw Error("\"" + e.toString() + "\" is a reserved event name");
		if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(t), this;
		let n = {
			type: $.EVENT,
			data: t
		};
		if (n.options = {}, n.options.compress = this.flags.compress !== !1, typeof t[t.length - 1] == "function") {
			let e = this.ids++, r = t.pop();
			this._registerAckCallback(e, r), n.id = e;
		}
		let r = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
		return this.flags.volatile && (!r || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(n), this.packet(n)) : this.sendBuffer.push(n)), this.flags = {}, this;
	}
	_registerAckCallback(e, t) {
		let n = this.flags.timeout ?? this._opts.ackTimeout;
		if (n === void 0) {
			this.acks[e] = t;
			return;
		}
		let r = this.io.setTimeoutFn(() => {
			delete this.acks[e];
			for (let t = 0; t < this.sendBuffer.length; t++) this.sendBuffer[t].id === e && this.sendBuffer.splice(t, 1);
			t.call(this, /* @__PURE__ */ Error("operation has timed out"));
		}, n);
		this.acks[e] = (...e) => {
			this.io.clearTimeoutFn(r), t.apply(this, [null, ...e]);
		};
	}
	emitWithAck(e, ...t) {
		let n = this.flags.timeout !== void 0 || this._opts.ackTimeout !== void 0;
		return new Promise((r, i) => {
			t.push((e, t) => n ? e ? i(e) : r(t) : r(e)), this.emit(e, ...t);
		});
	}
	_addToQueue(e) {
		let t;
		typeof e[e.length - 1] == "function" && (t = e.pop());
		let n = {
			id: this._queueSeq++,
			tryCount: 0,
			pending: !1,
			args: e,
			flags: Object.assign({ fromQueue: !0 }, this.flags)
		};
		e.push((e, ...r) => {
			if (n === this._queue[0]) return e === null ? (this._queue.shift(), t && t(null, ...r)) : n.tryCount > this._opts.retries && (this._queue.shift(), t && t(e)), n.pending = !1, this._drainQueue();
		}), this._queue.push(n), this._drainQueue();
	}
	_drainQueue(e = !1) {
		if (!this.connected || this._queue.length === 0) return;
		let t = this._queue[0];
		t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
	}
	packet(e) {
		e.nsp = this.nsp, this.io._packet(e);
	}
	onopen() {
		typeof this.auth == "function" ? this.auth((e) => {
			this._sendConnectPacket(e);
		}) : this._sendConnectPacket(this.auth);
	}
	_sendConnectPacket(e) {
		this.packet({
			type: $.CONNECT,
			data: this._pid ? Object.assign({
				pid: this._pid,
				offset: this._lastOffset
			}, e) : e
		});
	}
	onerror(e) {
		this.connected || this.emitReserved("connect_error", e);
	}
	onclose(e, t) {
		this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t);
	}
	onpacket(e) {
		if (e.nsp === this.nsp) switch (e.type) {
			case $.CONNECT:
				e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", /* @__PURE__ */ Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
				break;
			case $.EVENT:
			case $.BINARY_EVENT:
				this.onevent(e);
				break;
			case $.ACK:
			case $.BINARY_ACK:
				this.onack(e);
				break;
			case $.DISCONNECT:
				this.ondisconnect();
				break;
			case $.CONNECT_ERROR:
				this.destroy();
				let t = Error(e.data.message);
				t.data = e.data.data, this.emitReserved("connect_error", t);
				break;
		}
	}
	onevent(e) {
		let t = e.data || [];
		e.id != null && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
	}
	emitEvent(e) {
		if (this._anyListeners && this._anyListeners.length) {
			let t = this._anyListeners.slice();
			for (let n of t) n.apply(this, e);
		}
		super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
	}
	ack(e) {
		let t = this, n = !1;
		return function(...r) {
			n || (n = !0, t.packet({
				type: $.ACK,
				id: e,
				data: r
			}));
		};
	}
	onack(e) {
		let t = this.acks[e.id];
		typeof t == "function" && (t.apply(this, e.data), delete this.acks[e.id]);
	}
	onconnect(e, t) {
		this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
	}
	emitBuffered() {
		this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
			this.notifyOutgoingListeners(e), this.packet(e);
		}), this.sendBuffer = [];
	}
	ondisconnect() {
		this.destroy(), this.onclose("io server disconnect");
	}
	destroy() {
		this.subs &&= (this.subs.forEach((e) => e()), void 0), this.io._destroy(this);
	}
	disconnect() {
		return this.connected && this.packet({ type: $.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
	}
	close() {
		return this.disconnect();
	}
	compress(e) {
		return this.flags.compress = e, this;
	}
	get volatile() {
		return this.flags.volatile = !0, this;
	}
	timeout(e) {
		return this.flags.timeout = e, this;
	}
	onAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
	}
	prependAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
	}
	offAny(e) {
		if (!this._anyListeners) return this;
		if (e) {
			let t = this._anyListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyListeners = [];
		return this;
	}
	listenersAny() {
		return this._anyListeners || [];
	}
	onAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
	}
	prependAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
	}
	offAnyOutgoing(e) {
		if (!this._anyOutgoingListeners) return this;
		if (e) {
			let t = this._anyOutgoingListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyOutgoingListeners = [];
		return this;
	}
	listenersAnyOutgoing() {
		return this._anyOutgoingListeners || [];
	}
	notifyOutgoingListeners(e) {
		if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
			let t = this._anyOutgoingListeners.slice();
			for (let n of t) n.apply(this, e.data);
		}
	}
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/contrib/backo2.js
function ux(e) {
	e ||= {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
ux.prototype.duration = function() {
	var e = this.ms * this.factor ** + this.attempts++;
	if (this.jitter) {
		var t = Math.random(), n = Math.floor(t * this.jitter * e);
		e = Math.floor(t * 10) & 1 ? e + n : e - n;
	}
	return Math.min(e, this.max) | 0;
}, ux.prototype.reset = function() {
	this.attempts = 0;
}, ux.prototype.setMin = function(e) {
	this.ms = e;
}, ux.prototype.setMax = function(e) {
	this.max = e;
}, ux.prototype.setJitter = function(e) {
	this.jitter = e;
};
//#endregion
//#region ../../../../common/temp/node_modules/.pnpm/socket.io-client@4.7.4_supports-color@8.1.1/node_modules/socket.io-client/build/esm/manager.js
var dx = class extends Zy {
	constructor(e, t) {
		super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (t = e, e = void 0), t ||= {}, t.path = t.path || "/socket.io", this.opts = t, rb(this, t), this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || Infinity), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(t.randomizationFactor ?? .5), this.backoff = new ux({
			min: this.reconnectionDelay(),
			max: this.reconnectionDelayMax(),
			jitter: this.randomizationFactor()
		}), this.timeout(t.timeout == null ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
		let n = t.parser || Xb;
		this.encoder = new n.Encoder(), this.decoder = new n.Decoder(), this._autoConnect = t.autoConnect !== !1, this._autoConnect && this.open();
	}
	reconnection(e) {
		return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
	}
	reconnectionAttempts(e) {
		return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
	}
	reconnectionDelay(e) {
		var t;
		return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (t = this.backoff) == null || t.setMin(e), this);
	}
	randomizationFactor(e) {
		var t;
		return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (t = this.backoff) == null || t.setJitter(e), this);
	}
	reconnectionDelayMax(e) {
		var t;
		return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (t = this.backoff) == null || t.setMax(e), this);
	}
	timeout(e) {
		return arguments.length ? (this._timeout = e, this) : this._timeout;
	}
	maybeReconnectOnOpen() {
		!this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
	}
	open(e) {
		if (~this._readyState.indexOf("open")) return this;
		this.engine = new Lb(this.uri, this.opts);
		let t = this.engine, n = this;
		this._readyState = "opening", this.skipReconnect = !1;
		let r = sx(t, "open", function() {
			n.onopen(), e && e();
		}), i = (t) => {
			this.cleanup(), this._readyState = "closed", this.emitReserved("error", t), e ? e(t) : this.maybeReconnectOnOpen();
		}, a = sx(t, "error", i);
		if (!1 !== this._timeout) {
			let e = this._timeout, n = this.setTimeoutFn(() => {
				r(), i(/* @__PURE__ */ Error("timeout")), t.close();
			}, e);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
		return this.subs.push(r), this.subs.push(a), this;
	}
	connect(e) {
		return this.open(e);
	}
	onopen() {
		this.cleanup(), this._readyState = "open", this.emitReserved("open");
		let e = this.engine;
		this.subs.push(sx(e, "ping", this.onping.bind(this)), sx(e, "data", this.ondata.bind(this)), sx(e, "error", this.onerror.bind(this)), sx(e, "close", this.onclose.bind(this)), sx(this.decoder, "decoded", this.ondecoded.bind(this)));
	}
	onping() {
		this.emitReserved("ping");
	}
	ondata(e) {
		try {
			this.decoder.add(e);
		} catch (e) {
			this.onclose("parse error", e);
		}
	}
	ondecoded(e) {
		Db(() => {
			this.emitReserved("packet", e);
		}, this.setTimeoutFn);
	}
	onerror(e) {
		this.emitReserved("error", e);
	}
	socket(e, t) {
		let n = this.nsps[e];
		return n ? this._autoConnect && !n.active && n.connect() : (n = new lx(this, e, t), this.nsps[e] = n), n;
	}
	_destroy(e) {
		let t = Object.keys(this.nsps);
		for (let e of t) if (this.nsps[e].active) return;
		this._close();
	}
	_packet(e) {
		let t = this.encoder.encode(e);
		for (let n = 0; n < t.length; n++) this.engine.write(t[n], e.options);
	}
	cleanup() {
		this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
	}
	_close() {
		this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
	}
	disconnect() {
		return this._close();
	}
	onclose(e, t) {
		this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
	}
	reconnect() {
		if (this._reconnecting || this.skipReconnect) return this;
		let e = this;
		if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
		else {
			let t = this.backoff.duration();
			this._reconnecting = !0;
			let n = this.setTimeoutFn(() => {
				e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((t) => {
					t ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", t)) : e.onreconnect();
				}));
			}, t);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
	}
	onreconnect() {
		let e = this.backoff.attempts;
		this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
	}
}, fx = {};
function px(e, t) {
	typeof e == "object" && (t = e, e = void 0), t ||= {};
	let n = Rb(e, t.path || "/socket.io"), r = n.source, i = n.id, a = n.path, o = fx[i] && a in fx[i].nsps, s = t.forceNew || t["force new connection"] || !1 === t.multiplex || o, c;
	return s ? c = new dx(r, t) : (fx[i] || (fx[i] = new dx(r, t)), c = fx[i]), n.query && !t.query && (t.query = n.queryKey), c.socket(n.path, t);
}
Object.assign(px, {
	Manager: dx,
	Socket: lx,
	io: px,
	connect: px
});
//#endregion
//#region src/composables/useWebsockets.ts
var mx = M(!1), hx = {
	io: {},
	connected: mx
}, gx = (e) => {
	e.on("reconnect_error", (e) => {
		console.warn("[socket] reconnect_error", { errMessage: e instanceof Error ? e.message : String(e) });
	}), e.on("reconnect_failed", () => {
		console.warn("[socket] reconnect_failed");
	});
}, _x = async (e, t, n = !0) => (hx.io = new dx(e, t), gx(hx.io), new Promise((e, t) => {
	hx.io.once("open", () => e(void 0)), n && hx.io.once("error", t), hx.io.on("open", () => {
		mx.value = !0;
	}), hx.io.on("close", () => {
		mx.value = !1;
	});
})), vx = () => hx.io, yx = () => hx.connected, bx = (e) => "statusCode" in e && e.statusCode >= 400, xx = (e) => "code" in e && e.code < 400, Sx = async (e, t) => (await cc().get(`/cms/${e}`, { params: t })).data, Cx = Be({
	modules: /* @__PURE__ */ new Set(),
	addModule(e) {
		if (e.contentBlocks) for (let t of e.contentBlocks) t.component = ke(t.component);
		this.modules.add(e);
	},
	getModules() {
		return Array.from(this.modules);
	}
}), wx = () => Cx, Tx = Be({
	refs: /* @__PURE__ */ new Set(),
	onMount(e) {
		this.refs.add(e);
	},
	onUnmount(e) {
		this.refs.delete(e);
	},
	words: C(() => Array.from(Tx.refs).reduce((e, t) => e + (t.value.wordCharCount?.words || 0), 0)),
	characters: C(() => Array.from(Tx.refs).reduce((e, t) => e + (t.value.wordCharCount?.characters || 0), 0))
}), Ex = () => Tx, Dx = (e) => typeof e != "object" || !e ? !1 : typeof Reflect.get(e, "getValidationErrorAnchor") == "function", Ox = (e, t) => {
	let n = GLOBAL_CONFIG.APP_ENV === "sandbox" || GLOBAL_CONFIG.APP_ENV === "sandboxes", r = t?.toUpperCase() === "PUBLISH" && !n ? "_PUBLISH" : "", i = `URL_${e.toUpperCase()}${r}`;
	if (!((e) => e in GLOBAL_CONFIG)(i)) throw Error(`Base URL for brand "${e}" (key: ${i}) is not defined in GLOBAL_CONFIG.`);
	return GLOBAL_CONFIG[i];
}, kx = "00000000-0000-0000-0000-000000000000", Ax = 300, jx = nl(), Mx = (e) => jx.hasRight(e), Nx = {
	api_user: "api-users",
	article: "articles",
	articles_box: "articles-boxes",
	author: "authors",
	channel: "channels",
	channelizer: "channelizers",
	complex_module: "complex-modules",
	complex_page: "complex-pages",
	cta_button: "cta-buttons",
	gallery: "galleries",
	hub_pages: "hub-pages",
	image: "images",
	job: "jobs",
	linkout_teaser: "linkout-teasers",
	links_box: "links-boxes",
	newsletter: "newsletters",
	redirect_management: "redirect-management",
	static_page: "static-pages",
	video_page: "video-pages"
}, Px = (e, t) => t === "author_merge" ? "authors:merge" : `${Nx[t]}:${e}`, Fx = (e, t, n) => {
	let r = Px(e, t);
	return n && n.legacy && e === "edit" ? n.legacy.isEditableInCTF && Mx(r) : Mx(r);
}, Ix = (e, t) => Fx("edit", e, t), Lx = (e, t) => Fx("navigate", e, t), Rx = window.safari !== void 0, zx = [
	"http://",
	"https://",
	"mailto:"
], Bx = (e) => {
	if (!e) return "";
	let t = e;
	return t = e.trim(), zx.some((e) => t.toLowerCase().startsWith(e)) ? t : (t.includes(":"), "https://" + t);
}, Vx = (e, t = !1) => {
	switch (e) {
		case typeof e == "boolean": return e;
		case "true": return !0;
		case "false": return !1;
	}
	return t;
}, Hx = ol("bunte.svg"), Ux = ol("chip.svg"), Wx = ol("focus.svg");
ac(rl);
var Gx = Te({
	loader: () => import("./json-diff.view-DGvI4Zuh.js"),
	loadingComponent: () => De("div", { class: "row items-center justify-center q-pa-lg" }, [De(ae, {
		color: "primary",
		size: "3em"
	})])
});
//#endregion
export { Xl as AI_FIELD_ACTIONS, Vc as AUTHENTIK_OAUTH_STATE_PREFIX, ku as AiAssistButton, Tu as AiContextResolverInjectionKey, Su as AiEngineInjectionKey, hc as BCheckbox, Wu as BfBrandBasedState, Uu as BfBrandIcon, Gu as BfEntityNoEditIcon, Ku as BfEntityStateIcon, qu as BfEntityStateSelector, td as BfLimitedTextInput, id as BfLogoIcon, ad as BfScheduledChangeIcon, Td as BrandDropdownSelector, Hx as BunteLogo, zd as CMSDialog, ao as CMSNotification, Od as CardItem, kd as CardList, Ux as ChipLogo, Ad as CmsSelector, Ha as DEFAULT_SHRUNK_SIDEBAR_NAV_WIDTH, Va as DEFAULT_SIDEBAR_NAV_WIDTH, Id as DatetimeSelector, jd as DayRangeSelector, Tc as EmailForm, Tc as ModalReload, hf as EntityListSearchDefaultProps, Wx as FocusLogo, gf as HistoryModelName, _f as HistoryService, jf as HistoryTab, Ld as ItemCountField, Gx as JsonDiffView, bc as LanguageSelector, Rd as LegacySelector, tf as ListPagination, kx as PLACEHOLDER_UUID, z as ROUTES, Ax as SEARCH_DEBOUNCE, Kc as SSO_CODE_IN_FLIGHT_AT_KEY, Gc as SSO_CODE_IN_FLIGHT_KEY, Wc as SSO_OAUTH_STATE_STORAGE_KEY, Hc as SSO_PROVIDER_STORAGE_KEY, Uc as SSO_REDIRECT_URI_STORAGE_KEY, $d as ScheduleChangeInfoBanner, Mf as TagInput, Nf as TagSelector, Pf as ToggleButton, jc as UserService, El as VuetifyValidationRules, Xc as authenticate, Ia as browserLang, Bu as buildConstraints, Nu as buildFieldAssistSystemPrompt, zu as collectAiHints, Yl as computeRichDiff, Rl as computeWordDiff, _x as connectSockets, Vx as convertToBool, Lu as createAiFieldEngine, qc as createAuthentikOAuthState, Za as createVueI18n, Rs as dateRegex, fc as deleteEntity, Js as deserializeDatesInObject, wf as extendTableColumnsWithDisabledStyle, Bc as fetchRightsMeta, zs as formatDate, Bs as formatDateDots, Ws as formatDateTimeSeconds, Vs as formatDateddMMyy, Hs as formatDateddMMyyyy, Ys as formatDuration, Us as formatTime, Ox as getBaseUrlForBrand, cc as getClient, Lc as getCurrentUser, lc as getEntity, sc as getEntityAPIClient, B as getI18n, yf as getLastHistoryEntry, Xa as getQuasarLocale, Fc as getUser, Ic as getUsers, Pl as htmlToPlainText, Du as injectAiContextResolver, wu as injectAiEngine, Mx as isAllowed, bx as isApiError, xx as isApiResponse, Jc as isAuthentikOAuthState, Ix as isDocumentEditable, Lx as isDocumentVisitable, Rx as isSafari, pc as listEntities, Zc as logout, St as n, qs as omitDateTimeSeconds, Gl as parseMarkedTokens, uc as postEntity, Eu as provideAiContextResolver, Cu as provideAiEngine, Dx as providesValidationErrorAnchor, dc as putEntity, Ja as quasarLocales, Sf as quasarRulesStub, Cf as quasarValidateRules, mc as registerEntityEndpoint, ac as registerErrorInterceptor, bf as registerQuasar, Ks as resetDateTimeUnits, Sx as restSearch, jl as sanitizeHtml, Bx as sanitizeLink, sl as sanitizePathUrl, Gs as serializeDates, zc as setAdditionalRights, kc as setDefaultRouter, yt as t, Rc as updateUser, Ou as useAiAssist, Vu as useAiFieldDescriptor, Ff as useCardDragSort, oy as useChangesWatch, dy as useConfirmChangesDialog, Ac as useDefaultRouter, fy as useDetectOutsideClick, Gd as useDialogStore, yy as useEntityInfiniteSearchList, my as useEntityQuery, pf as useEntitySearchList, mf as useEntitySearchListWithCompanions, hy as useGermanQuoteTransform, Wa as useGlobalStore, wx as useModuleStore, so as useNotificationStore, xy as usePublishStates, Cy as usePublishableForm, yx as useSocketConnected, vx as useSockets, wy as useTitle, nl as useUserStore, Ex as useWordCountStore, $u as vGermanQuotes, Yc as validateStoredAuthentikOAuthState, J as withAiHint };

//# sourceMappingURL=index.es.js.map